<template>
  <div class="dashboard-container" :class="{ 'device-mobile': isMobileDevice, 'device-pc': !isMobileDevice }">
    <!-- 移动端固定顶部欢迎标题栏 -->
    <div class="mobile-welcome-header">
      <div class="mobile-welcome-scroll-container">
        <div class="mobile-welcome-scroll-content" ref="scrollText">
          欢迎尊贵的 <span class="crown-text"><span class="crown-emoji">👑</span>{{ username }}</span> 来到 OIer 之路
        </div>
      </div>
    </div>

    <!-- 欢迎卡片 -->
    <el-card class="welcome-card">
      <div class="welcome-content">
        <!-- 左侧欢迎区域 -->
        <div class="welcome-message">
          <h2>
            <span>欢迎尊贵的</span>
            <span class="crown-username">
              <span class="crown-emoji">👑</span>
              {{ username }}
            </span>
            <span>来到 OIer 之路</span>
          </h2>
        </div>
        <!-- 右侧打卡区域 -->
        <div class="fortune-section">
          <template v-if="!todayCheckedIn">
            <el-button 
              type="primary" 
              size="large" 
              class="check-in-btn"
              @click="handleCheckIn"
              :loading="checkingIn">
              <i class="el-icon-magic-stick"></i> 打卡
            </el-button>
          </template>
          <template v-else>
            <div class="fortune-content">
              <div class="fortune-level" :class="fortuneColorClass">
                §{{ todayFortune?.level || '未知' }}§
              </div>
              <div class="fortune-details">
                <div class="fortune-row">
                  <div class="fortune-item">
                    <span class="fortune-label good">宜</span>
                    <div class="fortune-text">
                      <div class="fortune-value">{{ todayFortune?.good || '未知' }}</div>
                      <div class="fortune-comment">{{ todayFortune?.goodComment || generateComment(todayFortune?.good) }}</div>
                    </div>
                  </div>
                  <div class="fortune-item">
                    <div class="fortune-text">
                      <div class="fortune-value">{{ todayFortune?.bad || '未知' }}</div>
                      <div class="fortune-comment">{{ todayFortune?.badComment || generateComment(todayFortune?.bad) }}</div>
                    </div>
                    <span class="fortune-label bad">忌</span>
                  </div>
                </div>
              </div>
              <div class="check-in-days">
                <span class="text">您已在此持续打卡</span>
                <span class="number">{{ checkInDays }}</span>
                <span class="text">天，好棒哦！</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-card>

    <!-- 导航卡片 -->
    <div class="nav-section">
      <!-- 更新&复盘待办 - 占用第一列跨三行 -->
      <div class="update-review-todo-in-nav">
        <!-- 更新&复盘待办标题 -->
        <div class="section-header update-review-todo-title-in-nav">
          <h2 class="section-title">更新&复盘待办</h2>
          <div class="update-review-todo-header-right">
            <span class="update-review-todo-count">{{ updateReviewTodoList.length }}项</span>
            <span class="todo-count-tag status-ontime" v-if="updateReviewTodoNormalCount > 0">{{ updateReviewTodoNormalCount }}</span>
            <span class="todo-count-tag status-delay" v-if="updateReviewTodoDelayCount > 0">{{ updateReviewTodoDelayCount }}</span>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-full-screen" 
              class="expand-btn"
              @click="openExpandDialog(1)"
              title="放大查看">
            </el-button>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-view" 
              class="view-skip-btn"
              @click="openViewSkipDialog(1)"
              title="查看已跳过">
            </el-button>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-setting" 
              class="config-btn"
              @click="showUpdateReviewTodoConfig = true">
            </el-button>
          </div>
        </div>
        
        <!-- 更新&复盘待办内容 -->
        <div class="update-review-todo-section-in-nav">
          <el-card class="update-review-todo-card" shadow="hover" v-loading="updateReviewTodoLoading">
            <div class="update-review-todo-content" v-if="updateReviewTodoList.length > 0">
              <div 
                v-for="(item, index) in updateReviewTodoList" 
                :key="index" 
                class="update-review-todo-item"
                :class="{ 'delay-item': item.is_dealy === 'Dealy' }">
                <div class="todo-item-content">
                  <!-- 第一行：标志(G/P) + 名称 + note标签（靠右） -->
                  <div class="todo-row-first">
                    <!-- 标志（赛事:G，题目:P） -->
                    <div class="todo-type-badge" :class="item.type === 'game' ? 'badge-game' : 'badge-question'">
                      {{ item.type === 'game' ? 'G' : 'P' }}
                    </div>
                    
                    <!-- 名称和图标容器 -->
                    <div class="todo-name-with-icon">
                      <div class="todo-name">{{ item.name }}</div>
                    <el-tooltip 
                      effect="dark" 
                      placement="top"
                      popper-class="fix-todo-tooltip">
                      <template slot="content">
                        <div v-html="getUpdateReviewTodoTooltipHtml(item)"></div>
                      </template>
                        <i 
                          class="el-icon-info todo-info-icon"
                          @click.stop="handleInfoIconClick(item, index, 'update-review')">
                        </i>
                    </el-tooltip>
                    </div>
                    
                    <!-- note 标签（靠右显示） -->
                    <div class="todo-note-tags" v-if="item.note && item.note.length">
                      <el-tag 
                        v-for="(n, i) in item.note" 
                        :key="i" 
                        size="mini"
                        :type="n === 'NOREP' ? 'danger' : (n === 'NOLEVEL' ? 'warning' : (n === 'NOERR' ? 'info' : 'default'))"
                        class="note-tag">
                        {{ getUpdateReviewTodoSingleNoteText(n) }}
                      </el-tag>
                    </div>
                  </div>
                  
                  <!-- 第二行：状态 + days_ago + 按钮（靠右） -->
                  <div class="todo-row-second">
                    <!-- 状态标签（最前面） -->
                    <div 
                      class="todo-status-tag"
                      :class="item.is_dealy === 'Dealy' ? 'status-delay' : 'status-ontime'">
                      {{ item.is_dealy === 'Dealy' ? '超时' : '正常' }}
                    </div>
                    
                    <!-- days_ago 文案（在状态后面，加粗放大并按状态上色） -->
                    <div class="todo-days" v-html="getUpdateReviewTodoDaysRichText(item)"></div>
                    
                    <!-- 操作按钮（靠右显示）：跳转 + 复盘/编辑 + skip -->
                    <div class="todo-actions">
                      <!-- 跳转按钮 -->
                      <el-button 
                        type="default" 
                        size="mini" 
                        icon="el-icon-position"
                        :disabled="!item.url"
                        @click.stop="handleGoToUrl(item.url)"
                        title="跳转"
                        class="action-btn">
                      </el-button>
                      <!-- 赛事类型：显示复盘按钮（弹窗） -->
                      <el-button 
                        v-if="item.type === 'game' && !isMobileDevice"
                        type="primary" 
                        size="mini" 
                        icon="el-icon-video-camera"
                        @click.stop="openReplayDialog(item)"
                        title="复盘"
                        class="action-btn replay-btn">
                      </el-button>
                      <!-- 题目类型：显示编辑按钮（弹窗） -->
                      <el-button 
                        v-else-if="!isMobileDevice"
                        type="primary" 
                        size="mini" 
                        icon="el-icon-edit"
                        @click.stop="openEditDialog(item)"
                        title="编辑"
                        class="action-btn edit-btn">
                      </el-button>
                      <!-- Skip按钮（连续点击5次info icon后显示） -->
                      <el-button 
                        v-if="showSkipButtons[`update-review-${index}`]"
                        type="warning" 
                        size="mini" 
                        @click.stop="openSkipDialog(item, index, 'update-review')"
                        title="跳过"
                        class="action-btn skip-btn">
                        skip
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-state-celebration">
              <div class="celebration-icon">🌟</div>
              <div class="celebration-title">完美！</div>
              <div class="celebration-message">你已完成所有的更新&复盘待办</div>
              <div class="celebration-subtitle">每一次复盘都是进步！✨</div>
            </div>
          </el-card>
        </div>
      </div>
      
      <!-- 更新&复盘待办配置对话框 -->
      <el-dialog
        title="更新&复盘待办配置"
        :visible.sync="showUpdateReviewTodoConfig"
        width="500px"
        :modal="true"
        :append-to-body="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        custom-class="update-review-todo-config-dialog"
        @close="handleUpdateReviewTodoConfigClose">
        <el-form :model="updateReviewTodoConfig" label-width="120px" ref="updateReviewTodoConfigForm">
          <el-form-item label="超时判断天数">
            <el-input-number 
              v-model="updateReviewTodoConfig.delayDays" 
              :min="1" 
              :max="365"
              style="width: 100%;">
            </el-input-number>
            <div class="config-tip">超过此天数未处理的待办将标记为"超时"</div>
          </el-form-item>
          <el-form-item label="统计起始时间">
            <el-date-picker
              v-model="updateReviewTodoConfig.startTime"
              type="datetime"
              placeholder="选择起始时间"
              format="yyyy/MM/dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              :append-to-body="true"
              popper-class="update-review-datepicker"
              style="width: 100%;">
            </el-date-picker>
            <div class="config-tip">只统计此时间之后的待办</div>
          </el-form-item>
          <el-form-item label="复盘得分率阈值">
            <el-input 
              v-model="scoreRateThresholdDisplay" 
              type="text"
              @blur="handleScoreRateThresholdBlur"
              style="width: 100%;"
              class="score-rate-threshold-input">
              <template slot="append">%</template>
            </el-input>
            <div class="config-tip">得分率小于此百分比的比赛需要复盘（例如：80% 表示四道题的模拟赛低于 320 分需要复盘）</div>
          </el-form-item>
          <el-form-item label="待办事宜">
            <el-checkbox-group v-model="updateReviewTodoConfig.todoTypes" @change="handleTodoTypesChange">
              <el-checkbox 
                label="NOREP"
                style="display: block; margin-bottom: 8px;">
                赛事复盘
              </el-checkbox>
              <el-checkbox 
                label="NOTAG"
                style="display: block; margin-bottom: 8px;">
                题目标签
              </el-checkbox>
              <el-checkbox 
                label="NOLEVEL"
                style="display: block; margin-bottom: 8px;">
                题目难度
              </el-checkbox>
              <el-checkbox 
                label="NOERR"
                style="display: block; margin-bottom: 8px;">
                错误类型
              </el-checkbox>
            </el-checkbox-group>
            <div class="config-tip">只显示选中类型的待办</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showUpdateReviewTodoConfig = false">取消</el-button>
          <el-button type="primary" @click="saveUpdateReviewTodoConfig">确定</el-button>
        </div>
      </el-dialog>
      
      <!-- 更新&复盘待办：编辑对话框（题目） -->
      <div class="vertical-center-dialog">
        <question-dialog
          v-if="updateReviewEditVisible && updateReviewCurrentQuestion"
          :visible.sync="updateReviewEditVisible"
          :question="updateReviewCurrentQuestion"
          :is-edit="true"
          :game-code="updateReviewCurrentQuestion.game_code || ''"
          @success="fetchUpdateReviewTodoList"
          @cancel="updateReviewEditVisible = false">
        </question-dialog>
      </div>
      
      <!-- 更新&复盘待办：复盘对话框（赛事） -->
      <game-replay
        v-if="updateReviewCurrentGame"
        :visible.sync="updateReviewReplayVisible"
        :game-info="updateReviewCurrentGame"
        @success="fetchUpdateReviewTodoList"
      />
      
      <!-- 订正待办 - 占用第二列跨三行 -->
      <div class="fix-todo-in-nav">
        <!-- 订正待办标题 -->
        <div class="section-header fix-todo-title-in-nav">
          <h2 class="section-title">订正待办</h2>
          <div class="fix-todo-header-right">
            <span class="fix-todo-count">{{ fixTodoList.length }}题</span>
            <span class="todo-count-tag status-ontime" v-if="fixTodoNormalCount > 0">{{ fixTodoNormalCount }}</span>
            <span class="todo-count-tag status-delay" v-if="fixTodoDelayCount > 0">{{ fixTodoDelayCount }}</span>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-full-screen" 
              class="expand-btn"
              @click="openExpandDialog(2)"
              title="放大查看">
            </el-button>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-view" 
              class="view-skip-btn"
              @click="openViewSkipDialog(2)"
              title="查看已跳过">
            </el-button>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-setting" 
              class="config-btn"
              @click="showFixTodoConfig = true">
            </el-button>
          </div>
        </div>
        
        <!-- 订正待办内容 -->
        <div class="fix-todo-section-in-nav">
          <el-card class="fix-todo-card" shadow="hover" v-loading="fixTodoLoading">
            <div class="fix-todo-content" v-if="fixTodoList.length > 0">
              <div 
                v-for="(item, index) in fixTodoList" 
                :key="index" 
                class="fix-todo-item"
                :class="{ 'delay-item': item.is_dealy === 'Dealy' }">
                <div class="todo-item-content">
                  <!-- 第一行：难度标签 + 题目名称 + 分数/订正分数 -->
                  <div class="todo-row-first">
                    <!-- 难度标签 -->
                      <div 
                        class="todo-level-tag"
                        :style="{ 
                          backgroundColor: getDifficultyColor(item.question_level || ''),
                          borderColor: getDifficultyColor(item.question_level || '')
                        }">
                        {{ item.question_level || '未定义' }}
                      </div>
                    
                    <!-- 题目名称和图标容器 -->
                    <div class="todo-question-name-with-icon">
                      <div class="todo-question-name">{{ item.question_name }}</div>
                    <el-tooltip 
                      effect="dark" 
                      placement="top"
                      popper-class="fix-todo-tooltip">
                      <template slot="content">
                        <div v-html="getFixTodoTooltipHtml(item)"></div>
                      </template>
                        <i 
                          class="el-icon-info todo-info-icon"
                          @click.stop="handleInfoIconClick(item, index, 'fix')">
                        </i>
                    </el-tooltip>
                    </div>
                    
                    <!-- 分数显示 -->
                    <div class="todo-score">
                      <span 
                        class="score-original"
                        :style="{ color: getScoreColor(item.question_score) }">
                        {{ item.question_score }}
                      </span>
                      <span class="score-separator">/</span>
                      <span 
                        class="score-fix"
                        :style="{ color: getScoreColor(item.question_score_fix) }">
                        {{ item.question_score_fix }}
                      </span>
                    </div>
                    </div>
                    
                  <!-- 第二行：状态 + days_ago + 操作按钮（靠右） -->
                  <div class="todo-row-second">
                    <!-- 状态标签 -->
                    <div 
                      class="todo-status-tag"
                      :class="item.is_dealy === 'Dealy' ? 'status-delay' : 'status-ontime'">
                      {{ item.is_dealy === 'Dealy' ? '超时' : '正常' }}
                    </div>
                    <!-- days_ago 文案（加粗放大并按状态上色） -->
                    <div class="todo-days" v-html="getFixDaysRichText(item)"></div>
                    <!-- 操作按钮靠右 -->
                    <div class="todo-actions">
                      <el-button 
                        type="default" 
                        size="mini" 
                        icon="el-icon-position"
                        :disabled="!item.question_url"
                        @click.stop="handleGoToQuestionUrl(item.question_url)"
                        title="跳转到题目"
                        class="action-btn">
                      </el-button>
                      <el-button 
                        type="success" 
                        size="mini" 
                        icon="el-icon-check"
                        @click.stop="handleFixTodo(item)"
                        title="标记为已订正"
                        class="action-btn">
                      </el-button>
                      <el-button 
                        type="primary" 
                            size="mini"
                        icon="el-icon-video-pause"
                        @click.stop="handleFixPending(item)"
                        :disabled="item.question_score === 100 || item.question_score_fix === 100"
                        title="挂起"
                        class="action-btn">
                      </el-button>
                      <!-- Skip按钮（连续点击5次info icon后显示） -->
                      <el-button 
                        v-if="showSkipButtons[`fix-${index}`]"
                        type="warning" 
                        size="mini" 
                        @click.stop="openSkipDialog(item, index, 'fix')"
                        title="跳过"
                        class="action-btn skip-btn">
                        skip
                      </el-button>
                        </div>
                  </div>
                </div>
              </div>
        </div>
            <div v-else class="empty-state-celebration">
              <div class="celebration-icon">🎉</div>
              <div class="celebration-title">太棒了！</div>
              <div class="celebration-message">你已经完成了所有订正待办</div>
              <div class="celebration-subtitle">继续保持，加油！💪</div>
            </div>
      </el-card>
          </div>
        </div>
      
      <!-- 订正待办配置对话框 -->
      <el-dialog
        title="订正待办配置"
        :visible.sync="showFixTodoConfig"
        width="500px"
        :modal="true"
        :append-to-body="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        custom-class="fix-todo-config-dialog"
        @close="handleFixTodoConfigClose">
        <el-form :model="fixTodoConfig" label-width="120px" ref="fixTodoConfigForm">
          <el-form-item label="超时判断天数">
            <el-input-number 
              v-model="fixTodoConfig.delayDays" 
              :min="1" 
              :max="365"
              style="width: 100%;">
            </el-input-number>
            <div class="config-tip">超过此天数未订正的题目将标记为"超时"</div>
          </el-form-item>
          <el-form-item label="统计起始时间">
            <el-date-picker
              v-model="fixTodoConfig.startTime"
              type="datetime"
              placeholder="选择起始时间"
              format="yyyy/MM/dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              style="width: 100%;">
            </el-date-picker>
            <div class="config-tip">只统计此时间之后的题目</div>
          </el-form-item>
          <el-form-item label="题目难度">
            <el-checkbox-group v-model="fixTodoConfig.questionLevels" @change="handleQuestionLevelsChange">
              <el-checkbox 
                v-for="option in questionLevelOptions" 
                :key="option.value" 
                :label="option.value"
                style="display: block; margin-bottom: 8px;">
                {{ option.label }}
              </el-checkbox>
            </el-checkbox-group>
            <div class="config-tip">只显示选中难度的题目</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showFixTodoConfig = false">取消</el-button>
          <el-button type="primary" @click="saveFixTodoConfig">确定</el-button>
        </div>
      </el-dialog>
      
      <!-- 计划待办 - 占用第三列跨三行 -->
      <div class="task-todo-in-nav">
        <!-- 计划待办标题 -->
        <div class="section-header task-todo-title-in-nav">
          <h2 class="section-title">计划待办</h2>
          <div class="task-todo-header-right">
          <span class="task-todo-count">{{ taskTodoList.length }}项</span>
            <span class="todo-count-tag status-ontime" v-if="taskTodoNormalCount > 0">{{ taskTodoNormalCount }}</span>
            <span class="todo-count-tag status-delay" v-if="taskTodoDelayCount > 0">{{ taskTodoDelayCount }}</span>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-full-screen" 
              class="expand-btn"
              @click="openExpandDialog(3)"
              title="放大查看">
            </el-button>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-view" 
              class="view-skip-btn"
              @click="openViewSkipDialog(3)"
              title="查看已跳过">
            </el-button>
            <span class="header-separator">｜</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-setting" 
              class="config-btn"
              @click="showTaskTodoConfig = true">
            </el-button>
          </div>
          </div>
        
        <!-- 计划待办内容 -->
        <div class="task-todo-section-in-nav">
          <el-card class="task-todo-card" shadow="hover" v-loading="taskTodoLoading">
            <div class="task-todo-content" v-if="taskTodoList.length > 0">
              <div 
                v-for="(item, index) in taskTodoList" 
                :key="index" 
                class="task-todo-item"
                :class="getTaskItemClass(item)">
                <div class="task-item-content">
                  <!-- 第一行：状态标签 + 计划名称 -->
                  <div class="task-row-first">
                    <!-- 状态标签 -->
                      <div 
                        class="task-status-tag"
                        :class="getTaskStatusClass(item.plan_status_value)">
                        {{ item.plan_status }}
                      </div>
                    
                    <!-- 计划名称和图标容器 -->
                    <div class="task-plan-name-with-icon">
                      <div 
                        class="task-plan-name" 
                        @click="showPlanInfo(item)"
                        title="点击查看计划详情">
                        {{ item.plan_name }}
                      </div>
                      <el-tooltip 
                        effect="dark" 
                        placement="top"
                        popper-class="fix-todo-tooltip">
                        <template slot="content">
                          <div v-html="getTaskTodoTooltipHtml(item)"></div>
                        </template>
                        <i 
                          class="el-icon-info todo-info-icon"
                          @click.stop="handleInfoIconClick(item, index, 'task')">
                        </i>
                      </el-tooltip>
                    </div>
                  </div>
                  
                  <!-- 第二行：天数 + 时间状态 + 操作按钮 -->
                  <div class="task-row-second">
                      <div 
                        class="task-time-status"
                        :class="getTimeStatusClass(item.plan_status_info)">
                        {{ getTimeStatusText(item.plan_status_info) }}
                      </div>
                    <div v-if="item.days_ago !== null" class="task-days-wrapper">
                      <div class="task-days" v-html="getTaskDaysRichText(item)"></div>
                    </div>
                    <div class="task-actions" v-if="!isMobileDevice">
                      <!-- 编辑按钮（所有状态都显示） -->
                      <el-button 
                        type="default" 
                        size="mini" 
                        icon="el-icon-edit"
                        @click.stop="handleTaskEdit(item)"
                        title="编辑"
                        class="task-action-btn task-edit-btn">
                      </el-button>
                      
                      <!-- 未开始状态：显示开始按钮 -->
                      <template v-if="item.plan_status_value === 0">
                        <el-button 
                          type="success" 
                          size="mini" 
                          icon="el-icon-video-play"
                          @click.stop="handleTaskStart(item)"
                          title="开始"
                          class="task-action-btn task-start-btn">
                        </el-button>
                      </template>
                      
                      <!-- 进行中状态：显示暂停、完成、终止按钮 -->
                      <template v-if="item.plan_status_value === 1">
                        <el-button 
                          type="warning" 
                          size="mini" 
                          icon="el-icon-video-pause"
                          @click.stop="handleTaskPause(item)"
                          title="暂停"
                          class="task-action-btn task-pause-btn">
                        </el-button>
                        <el-button 
                          type="success" 
                          size="mini" 
                          icon="el-icon-check"
                          @click.stop="handleTaskComplete(item)"
                          title="完成"
                          class="task-action-btn task-complete-btn">
                        </el-button>
                        <el-button 
                          type="danger" 
                          size="mini" 
                          icon="el-icon-circle-close"
                          @click.stop="handleTaskTerminate(item)"
                          title="终止"
                          class="task-action-btn task-terminate-btn">
                        </el-button>
                      </template>
                      <!-- Skip按钮（连续点击5次info icon后显示） -->
                      <el-button 
                        v-if="showSkipButtons[`task-${index}`]"
                        type="warning" 
                        size="mini" 
                        @click.stop="openSkipDialog(item, index, 'task')"
                        title="跳过"
                        class="task-action-btn skip-btn">
                        skip
                      </el-button>
                    </div>
                    <!-- 移动端：折叠为“...”按钮 -->
                    <div class="task-actions-mobile" v-else>
                      <el-button
                        type="default"
                        size="mini"
                        icon="el-icon-more"
                        class="task-action-btn"
                        @click.stop="toggleTaskActions(index)"
                        title="更多">
                      </el-button>
                      <div 
                        class="task-actions-panel" 
                        v-if="taskTodoActionsOpenIndex === index"
                        @click.stop>
                        <el-button 
                          type="default" 
                          size="mini" 
                          icon="el-icon-edit"
                          @click.stop="handleTaskEdit(item); toggleTaskActions(null)"
                          class="task-action-btn task-edit-btn">
                        </el-button>
                        <template v-if="item.plan_status_value === 0">
                          <el-button 
                            type="success" 
                            size="mini" 
                            icon="el-icon-video-play"
                            @click.stop="handleTaskStart(item); toggleTaskActions(null)"
                            class="task-action-btn task-start-btn">
                          </el-button>
                        </template>
                        <template v-if="item.plan_status_value === 1">
                          <el-button 
                            type="warning" 
                            size="mini" 
                            icon="el-icon-video-pause"
                            @click.stop="handleTaskPause(item); toggleTaskActions(null)"
                            class="task-action-btn task-pause-btn">
                          </el-button>
                          <el-button 
                            type="success" 
                            size="mini" 
                            icon="el-icon-check"
                            @click.stop="handleTaskComplete(item); toggleTaskActions(null)"
                            class="task-action-btn task-complete-btn">
                          </el-button>
                          <el-button 
                            type="danger" 
                            size="mini" 
                            icon="el-icon-circle-close"
                            @click.stop="handleTaskTerminate(item); toggleTaskActions(null)"
                            class="task-action-btn task-terminate-btn">
                          </el-button>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-state-celebration">
              <div class="celebration-icon">✨</div>
              <div class="celebration-title">恭喜恭喜！</div>
              <div class="celebration-message">你已经完成了所有计划待办</div>
              <div class="celebration-subtitle">你真厉害！🌟</div>
            </div>
      </el-card>
        </div>
      </div>
      
      <!-- 计划内容对话框 -->
      <plan-info-dialog
        :visible.sync="showPlanInfoDialog"
        :plan-info="currentPlanInfo">
      </plan-info-dialog>
      
      <!-- 计划待办配置对话框 -->
      <el-dialog
        title="计划待办配置"
        :visible.sync="showTaskTodoConfig"
        width="500px"
        :modal="true"
        :append-to-body="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        custom-class="task-todo-config-dialog"
        @close="handleTaskTodoConfigClose">
        <el-form :model="taskTodoConfig" label-width="120px" ref="taskTodoConfigForm">
          <el-form-item label="未开始提醒天数">
            <el-input-number 
              v-model="taskTodoConfig.startLeadDays" 
              :min="0" 
              :max="365"
              style="width: 100%;">
            </el-input-number>
            <div class="config-tip">仅当计划预计开始时间 ≤ 此天数（含今天）才显示在待办</div>
          </el-form-item>
          <el-form-item label="计划开始时间">
            <el-radio-group v-model="taskTodoConfig.allowEmptyStart">
              <el-radio :label="true">允许为空</el-radio>
              <el-radio :label="false">不允许为空</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showTaskTodoConfig = false">取消</el-button>
          <el-button type="primary" @click="saveTaskTodoConfig">确定</el-button>
        </div>
      </el-dialog>
      
      <!-- 计划待办编辑对话框 -->
      <plan-dialog
        :visible.sync="taskEditDialogVisible"
        :plan="currentTaskPlan"
        :is-edit="!!currentTaskPlan"
        @success="handleTaskEditSuccess">
      </plan-dialog>
      
    </div>

    <!-- 底部区域（包含标题和内容） -->
    <div class="bottom-container">
      <!-- 友情链接标题 -->
      <div class="section-header links-title">
        <h2 class="section-title">友情链接</h2>
      </div>

        <!-- 每日X订标题 -->
      <div class="section-header daily-title-in-bottom">
          <h2 class="section-title">每日 X 订</h2>
        </div>

      <!-- 大事记标题 -->
      <div class="section-header great-events-title">
        <h2 class="section-title">大事记</h2>
      </div>

      <!-- 友情链接内容 -->
      <div class="links-section">
        <el-card v-for="(link, index) in friendLinks" 
                :key="link.id" 
                shadow="hover" 
                class="link-card">
          <el-tooltip effect="dark" placement="top">
            <template slot="content">
              <div>{{ link.description || '暂无描述' }}</div>
            </template>
            <a :href="link.link_url" target="_blank" class="link-content">
              <div class="link-name" v-html="formatLinkName(link.link_name)"></div>
            </a>
          </el-tooltip>
        </el-card>
      </div>
        
        <!-- 每日X订内容 -->
      <div class="daily-fix-section-in-bottom">
        <el-card v-if="randomQuestion" class="daily-fix-card-bottom" shadow="hover">
            <div class="question-info">
              <div class="question-header">
                <h3 class="question-name">{{ randomQuestion.question_name }}</h3>
                <div class="score-tag" 
                     :style="{ backgroundColor: getScoreColor(randomQuestion.question_score_fix) }">
                  {{ randomQuestion.question_score_fix }}
                </div>
                <div class="difficulty-tag"
                     :style="{ backgroundColor: getDifficultyColor(randomQuestion.question_level || '未定义') }">
                  {{ randomQuestion.question_level || '未定义' }}
                </div>
              </div>
              <div class="game-name">
                <i class="el-icon-trophy"></i>
                <a :href="randomQuestion.game_url" target="_blank" class="game-name-link">{{ randomQuestion.game_name }}</a>
              </div>
              <div class="game-time">
                <i class="el-icon-date"></i>
                {{ formatGameTime(randomQuestion.game_time) }}
              </div>
              <!-- 错误类型（存在时显示），放在标签上一行 -->
              <div v-if="randomQuestion && normalizeErrors(randomQuestion.errors).length > 0" class="error-types">
                <span class="error-tags">
                  <el-tag
                    v-for="err in normalizeErrors(randomQuestion.errors)"
                    :key="(err.error_code || err.error_name || err) + '-err'"
                    :style="getErrorOutlineStyle(err.error_code || err.error_name || err)"
                    size="small"
                    style="margin: 2px 6px 2px 0; height: 24px; line-height: 22px;">
                    <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ err.error_name || err }}
                  </el-tag>
                </span>
              </div>
              <div class="question-tags">
                <el-tag
                  v-for="tagName in randomQuestion.tags"
                  :key="tagName"
                  :style="{ 
                    backgroundColor: getTagColorByName(tagName),
                    borderColor: getTagColorByName(tagName),
                    color: 'white'
                  }"
                  size="small">
                  {{ tagName }}
                </el-tag>
              </div>
            </div>
            <div class="question-actions">
              <el-button 
                type="primary" 
                size="small" 
                @click="handleRefresh"
                icon="el-icon-refresh">
                换题
              </el-button>
              <el-button 
                type="success" 
                size="small" 
                :disabled="!randomQuestion.question_url"
                @click="handleGoToQuestion"
                icon="el-icon-position">
                出发
              </el-button>
              <el-button 
                type="warning" 
                size="small" 
                @click="handleFix"
                icon="el-icon-check">
                搞定
              </el-button>
            </div>
          </el-card>
          <el-empty v-else description="暂无未订正题目"></el-empty>
      </div>

      <!-- 大事记内容 -->
      <div class="great-events-section">
        <el-card class="great-events-card-bottom" shadow="hover">
          <div 
            class="events-container" 
            v-loading="eventsLoading"
            @mouseenter="pauseScrolling"
            @mouseleave="resumeScrolling">
            <div v-if="greatEvents.length > 0" class="events-list">
              <div v-for="(event, index) in greatEvents" :key="event.id" class="event-item">
                <div class="event-time">{{ formatEventTime(event.event_time) }}</div>
                <div class="event-content">
                  <span class="event-person">{{ event.person }}</span>
                  <span class="event-text">{{ event.event }}</span>
                </div>
              </div>
            </div>
            <el-empty v-else description="暂无大事记" :image-size="80"></el-empty>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="copyright-text pc-only">
      Copyright © 2024 OIer之路 All rights reserved.  |  闽ICP备2025095302号-1
    </div>
    <div class="copyright-text mobile-only">
      Copyright © 2024 OIer之路 All rights reserved.<br>闽ICP备2025095302号-1
    </div>
    
    <!-- Skip确认对话框 -->
    <el-dialog
      title="跳过待办"
      :visible.sync="showSkipDialog"
      width="500px"
      :modal="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      custom-class="skip-dialog">
      <div class="skip-dialog-content">
        <div class="skip-item-info">
          <div class="skip-item-label">待办内容：</div>
          <div class="skip-item-value">{{ skipDialogItem ? (skipDialogItem.name || skipDialogItem.question_name || skipDialogItem.plan_name) : '' }}</div>
        </div>
        <div class="skip-reason-section">
          <div class="skip-reason-label">跳过原因：<span style="color: #f56c6c;">*</span></div>
          <div class="skip-preset-reasons">
            <el-button
              v-for="(reason, index) in skipPresetReasons"
              :key="index"
              :type="skipReason === reason ? 'primary' : 'default'"
              size="small"
              @click="selectPresetReason(reason)">
              {{ reason }}
            </el-button>
          </div>
          <div class="skip-custom-reason">
            <el-input
              v-model="skipCustomReason"
              type="textarea"
              :rows="3"
              placeholder="或直接输入自定义原因（最多50字符）"
              maxlength="50"
              show-word-limit
              @input="skipReason = ''">
            </el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSkipDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmSkip" :disabled="!skipReason && !skipCustomReason">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- View Skip对话框 -->
    <el-dialog
      :title="`已跳过的${getTodoTypeText(viewSkipType)}待办`"
      :visible.sync="showViewSkipDialog"
      width="600px"
      :modal="true"
      :append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="view-skip-dialog">
      <div class="view-skip-content" v-loading="skipListLoading">
        <div v-if="!skipListLoading && skipList.length > 0" class="skip-list">
          <div 
            v-for="(item, index) in skipList" 
            :key="index" 
            class="skip-list-item">
            <!-- 第一行：类型/难度标签 + 名称（左侧），待办标签（右侧） -->
            <div class="skip-list-item-header-row">
              <div class="skip-list-item-header">
                <template v-if="viewSkipType === 1">
                  <!-- 更新&复盘：显示G/P标签 -->
                  <div 
                    v-if="item.skip_info && (item.skip_info.startsWith('G ') || item.skip_info.startsWith('P '))"
                    class="todo-type-badge"
                    :class="item.skip_info.startsWith('G ') ? 'badge-game' : 'badge-question'">
                    {{ item.skip_info.startsWith('G ') ? 'G' : 'P' }}
                  </div>
                  <!-- 名称 -->
                  <div class="skip-list-item-name">{{ getSkipItemName(item) }}</div>
                </template>
                <template v-else-if="viewSkipType === 2">
                  <!-- 订正：解析难度标签 -->
                  <el-tag 
                    v-if="item.skip_info && item.skip_info.startsWith('[')"
                    :style="{ 
                      backgroundColor: getDifficultyColor(item.skip_info.match(/\[([^\]]+)\]/)?.[1] || ''),
                      borderColor: getDifficultyColor(item.skip_info.match(/\[([^\]]+)\]/)?.[1] || ''),
                      color: 'white',
                      fontWeight: 'bold'
                    }"
                    size="small"
                    class="skip-level-tag">
                    {{ item.skip_info.match(/\[([^\]]+)\]/)?.[1] || '未定义' }}
                  </el-tag>
                  <!-- 题目名称 -->
                  <div class="skip-list-item-name">{{ getSkipItemQuestionName(item) }}</div>
                </template>
                <template v-else-if="viewSkipType === 3">
                  <!-- 计划待办：任务状态标签 -->
                  <div 
                    v-if="getSkipItemTaskStatus(item)"
                    class="task-status-tag"
                    :class="getTaskStatusClass(getSkipItemTaskStatus(item).statusValue)">
                    {{ getSkipItemTaskStatus(item).status }}
                  </div>
                  <div class="skip-list-item-name">{{ getSkipItemName(item) }}</div>
                </template>
                <template v-else>
                  <div class="skip-list-item-name">{{ getSkipItemName(item) }}</div>
                </template>
              </div>
              <!-- 待办标签（靠右显示）- 更新&复盘待办 -->
              <div class="skip-list-item-todo-tags" v-if="viewSkipType === 1 && getSkipItemTodoTags(item).length > 0">
                <el-tag 
                  v-for="(tag, tagIndex) in getSkipItemTodoTags(item)" 
                  :key="tagIndex" 
                  size="mini"
                  :type="tag === 'NOREP' ? 'danger' : (tag === 'NOLEVEL' ? 'warning' : (tag === 'NOERR' ? 'info' : 'default'))"
                  class="skip-todo-tag">
                  {{ getUpdateReviewTodoSingleNoteText(tag) }}
                </el-tag>
              </div>
              <!-- 分数显示（靠右显示）- 订正待办 -->
              <div class="skip-list-item-score" v-if="viewSkipType === 2 && getSkipItemScores(item)">
                <span 
                  class="score-original"
                  :style="{ color: getScoreColor(getSkipItemScores(item).score) }">
                  {{ getSkipItemScores(item).score }}
                </span>
                <span class="score-separator">/</span>
                <span 
                  class="score-fix"
                  :style="{ color: getScoreColor(getSkipItemScores(item).scoreFix) }">
                  {{ getSkipItemScores(item).scoreFix }}
                </span>
              </div>
            </div>
            <!-- 订正待办第二行：赛事名称 -->
            <div class="skip-list-item-game-name-row" v-if="viewSkipType === 2 && getSkipItemGameName(item)">
              <div class="skip-list-item-game-name">
                <span class="game-icon">🏆</span>
                {{ getSkipItemGameName(item) }}
              </div>
            </div>
            <!-- 第三行：理由和时间在左，按钮在右下 -->
            <div class="skip-list-item-bottom-row">
              <div class="skip-list-item-bottom-left">
                <div class="skip-list-item-reason">{{ item.skip_reason }}</div>
                <div class="skip-list-item-time">{{ item.create_time }}</div>
              </div>
              <div class="skip-list-item-actions">
                <el-button 
                  type="danger" 
                  size="mini" 
                  @click="handleRemoveSkip(item)"
                  title="取消跳过">
                  取消跳过
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <el-empty v-else-if="!skipListLoading && skipList.length === 0" description="暂无已跳过的待办" :image-size="80"></el-empty>
      </div>
    </el-dialog>
    
    <!-- 放大查看对话框 -->
    <el-dialog
      :title="getExpandDialogTitle(expandDialogType)"
      :visible.sync="expandDialogVisible"
      :width="expandDialogWidth"
      :modal="true"
      :append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="expand-todo-dialog"
      :class="{ 'expand-dialog-overflow': expandDialogContentOverflow }"
      @opened="handleExpandDialogOpened">
      <div class="expand-todo-content" :class="getExpandContentClass(expandDialogType)" ref="expandTodoContent">
        <!-- 更新&复盘待办内容 -->
        <template v-if="expandDialogType === 1">
          <div v-if="updateReviewTodoList.length > 0">
            <div 
              v-for="(item, index) in updateReviewTodoList" 
              :key="index" 
              class="update-review-todo-item"
              :class="{ 'delay-item': item.is_dealy === 'Dealy' }">
              <div class="todo-item-content">
                <!-- 第一行：标志(G/P) + 名称 + note标签（靠右） -->
                <div class="todo-row-first">
                  <!-- 标志（赛事:G，题目:P） -->
                  <div class="todo-type-badge" :class="item.type === 'game' ? 'badge-game' : 'badge-question'">
                    {{ item.type === 'game' ? 'G' : 'P' }}
                  </div>
                  
                  <!-- 名称和图标容器 -->
                  <div class="todo-name-with-icon">
                    <div class="todo-name">{{ item.name }}</div>
                    <el-tooltip 
                      effect="dark" 
                      placement="top"
                      popper-class="fix-todo-tooltip">
                      <template slot="content">
                        <div v-html="getUpdateReviewTodoTooltipHtml(item)"></div>
                      </template>
                      <i 
                        class="el-icon-info todo-info-icon"
                        @click.stop="handleInfoIconClick(item, index, 'update-review')">
                      </i>
                    </el-tooltip>
                  </div>
                  
                  <!-- note 标签（靠右显示） -->
                  <div class="todo-note-tags" v-if="item.note && item.note.length">
                    <el-tag 
                      v-for="(n, i) in item.note" 
                      :key="i" 
                      size="mini"
                      :type="n === 'NOREP' ? 'danger' : (n === 'NOLEVEL' ? 'warning' : (n === 'NOERR' ? 'info' : 'default'))"
                      class="note-tag">
                      {{ getUpdateReviewTodoSingleNoteText(n) }}
                    </el-tag>
                  </div>
                </div>
                
                <!-- 第二行：状态 + days_ago + 按钮（靠右） -->
                <div class="todo-row-second">
                  <!-- 状态标签（最前面） -->
                  <div 
                    class="todo-status-tag"
                    :class="item.is_dealy === 'Dealy' ? 'status-delay' : 'status-ontime'">
                    {{ item.is_dealy === 'Dealy' ? '超时' : '正常' }}
                  </div>
                  
                  <!-- days_ago 文案（在状态后面，加粗放大并按状态上色） -->
                  <div class="todo-days" v-html="getUpdateReviewTodoDaysRichText(item)"></div>
                  
                  <!-- 操作按钮（靠右显示）：跳转 + 复盘/编辑 + skip -->
                  <div class="todo-actions">
                    <!-- 跳转按钮 -->
                    <el-button 
                      type="default" 
                      size="mini" 
                      icon="el-icon-position"
                      :disabled="!item.url"
                      @click.stop="handleGoToUrl(item.url)"
                      title="跳转"
                      class="action-btn">
                    </el-button>
                    <!-- 赛事类型：显示复盘按钮（弹窗） -->
                    <el-button 
                      v-if="item.type === 'game' && !isMobileDevice"
                      type="primary" 
                      size="mini" 
                      icon="el-icon-video-camera"
                      @click.stop="openReplayDialog(item)"
                      title="复盘"
                      class="action-btn replay-btn">
                    </el-button>
                    <!-- 题目类型：显示编辑按钮（弹窗） -->
                    <el-button 
                      v-else-if="!isMobileDevice"
                      type="primary" 
                      size="mini" 
                      icon="el-icon-edit"
                      @click.stop="openEditDialog(item)"
                      title="编辑"
                      class="action-btn edit-btn">
                    </el-button>
                    <!-- Skip按钮（连续点击5次info icon后显示） -->
                    <el-button 
                      v-if="showSkipButtons[`update-review-${index}`]"
                      type="warning" 
                      size="mini" 
                      @click.stop="openSkipDialog(item, index, 'update-review')"
                      title="跳过"
                      class="action-btn skip-btn">
                      skip
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state-celebration">
            <div class="celebration-icon">🌟</div>
            <div class="celebration-title">完美！</div>
            <div class="celebration-message">你已完成所有的更新&复盘待办</div>
            <div class="celebration-subtitle">每一次复盘都是进步！✨</div>
          </div>
        </template>
        
        <!-- 订正待办内容 -->
        <template v-else-if="expandDialogType === 2">
          <div v-if="fixTodoList.length > 0">
            <div 
              v-for="(item, index) in fixTodoList" 
              :key="index" 
              class="fix-todo-item"
              :class="{ 'delay-item': item.is_dealy === 'Dealy' }">
              <div class="todo-item-content">
                <!-- 第一行：难度标签 + 题目名称 + 分数/订正分数 -->
                <div class="todo-row-first">
                  <!-- 难度标签 -->
                  <div 
                    class="todo-level-tag"
                    :style="{ 
                      backgroundColor: getDifficultyColor(item.question_level || ''),
                      borderColor: getDifficultyColor(item.question_level || '')
                    }">
                    {{ item.question_level || '未定义' }}
                  </div>
                  
                  <!-- 题目名称和图标容器 -->
                  <div class="todo-question-name-with-icon">
                    <div class="todo-question-name">{{ item.question_name }}</div>
                    <el-tooltip 
                      effect="dark" 
                      placement="top"
                      popper-class="fix-todo-tooltip">
                      <template slot="content">
                        <div v-html="getFixTodoTooltipHtml(item)"></div>
                      </template>
                      <i 
                        class="el-icon-info todo-info-icon"
                        @click.stop="handleInfoIconClick(item, index, 'fix')">
                      </i>
                    </el-tooltip>
                  </div>
                  
                  <!-- 分数显示 -->
                  <div class="todo-score">
                    <span 
                      class="score-original"
                      :style="{ color: getScoreColor(item.question_score) }">
                      {{ item.question_score }}
                    </span>
                    <span class="score-separator">/</span>
                    <span 
                      class="score-fix"
                      :style="{ color: getScoreColor(item.question_score_fix) }">
                      {{ item.question_score_fix }}
                    </span>
                  </div>
                </div>
                
                <!-- 第二行：状态 + days_ago + 操作按钮（靠右） -->
                <div class="todo-row-second">
                  <!-- 状态标签 -->
                  <div 
                    class="todo-status-tag"
                    :class="item.is_dealy === 'Dealy' ? 'status-delay' : 'status-ontime'">
                    {{ item.is_dealy === 'Dealy' ? '超时' : '正常' }}
                  </div>
                  <!-- days_ago 文案（加粗放大并按状态上色） -->
                  <div class="todo-days" v-html="getFixDaysRichText(item)"></div>
                  <!-- 操作按钮靠右 -->
                  <div class="todo-actions">
                    <el-button 
                      type="default" 
                      size="mini" 
                      icon="el-icon-position"
                      :disabled="!item.question_url"
                      @click.stop="handleGoToQuestionUrl(item.question_url)"
                      title="跳转到题目"
                      class="action-btn">
                    </el-button>
                    <el-button 
                      type="success" 
                      size="mini" 
                      icon="el-icon-check"
                      @click.stop="handleFixTodo(item)"
                      title="标记为已订正"
                      class="action-btn">
                    </el-button>
                    <el-button 
                      type="primary" 
                      size="mini"
                      icon="el-icon-video-pause"
                      @click.stop="handleFixPending(item)"
                      :disabled="item.question_score === 100 || item.question_score_fix === 100"
                      title="挂起"
                      class="action-btn">
                    </el-button>
                    <!-- Skip按钮（连续点击5次info icon后显示） -->
                    <el-button 
                      v-if="showSkipButtons[`fix-${index}`]"
                      type="warning" 
                      size="mini" 
                      @click.stop="openSkipDialog(item, index, 'fix')"
                      title="跳过"
                      class="action-btn skip-btn">
                      skip
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state-celebration">
            <div class="celebration-icon">🎉</div>
            <div class="celebration-title">太棒了！</div>
            <div class="celebration-message">你已经完成了所有订正待办</div>
            <div class="celebration-subtitle">继续保持，加油！💪</div>
          </div>
        </template>
        
        <!-- 计划待办内容 -->
        <template v-else-if="expandDialogType === 3">
          <div v-if="taskTodoList.length > 0">
            <div 
              v-for="(item, index) in taskTodoList" 
              :key="index" 
              class="task-todo-item"
              :class="getTaskItemClass(item)">
              <div class="task-item-content">
                <!-- 第一行：状态标签 + 计划名称 -->
                <div class="task-row-first">
                  <!-- 状态标签 -->
                  <div 
                    class="task-status-tag"
                    :class="getTaskStatusClass(item.plan_status_value)">
                    {{ item.plan_status }}
                  </div>
                  
                  <!-- 计划名称和图标容器 -->
                  <div class="task-plan-name-with-icon">
                    <div 
                      class="task-plan-name" 
                      @click="showPlanInfo(item)"
                      title="点击查看计划详情">
                      {{ item.plan_name }}
                    </div>
                    <el-tooltip 
                      effect="dark" 
                      placement="top"
                      popper-class="fix-todo-tooltip">
                      <template slot="content">
                        <div v-html="getTaskTodoTooltipHtml(item)"></div>
                      </template>
                      <i 
                        class="el-icon-info todo-info-icon"
                        @click.stop="handleInfoIconClick(item, index, 'task')">
                      </i>
                    </el-tooltip>
                  </div>
                </div>
                
                <!-- 第二行：天数 + 时间状态 + 操作按钮 -->
                <div class="task-row-second">
                  <div 
                    class="task-time-status"
                    :class="getTimeStatusClass(item.plan_status_info)">
                    {{ getTimeStatusText(item.plan_status_info) }}
                  </div>
                  <div v-if="item.days_ago !== null" class="task-days-wrapper">
                    <div class="task-days" v-html="getTaskDaysRichText(item)"></div>
                  </div>
                  <div class="task-actions" v-if="!isMobileDevice">
                    <!-- 编辑按钮（所有状态都显示） -->
                    <el-button 
                      type="default" 
                      size="mini" 
                      icon="el-icon-edit"
                      @click.stop="handleTaskEdit(item)"
                      title="编辑"
                      class="task-action-btn task-edit-btn">
                    </el-button>
                    
                    <!-- 未开始状态：显示开始按钮 -->
                    <template v-if="item.plan_status_value === 0">
                      <el-button 
                        type="success" 
                        size="mini" 
                        icon="el-icon-video-play"
                        @click.stop="handleTaskStart(item)"
                        title="开始"
                        class="task-action-btn task-start-btn">
                      </el-button>
                    </template>
                    
                    <!-- 进行中状态：显示暂停、完成、终止按钮 -->
                    <template v-if="item.plan_status_value === 1">
                      <el-button 
                        type="warning" 
                        size="mini" 
                        icon="el-icon-video-pause"
                        @click.stop="handleTaskPause(item)"
                        title="暂停"
                        class="task-action-btn task-pause-btn">
                      </el-button>
                      <el-button 
                        type="success" 
                        size="mini" 
                        icon="el-icon-check"
                        @click.stop="handleTaskComplete(item)"
                        title="完成"
                        class="task-action-btn task-complete-btn">
                      </el-button>
                      <el-button 
                        type="danger" 
                        size="mini" 
                        icon="el-icon-circle-close"
                        @click.stop="handleTaskTerminate(item)"
                        title="终止"
                        class="task-action-btn task-terminate-btn">
                      </el-button>
                    </template>
                    <!-- Skip按钮（连续点击5次info icon后显示） -->
                    <el-button 
                      v-if="showSkipButtons[`task-${index}`]"
                      type="warning" 
                      size="mini" 
                      @click.stop="openSkipDialog(item, index, 'task')"
                      title="跳过"
                      class="task-action-btn skip-btn">
                      skip
                    </el-button>
                  </div>
                  <!-- 移动端：折叠为"..."按钮 -->
                  <div class="task-actions-mobile" v-else>
                    <el-button
                      type="default"
                      size="mini"
                      icon="el-icon-more"
                      class="task-action-btn"
                      @click.stop="toggleTaskActions(index)"
                      title="更多">
                    </el-button>
                    <div 
                      class="task-actions-panel" 
                      v-if="taskTodoActionsOpenIndex === index"
                      @click.stop>
                      <el-button 
                        type="default" 
                        size="mini" 
                        icon="el-icon-edit"
                        @click.stop="handleTaskEdit(item); toggleTaskActions(null)"
                        class="task-action-btn task-edit-btn">
                      </el-button>
                      <template v-if="item.plan_status_value === 0">
                        <el-button 
                          type="success" 
                          size="mini" 
                          icon="el-icon-video-play"
                          @click.stop="handleTaskStart(item); toggleTaskActions(null)"
                          class="task-action-btn task-start-btn">
                        </el-button>
                      </template>
                      <template v-if="item.plan_status_value === 1">
                        <el-button 
                          type="warning" 
                          size="mini" 
                          icon="el-icon-video-pause"
                          @click.stop="handleTaskPause(item); toggleTaskActions(null)"
                          class="task-action-btn task-pause-btn">
                        </el-button>
                        <el-button 
                          type="success" 
                          size="mini" 
                          icon="el-icon-check"
                          @click.stop="handleTaskComplete(item); toggleTaskActions(null)"
                          class="task-action-btn task-complete-btn">
                        </el-button>
                        <el-button 
                          type="danger" 
                          size="mini" 
                          icon="el-icon-circle-close"
                          @click.stop="handleTaskTerminate(item); toggleTaskActions(null)"
                          class="task-action-btn task-terminate-btn">
                        </el-button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state-celebration">
            <div class="celebration-icon">✨</div>
            <div class="celebration-title">恭喜恭喜！</div>
            <div class="celebration-message">你已经完成了所有计划待办</div>
            <div class="celebration-subtitle">你真厉害！🌟</div>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getRandomUnfixQuestion, getQuestions } from '@/api/question'
import { getVisibleGreatEvents } from '@/api/great_event'
import { isMobile, addResizeListener } from '@/utils/device'
import { getErrorOutlineStyle } from '@/constants/errorTypes'
import { updatePlanStatus, getPlanDetail } from '@/api/plan'
import PlanInfoDialog from '@/views/plan/components/PlanInfoDialog.vue'
import PlanDialog from '@/views/plan/components/PlanDialog.vue'
import QuestionDialog from '@/views/game/components/QuestionDialog.vue'
import GameReplay from '@/views/game/components/GameReplay.vue'
import { getGameList } from '@/api/game'
import { addTodoSkip, getTodoSkipList, removeTodoSkip } from '@/api/todo_skip'

// 运势配置
const FORTUNE_LEVELS = [
  { level: '大吉', probability: 0.14, color: 'great' },
  { level: '中吉', probability: 0.17, color: 'good' },
  { level: '小吉', probability: 0.25, color: 'small-good' },
  { level: '平', probability: 0.25, color: 'normal' },
  { level: '小凶', probability: 0.07, color: 'small-bad' },
  { level: '中凶', probability: 0.06, color: 'bad' },
  { level: '大凶', probability: 0.05, color: 'worse' }
]

// 活动池
const ACTIVITIES = [
  '看书', '学习', '打模拟赛', '订正', '刷题', 
  '交友', '桌游', '看电视', '玩游戏', '晒太阳',
  '煮奶茶', '做饭', '当一只喵', '卖萌', '躺平',
  '起飞', '旅行', '撸猫', '吃冰淇淋','抠脚','抠毛毛',
  '打拳', '第五人格.启动', '冲击RK1', '掼蛋吧，少年'
]

// 骚话模板
const COMMENTS = {
  good: [
    '这波稳了！',
    '今天运势爆棚~',
    '不愧是你！',
    '这就是大佬吗？',
    '太强了吧！',
    '这波啊，这波是肝帝！',
    '稳如老狗~',
    '这么强的吗？',
    '今天状态拉满！',
    '这波操作很秀！',
    '你就是传奇！',
    '无敌是多么寂寞~',
    '这波操作满分！',
    '你是最棒的！',
    '简直完美！',
    '这就是实力！',
    '你是天选之子！',
    '全场最佳！',
    '无人能敌！',
    '你是我的偶像！',
    '每个人都有自己要走的路！',
    'RP++++++不完！',
    'Lv10大佬，让人颤抖啊！'
  ],
  bad: [
    '淡定淡定~',
    '问题不大！',
    '莫慌莫慌~',
    '佛系一点~',
    '下次一定行！',
    '总会过去的~',
    '别担心啦~',
    '问题不大的！',
    '明天会更好~',
    '睡一觉就好了~',
    '小问题而已~',
    '保持微笑~',
    '再接再厉！',
    '不必在意~',
    '一切都会好~',
    '相信自己！',
    '风雨过后是彩虹~',
    '别灰心，加油！',
    '今天不行明天行！',
    '继续努力！',
    '对着生活比个耶！'
  ]
}

export default {
  name: 'Welcome',
  components: {
    PlanInfoDialog,
    PlanDialog,
    QuestionDialog,
    GameReplay
  },
  data() {
    return {
      friendLinks: [],
      randomQuestion: null,
      tags: [],
      username: '',
      checkInDays: 0,
      todayCheckedIn: false,
      checkingIn: false,
      todayFortune: null,
      greatEvents: [], // 大事记数据
      eventsLoading: false, // 大事记加载状态
      autoScrollInterval: null, // 自动滚动定时器
      currentScrollPosition: 0, // 当前滚动位置
      scrollSpeed: 1, // 滚动速度，每次滚动1px
      pauseScroll: false, // 鼠标悬停时暂停滚动
      headerScrollInterval: null, // 头部标题滚动定时器
      isMobileDevice: false,
      removeResizeListener: null,
      // 订正待办相关
      fixTodoList: [],
      fixTodoLoading: false,
      showFixTodoConfig: false,
      fixTodoConfig: {
        delayDays: 7,
        startTime: '2025/11/01 00:00:00',
        questionLevels: ['', '红题', '橙题', '黄题', '绿题', '蓝题', '紫题'] // 默认选中除黑题外的所有选项
      },
      // 题目难度选项
      questionLevelOptions: [
        { value: '', label: '未定义' },
        { value: '红题', label: '红题' },
        { value: '橙题', label: '橙题' },
        { value: '黄题', label: '黄题' },
        { value: '绿题', label: '绿题' },
        { value: '蓝题', label: '蓝题' },
        { value: '紫题', label: '紫题' },
        { value: '黑题', label: '黑题' }
      ],
      // 计划待办相关
      taskTodoList: [],
      taskTodoLoading: false,
      showPlanInfoDialog: false,
      currentPlanInfo: '',
      taskTodoActionsOpenIndex: null,
      showTaskTodoConfig: false,
      taskEditDialogVisible: false,
      currentTaskPlan: null,
      // 计划待办配置
      taskTodoConfig: {
        startLeadDays: 7,
        allowEmptyStart: false
      },
      
      // 更新&复盘待办相关
      updateReviewTodoList: [],
      updateReviewTodoLoading: false,
      showUpdateReviewTodoConfig: false,
      updateReviewTodoConfig: {
        delayDays: 7,
        startTime: '2025/11/01 00:00:00',
        todoTypes: ['NOREP', 'NOTAG', 'NOLEVEL', 'NOERR'], // 默认选中所有类型
        scoreRateThreshold: 80 // 默认得分率阈值80%（小于80%需要复盘）
      },
      // 弹窗：更新&复盘 - 编辑/复盘
      updateReviewEditVisible: false,
      updateReviewCurrentQuestion: null,
      updateReviewReplayVisible: false,
      updateReviewCurrentGame: null,
      // Skip功能相关
      // 记录每个待办项的点击次数和最后点击时间（用于3秒内连续点击5次）
      infoClickCounts: {}, // { 'update-review-0': { count: 0, lastTime: 0 } }
      // 记录显示skip按钮的待办项索引
      showSkipButtons: {}, // { 'update-review-0': true }
      // Skip确认对话框
      showSkipDialog: false,
      skipDialogItem: null, // 当前要skip的待办项
      skipDialogType: null, // 'update-review' | 'fix' | 'task'
      skipReason: '', // 跳过原因
      skipCustomReason: '', // 自定义原因
      skipPresetReasons: ['太简单了，没有复盘的价值。', '红题？不需要标签。', '懒，不想做。', '太难，不会做。', '最近忙，等有空再做。'],
      // View Skip对话框
      showViewSkipDialog: false,
      viewSkipType: null, // 1: 更新&复盘, 2: 订正, 3: 计划
      skipList: [], // skip列表数据
      skipListLoading: false, // skip列表加载状态
      // 放大查看对话框
      expandDialogVisible: false,
      expandDialogType: null, // 1: 更新&复盘, 2: 订正, 3: 计划
      expandDialogContentOverflow: false // 内容是否超过最大高度
    }
  },
  computed: {
    fortuneColorClass() {
      if (!this.todayFortune || !this.todayFortune.level) return ''
      const fortune = FORTUNE_LEVELS.find(f => f.level === this.todayFortune.level)
      return fortune ? fortune.color : ''
    },
    // 更新&复盘待办：正常和超时任务数量
    updateReviewTodoNormalCount() {
      return this.updateReviewTodoList.filter(item => item.is_dealy !== 'Dealy').length
    },
    updateReviewTodoDelayCount() {
      return this.updateReviewTodoList.filter(item => item.is_dealy === 'Dealy').length
    },
    // 得分率阈值显示值（格式化）
    scoreRateThresholdDisplay: {
      get() {
        return this.updateReviewTodoConfig.scoreRateThreshold
      },
      set(value) {
        // 解析输入值，去掉%符号
        let numValue = value
        if (typeof value === 'string') {
          numValue = value.replace(/%/g, '').trim()
        }
        const parsedValue = parseInt(numValue, 10)
        if (!isNaN(parsedValue)) {
          // 限制在0-100之间
          const clampedValue = Math.max(0, Math.min(100, parsedValue))
          this.updateReviewTodoConfig.scoreRateThreshold = clampedValue
        }
      }
    },
    // 订正待办：正常和超时任务数量
    fixTodoNormalCount() {
      return this.fixTodoList.filter(item => item.is_dealy !== 'Dealy').length
    },
    fixTodoDelayCount() {
      return this.fixTodoList.filter(item => item.is_dealy === 'Dealy').length
    },
    // 计划待办：正常和超时任务数量
    taskTodoNormalCount() {
      return this.taskTodoList.filter(item => item.plan_status_info !== 'Delay').length
    },
    taskTodoDelayCount() {
      return this.taskTodoList.filter(item => item.plan_status_info === 'Delay').length
    },
    // 放大对话框宽度（与跳过对话框保持一致）
    expandDialogWidth() {
      return '600px'
    }
  },
  watch: {
    // 监听配置对话框显示状态，手动调整 z-index
    showFixTodoConfig(newVal) {
      if (newVal) {
        // 对话框打开时，延迟调整 z-index 确保 DOM 已渲染
        this.$nextTick(() => {
          setTimeout(() => {
            // 1. 先设置遮罩层的 z-index
            const modals = document.querySelectorAll('.v-modal')
            if (modals.length > 0) {
              // 获取最后一个遮罩层（最新的）
              const lastModal = modals[modals.length - 1]
              lastModal.style.zIndex = '3000'
            }
            
            // 2. 再设置对话框 wrapper 的 z-index（必须高于遮罩层）
            const dialogWrappers = document.querySelectorAll('.el-dialog__wrapper')
            dialogWrappers.forEach(wrapper => {
              const configDialog = wrapper.querySelector('.fix-todo-config-dialog')
              if (configDialog) {
                wrapper.style.zIndex = '3001'
              }
            })
          }, 100) // 增加延迟到100ms，确保 Element UI 完成初始化
        })
      }
    },
    // 监听更新&复盘待办配置对话框显示状态，手动调整 z-index
    showUpdateReviewTodoConfig(newVal) {
      if (newVal) {
        // 对话框打开时，延迟调整 z-index 确保 DOM 已渲染
        this.$nextTick(() => {
          setTimeout(() => {
            // 1. 先设置遮罩层的 z-index
            const modals = document.querySelectorAll('.v-modal')
            if (modals.length > 0) {
              // 获取最后一个遮罩层（最新的）
              const lastModal = modals[modals.length - 1]
              lastModal.style.zIndex = '3000'
            }
            
            // 2. 再设置对话框 wrapper 的 z-index（必须高于遮罩层）
            const dialogWrappers = document.querySelectorAll('.el-dialog__wrapper')
            dialogWrappers.forEach(wrapper => {
              const configDialog = wrapper.querySelector('.update-review-todo-config-dialog')
              if (configDialog) {
                wrapper.style.zIndex = '3001'
              }
            })
          }, 100) // 增加延迟到100ms，确保 Element UI 完成初始化
        })
      }
    }
  },
  created() {
    this.loadFixTodoConfig() // 加载配置
    this.loadUpdateReviewTodoConfig() // 加载更新&复盘待办配置
    this.loadTaskTodoConfig() // 加载计划待办配置
    this.fetchFriendLinks()
    this.fetchRandomQuestion()
    this.fetchUserInfo()
    this.fetchFixTodoList() // 获取订正待办数据
    this.fetchTaskTodoList() // 获取计划待办数据
    this.fetchUpdateReviewTodoList() // 获取更新&复盘待办数据
    this.checkTodayStatus()
    this.fetchGreatEvents() // 获取大事记数据
  },
  mounted() {
    // 初始化设备类型并监听窗口变化
    this.isMobileDevice = isMobile()
    let resizeTimer = null
    this.removeResizeListener = addResizeListener(() => {
      this.isMobileDevice = isMobile()
      
      // 使用防抖，避免频繁触发
      if (resizeTimer) clearTimeout(resizeTimer)
      
      resizeTimer = setTimeout(() => {
        // 总是调用syncGreatEventsHeight，内部会根据isMobileDevice判断
        this.syncGreatEventsHeight()
        
        // PC端重新初始化滚动
        if (!this.isMobileDevice) {
          setTimeout(() => {
            this.initializeScroll()
          }, 200)
        }
      }, 300) // 300ms防抖延迟
    })
    // 注意：大事记的滚动初始化在 fetchGreatEvents() 完成后自动调用
    // 头部标题的滚动初始化在 fetchUserInfo() 完成后自动调用
    
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopAutoScroll();
    this.stopHeaderScroll(); // 清除头部标题滚动定时器
    if (this.removeResizeListener) {
      this.removeResizeListener()
      this.removeResizeListener = null
    }
  },
  methods: {
    // 处理友链名称中的换行符，如果有换行则第一行放大2倍
    formatLinkName(name) {
      if (!name) return ''
      
      // 先将字符串字面量 \n 和真正的换行符统一处理
      let processedName = name.replace(/\\n/g, '\n')
      
      // 按换行符分割
      const lines = processedName.split('\n')
      
      // 如果有换行（多于一行），第一行放大2倍；如果没有换行，保持原样
      if (lines.length > 1 && lines[0]) {
        // 有换行：第一行用 span 包裹并添加放大样式
        lines[0] = `<span class="link-name-icon">${lines[0]}</span>`
      }
      // 如果没有换行，lines.length === 1，直接返回原内容（不需要添加 span）
      
      // 重新组合，将换行符转换为 <br>
      return lines.join('<br>')
    },
    async fetchFriendLinks() {
      try {
        console.log('开始获取可见友链')
        const response = await request.get('/api/friend-links/visible')
        console.log('获取到的友链数据:', response)
        
        // 检查响应格式并处理数据
        if (Array.isArray(response)) {
          this.friendLinks = response
        } else if (response && Array.isArray(response.data)) {
          this.friendLinks = response.data
        } else {
          this.friendLinks = []
          console.warn('未获取到有效的友链数据:', response)
        }
        
        console.log('处理后的友链列表:', this.friendLinks)
        
        // 友链加载完成后同步大事记高度
        this.$nextTick(() => {
          this.syncGreatEventsHeight();
        });
      } catch (error) {
        console.error('获取友情链接失败:', error)
        if (error.response) {
          console.error('错误响应:', error.response)
        } else if (error.request) {
          console.error('请求未收到响应')
        } else {
          console.error('请求配置错误:', error.message)
        }
      }
    },
    
    getScoreColor(score) {
      if (score === undefined || score === null) return '#606266'
      const percentage = score
      if (percentage >= 100) return '#237804' // 绿色
      if (percentage >= 75) return '#52C41A'  // 黄绿色
      if (percentage >= 50) return '#F7BA2A'  // 黄色
      if (percentage >= 25) return '#E6A23C'  // 橙色
      return '#F56C6C' // 红色
    },
    
    // 获取赛事分数颜色（参考GameList.vue的逻辑）
    getGameScoreColor(score, questionNum) {
      if (!questionNum || questionNum === 0) return '#606266' // 默认颜色，如果没有题目数
      
      const fullScore = questionNum * 100
      const percentage = (score / fullScore) * 100
      
      if (percentage >= 100) return '#237804' // 绿色
      if (percentage >= 75) return '#52C41A' // 黄绿色
      if (percentage >= 50) return '#F7BA2A' // 黄色
      if (percentage >= 25) return '#E6A23C' // 橙色
      return '#F56C6C' // 红色
    },
    
    async fetchRandomQuestion() {
      try {
        const { data } = await getRandomUnfixQuestion()
        this.randomQuestion = data
        console.log('获取到的随机题目数据:', data) // 添加日志
      } catch (error) {
        console.error('获取随机未订正题目失败:', error)
      }
    },
    
    // 格式化赛事时间
    formatGameTime(timeString) {
      if (!timeString) return '未知日期'
      try {
        const date = new Date(timeString)
        return isNaN(date.getTime()) 
          ? '未知日期' 
          : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
      } catch (error) {
        return '未知日期'
      }
    },
    
    handleRefresh() {
      this.fetchRandomQuestion()
    },
    
    handleGoToQuestion() {
      if (this.randomQuestion && this.randomQuestion.question_url) {
        window.open(this.randomQuestion.question_url, '_blank')
      }
    },
    
    async handleFix() {
      try {
        await this.$confirm('确认将该题目订正分数改为100分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/game/question/${this.randomQuestion.question_code}/fix`,
          method: 'put',
          data: {
            question_score_fix: 100
          }
        })
        
        if (res.code === 200) {
          this.$message.success('订正成功')
          // 获取新的随机题目
          this.fetchRandomQuestion()
        } else {
          throw new Error(res.message || '订正失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('订正失败:', error)
          this.$message.error(error.message || '订正失败')
        }
      }
    },
    
    getDifficultyColor(level) {
      const colorMap = {
        '红题': '#F56C6C',  // 红色
        '橙题': '#E6A23C',  // 橙色
        '黄题': '#F7BA2A',  // 黄色
        '绿题': '#67C23A',  // 绿色
        '蓝题': '#409EFF',  // 蓝色
        '紫题': '#8E44AD',  // 紫色
        '黑题': '#2C3E50',  // 黑色
        '': '#909399'       // 灰色
      }
      return colorMap[level] || '#909399'
    },
    
    // 加载订正待办配置（从本地缓存）
    loadFixTodoConfig() {
      try {
        const savedConfig = localStorage.getItem('fixTodoConfig')
        if (savedConfig) {
          const config = JSON.parse(savedConfig)
          this.fixTodoConfig.delayDays = config.delayDays || 7
          this.fixTodoConfig.startTime = config.startTime || '2025/11/01 00:00:00'
          // 兼容旧配置，如果没有questionLevels则使用默认值
          this.fixTodoConfig.questionLevels = config.questionLevels || ['', '红题', '橙题', '黄题', '绿题', '蓝题', '紫题']
        }
      } catch (error) {
        console.error('加载订正待办配置失败:', error)
      }
    },
    
    // 保存订正待办配置（到本地缓存）
    saveFixTodoConfig() {
      try {
        localStorage.setItem('fixTodoConfig', JSON.stringify(this.fixTodoConfig))
        this.showFixTodoConfig = false
        this.$message.success('配置保存成功')
        // 重新获取数据
        this.fetchFixTodoList()
      } catch (error) {
        console.error('保存订正待办配置失败:', error)
        this.$message.error('配置保存失败')
      }
    },
    
    // 关闭配置对话框
    handleFixTodoConfigClose() {
      // 恢复配置为保存的值
      this.loadFixTodoConfig()
    },
    
    // 处理题目难度选择变化
    handleQuestionLevelsChange() {
      // 如果全部取消选择，则重新选中默认项
      if (!this.fixTodoConfig.questionLevels || this.fixTodoConfig.questionLevels.length === 0) {
        this.$message.warning('至少需要选择一个难度')
        this.fixTodoConfig.questionLevels = ['', '红题', '橙题', '黄题', '绿题', '蓝题', '紫题']
      }
    },
    
    // 加载更新&复盘待办配置（从本地缓存）
    loadUpdateReviewTodoConfig() {
      try {
        const savedConfig = localStorage.getItem('updateReviewTodoConfig')
        if (savedConfig) {
          const config = JSON.parse(savedConfig)
          this.updateReviewTodoConfig.delayDays = config.delayDays || 7
          this.updateReviewTodoConfig.startTime = config.startTime || '2025/11/01 00:00:00'
          this.updateReviewTodoConfig.todoTypes = config.todoTypes || ['NOREP', 'NOTAG', 'NOLEVEL', 'NOERR']
          this.updateReviewTodoConfig.scoreRateThreshold = config.scoreRateThreshold !== undefined ? config.scoreRateThreshold : 80
        }
      } catch (error) {
        console.error('加载更新&复盘待办配置失败:', error)
      }
    },
    
    // 保存更新&复盘待办配置（到本地缓存）
    saveUpdateReviewTodoConfig() {
      try {
        localStorage.setItem('updateReviewTodoConfig', JSON.stringify(this.updateReviewTodoConfig))
        this.showUpdateReviewTodoConfig = false
        this.$message.success('配置保存成功')
        // 重新获取数据
        this.fetchUpdateReviewTodoList()
      } catch (error) {
        console.error('保存更新&复盘待办配置失败:', error)
        this.$message.error('配置保存失败')
      }
    },
    
    // 关闭更新&复盘待办配置对话框
    handleUpdateReviewTodoConfigClose() {
      // 恢复配置为保存的值
      this.loadUpdateReviewTodoConfig()
    },
    
    // 处理待办事宜类型选择变化
    handleTodoTypesChange() {
      // 如果全部取消选择，则重新选中默认项
      if (!this.updateReviewTodoConfig.todoTypes || this.updateReviewTodoConfig.todoTypes.length === 0) {
        this.$message.warning('至少需要选择一个待办事宜类型')
        this.updateReviewTodoConfig.todoTypes = ['NOREP', 'NOTAG', 'NOLEVEL', 'NOERR']
      }
    },
    
    // 处理得分率阈值失去焦点
    handleScoreRateThresholdBlur() {
      // 确保值在有效范围内
      const value = this.updateReviewTodoConfig.scoreRateThreshold
      if (isNaN(value) || value < 0) {
        this.updateReviewTodoConfig.scoreRateThreshold = 0
      } else if (value > 100) {
        this.updateReviewTodoConfig.scoreRateThreshold = 100
      }
    },
    
    // 获取更新&复盘待办数据
    async fetchUpdateReviewTodoList() {
      this.updateReviewTodoLoading = true
      try {
        const todoTypesStr = this.updateReviewTodoConfig.todoTypes.join(',')
        const response = await request.get('/api/update-review-todo/list', {
          params: {
            delay_days: this.updateReviewTodoConfig.delayDays,
            start_time: this.updateReviewTodoConfig.startTime,
            todo_types: todoTypesStr,
            score_rate_threshold: this.updateReviewTodoConfig.scoreRateThreshold
          }
        })
        if (response.code === 200) {
          this.updateReviewTodoList = response.data || []
        } else {
          this.$message.error(response.message || '获取更新&复盘待办数据失败')
          this.updateReviewTodoList = []
        }
      } catch (error) {
        console.error('获取更新&复盘待办数据失败:', error)
        this.$message.error('获取更新&复盘待办数据失败')
        this.updateReviewTodoList = []
      } finally {
        this.updateReviewTodoLoading = false
      }
    },
    
    // 获取订正待办数据
    async fetchFixTodoList() {
      this.fixTodoLoading = true
      try {
        // 将题目难度数组转换为逗号分隔的字符串
        // 使用特殊标记 '__EMPTY__' 来表示空字符串，避免 join 后丢失
        const questionLevelsStr = this.fixTodoConfig.questionLevels
          .map(level => level === '' ? '__EMPTY__' : level)
          .join(',')
        const response = await request.get('/api/game/fix-todo/list', {
          params: {
            delay_days: this.fixTodoConfig.delayDays,
            start_time: this.fixTodoConfig.startTime,
            question_levels: questionLevelsStr
          }
        })
        if (response.code === 200) {
          this.fixTodoList = response.data || []
        } else {
          this.$message.error(response.message || '获取订正待办数据失败')
          this.fixTodoList = []
        }
      } catch (error) {
        console.error('获取订正待办数据失败:', error)
        this.$message.error('获取订正待办数据失败')
        this.fixTodoList = []
      } finally {
        this.fixTodoLoading = false
      }
    },
    
    // 格式化时间为 YYYY-MM-DD（与计划列表保持一致，不做时区偏移）
    formatTooltipTime(timeString) {
      if (!timeString) return ''
      try {
        // 如果已经是日期格式 YYYY-MM-DD，直接返回
        if (/^\d{4}-\d{2}-\d{2}$/.test(timeString)) {
          return timeString
        }

        // 与计划列表中的 formatDate 逻辑保持一致：
        // 1) 如果包含 'T'，视为 ISO 字符串，取前面的日期部分
        if (timeString.includes('T')) {
          return timeString.split('T')[0]
        }
        // 2) 如果包含空格，视为 MySQL DATETIME，取日期部分
        if (timeString.includes(' ')) {
          return timeString.split(' ')[0]
        }

        // 3) 回退：尝试用正则直接截取开头的 YYYY-MM-DD
        const dateMatch = timeString.match(/^(\d{4}-\d{2}-\d{2})/)
        if (dateMatch) {
          return dateMatch[1]
        }
        
        return timeString // 无法解析时返回原值
      } catch (error) {
        console.error('格式化时间失败:', error, timeString)
        return timeString
      }
    },
    
    // 获取tooltip内容（HTML格式）
    getFixTodoTooltipHtml(item) {
      const parts = []
      
      // 题目难度
      const questionLevel = item.question_level || '未定义'
      const levelColor = this.getDifficultyColor(item.question_level || '')
      parts.push(`
        <div class="tooltip-row">
          <span class="tooltip-label">题目难度：</span>
          <span class="tooltip-difficulty-tag" style="background-color: ${levelColor}; color: white; padding: 2px 6px; border-radius: 4px; font-size: 12px; display: inline-block;">
            ${questionLevel}
          </span>
        </div>
      `)
      
      // 题目名称
      if (item.question_name) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">题目名称：</span>
            <span class="tooltip-value">${item.question_name}</span>
          </div>
        `)
      }
      
      // 赛事名称（移动到题目名称下面）
      if (item.game_name) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">赛事名称：</span>
            <span class="tooltip-value">${item.game_name}</span>
          </div>
        `)
      }
      
      // 分数信息
      parts.push(`
        <div class="tooltip-row">
          <span class="tooltip-label">分数：</span>
          <span class="tooltip-value">
            <span style="color: ${this.getScoreColor(item.question_score)}; font-weight: bold;">${item.question_score}</span>
            <span>/</span>
            <span style="color: ${this.getScoreColor(item.question_score_fix)}; font-weight: bold;">${item.question_score_fix}</span>
          </span>
        </div>
      `)
      
      // 天数
      if (item.days_ago !== undefined && item.days_ago !== null) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">天数：</span>
            <span class="tooltip-value">${item.days_ago}天</span>
          </div>
        `)
      }
      
      // 状态
      if (item.is_dealy) {
        const statusText = item.is_dealy === 'Dealy' ? '超时' : '正常'
        const statusColor = item.is_dealy === 'Dealy' ? '#f56c6c' : '#67c23a'
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">状态：</span>
            <span style="color: ${statusColor}; font-weight: bold;">${statusText}</span>
          </div>
        `)
      }
      
      // 时间
      if (item.game_time) {
        const formattedTime = this.formatTooltipTime(item.game_time)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">时间：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      }
      
      // 标签
      if (item.tag_name) {
        const tags = this.getTagList(item.tag_name)
        const tagHtml = tags.map(tag => {
          const tagColor = this.getTagColorByName(tag)
          return `<span class="tooltip-tag" style="background-color: ${tagColor}; color: white; padding: 2px 6px; border-radius: 4px; font-size: 11px; display: inline-block; margin-right: 4px; margin-bottom: 4px;">${tag}</span>`
        }).join('')
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">标签：</span>
            <div style="display: inline-block; line-height: 1.8;">${tagHtml}</div>
          </div>
        `)
      }
      
      // 错误类型
      if (item.error_name) {
        const errors = item.error_name.split(',').map(e => e.trim()).filter(e => e)
        const errorHtml = errors.map(errorName => {
          // 使用与页面显示一致的样式：直接使用 getErrorOutlineStyle
          const errorStyle = getErrorOutlineStyle(errorName)
          return `<span class="tooltip-error" style="background-color: ${errorStyle.backgroundColor}; border: 1px solid ${errorStyle.borderColor}; color: ${errorStyle.color}; padding: 2px 6px; border-radius: 4px; font-size: 11px; display: inline-block; margin-right: 4px; margin-bottom: 4px;">
            <i class="el-icon-warning" style="margin-right: 4px;"></i>${errorName}
          </span>`
        }).join('')
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">错误类型：</span>
            <div style="display: inline-block; line-height: 1.8;">${errorHtml}</div>
          </div>
        `)
      }
      
      return parts.length > 0 ? parts.join('') : '<div class="tooltip-row">暂无详细信息</div>'
    },
    
    // 将标签字符串转换为数组
    getTagList(tagName) {
      if (!tagName) return []
      // tag_name 是逗号分隔的字符串，例如 "tag1,tag2,tag3"
      return tagName.split(',').map(tag => tag.trim()).filter(tag => tag)
    },
    
    // 将错误类型字符串转换为数组
    getErrorList(errorName) {
      if (!errorName) return []
      // error_name 是逗号分隔的字符串，例如 "error1,error2,error3"
      return errorName.split(',').map(error => error.trim()).filter(error => error)
    },
    
    // 获取计划待办tooltip内容（HTML格式）
    getTaskTodoTooltipHtml(item) {
      const parts = []
      
      // 计划名称
      if (item.plan_name) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">计划名称：</span>
            <span class="tooltip-value">${item.plan_name}</span>
          </div>
        `)
      }
      
      // 计划状态
      if (item.plan_status) {
        const statusColor = item.plan_status_value === 0 ? '#909399' : '#409EFF'
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">计划状态：</span>
            <span style="color: ${statusColor}; font-weight: bold;">${item.plan_status}</span>
          </div>
        `)
      }
      
      // 时间状态（移动到计划状态下方）
      if (item.plan_status_info) {
        const timeStatusText = item.plan_status_info === 'Delay' ? '超时' : 
                               item.plan_status_info === 'OnTime' ? '正常' : '未设置'
        const timeStatusColor = item.plan_status_info === 'Delay' ? '#f56c6c' : 
                                item.plan_status_info === 'OnTime' ? '#67c23a' : '#909399'
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">时间状态：</span>
            <span style="color: ${timeStatusColor}; font-weight: bold;">${timeStatusText}</span>
          </div>
        `)
      }
      
      // 天数（移动到计划状态下方）
      if (item.days_ago !== undefined && item.days_ago !== null) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">天数：</span>
            <span class="tooltip-value">${Math.abs(item.days_ago)}天</span>
          </div>
        `)
      }
      
      // 创建时间
      if (item.created_time) {
        const formattedTime = this.formatTooltipTime(item.created_time)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">创建时间：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      }
      
      // 预计开始
      if (item.scheduled_start_time) {
        const formattedTime = this.formatTooltipTime(item.scheduled_start_time)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">预计开始：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      } else {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">预计开始：</span>
            <span class="tooltip-value" style="color: #909399;">未设置</span>
          </div>
        `)
      }
      
      // 实际开始 - 直接使用 start_time 字段（与计划页面一致，对应数据库 start_time 字段）
      // 注意：actual_start_time 也对应数据库 start_time 字段，但我们统一使用 start_time
      const actualStartTime = item.start_time
      if (actualStartTime) {
        const formattedTime = this.formatTooltipTime(actualStartTime)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">实际开始：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      } else {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">实际开始：</span>
            <span class="tooltip-value" style="color: #909399;">未开始</span>
          </div>
        `)
      }
      
      // 预计完成
      if (item.scheduled_end_time) {
        const formattedTime = this.formatTooltipTime(item.scheduled_end_time)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">预计完成：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      } else {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">预计完成：</span>
            <span class="tooltip-value" style="color: #909399;">未设置</span>
          </div>
        `)
      }
      
      // 实际完成 - 直接使用 end_time 字段（与计划页面一致，对应数据库 end_time 字段）
      // 注意：actual_end_time 也对应数据库 end_time 字段，但我们统一使用 end_time
      const actualEndTime = item.end_time
      if (actualEndTime) {
        const formattedTime = this.formatTooltipTime(actualEndTime)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">实际完成：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      } else {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">实际完成：</span>
            <span class="tooltip-value" style="color: #909399;">未完成</span>
          </div>
        `)
      }
      
      return parts.length > 0 ? parts.join('') : '<div class="tooltip-row">暂无详细信息</div>'
    },
    
    // 获取计划待办数据
    async fetchTaskTodoList() {
      this.taskTodoLoading = true
      try {
        const response = await request.get('/api/plan/task-todo/list', {
          params: {
            start_lead_days: this.taskTodoConfig.startLeadDays,
            allow_empty_start: this.taskTodoConfig.allowEmptyStart ? 1 : 0
          }
        })
        if (response.code === 200) {
          this.taskTodoList = response.data || []
        } else {
          this.$message.error(response.message || '获取计划待办数据失败')
          this.taskTodoList = []
        }
      } catch (error) {
        console.error('获取计划待办数据失败:', error)
        this.$message.error('获取计划待办数据失败')
        this.taskTodoList = []
      } finally {
        this.taskTodoLoading = false
      }
    },
    
    // 加载计划待办配置（从本地缓存）
    loadTaskTodoConfig() {
      try {
        const saved = localStorage.getItem('taskTodoConfig')
        if (saved) {
          const cfg = JSON.parse(saved)
          this.taskTodoConfig.startLeadDays = typeof cfg.startLeadDays === 'number' ? cfg.startLeadDays : 7
          this.taskTodoConfig.allowEmptyStart = !!cfg.allowEmptyStart
        }
      } catch (e) {
        console.error('加载计划待办配置失败:', e)
      }
    },
    
    // 保存计划待办配置（到本地缓存）
    saveTaskTodoConfig() {
      try {
        localStorage.setItem('taskTodoConfig', JSON.stringify(this.taskTodoConfig))
        this.showTaskTodoConfig = false
        this.$message.success('配置保存成功')
        // 重新获取计划待办数据
        this.fetchTaskTodoList()
      } catch (e) {
        console.error('保存计划待办配置失败:', e)
        this.$message.error('配置保存失败')
      }
    },
    
    // 关闭计划待办配置对话框
    handleTaskTodoConfigClose() {
      this.loadTaskTodoConfig()
    },
    
    // 移动端：展开/收起计划操作按钮面板
    toggleTaskActions(index) {
      this.taskTodoActionsOpenIndex = this.taskTodoActionsOpenIndex === index ? null : index
    },
    
    // 显示计划详情
    showPlanInfo(item) {
      this.currentPlanInfo = item.plan_info
      this.showPlanInfoDialog = true
    },
    
    // 获取计划项整体样式类
    getTaskItemClass(item) {
      const classes = []
      if (item.plan_status_value === 0) {
        classes.push('status-not-started-item')
      } else if (item.plan_status_value === 1) {
        classes.push('status-in-progress-item')
      }
      if (item.plan_status_info === 'Delay') {
        classes.push('delay-item')
      }
      return classes.join(' ')
    },
    
    // 获取计划状态样式类
    getTaskStatusClass(status) {
      const classMap = {
        0: 'status-not-started',
        1: 'status-in-progress'
      }
      return classMap[status] || ''
    },
    
    // 获取时间状态样式类
    getTimeStatusClass(statusInfo) {
      const classMap = {
        'Delay': 'time-delay',
        'OnTime': 'time-ontime',
        'Unconfigured': 'time-unconfigured'
      }
      return classMap[statusInfo] || ''
    },
    
    // 获取时间状态文本
    getTimeStatusText(statusInfo) {
      const textMap = {
        'Delay': '超时',
        'OnTime': '正常',
        'Unconfigured': '未设置'
      }
      return textMap[statusInfo] || ''
    },
    
    // 获取“天数”显示文本（根据状态与天数生成描述性文本）
    getTaskDaysText(item) {
      const statusValue = item.plan_status_value // 0 未开始，1 进行中
      const statusInfo = item.plan_status_info   // Delay, OnTime, Unconfigured, ''
      const daysAgo = Number(item.days_ago || 0)
      const absDays = Math.abs(daysAgo)
      
      if (!statusInfo || statusInfo === 'Unconfigured') {
        return '0天'
      }
      
      if (statusValue === 0) {
        // 未开始：基于预计开始时间
        if (statusInfo === 'OnTime') {
          // 未来：daysAgo 为负或 0
          return `距离预计开始时间还有 ${absDays} 天`
        }
        if (statusInfo === 'Delay') {
          // 过去：daysAgo 为正
          return `距离预计开始时间已经超时 ${absDays} 天`
        }
      } else if (statusValue === 1) {
        // 进行中：基于预计完成时间
        if (statusInfo === 'OnTime') {
          return `距离预计完成时间还有 ${absDays} 天`
        }
        if (statusInfo === 'Delay') {
          return `距离预计完成时间已经超时 ${absDays} 天`
        }
      }
      
      // 兜底
      return `${absDays}天`
    },
    
    // 获取“天数”富文本（仅对“xx 天”强调：加粗、字号+2、按状态着色）
    getTaskDaysRichText(item) {
      const plain = this.getTaskDaysText(item)
      const statusInfo = item.plan_status_info
      if (!plain || plain === '0天') return '0天'
      
      // 匹配“数字+空格?+天”，仅包裹数字部分
      const match = plain.match(/(\d+)(\s*天)/)
      if (!match) return plain
      const numberOnly = match[1] // 仅数字
      const suffix = match[2] || '' // "天"（可能带空格）
      // 使用内联样式以兼容 scoped 样式对 v-html 的影响
      let color = ''
      if (statusInfo === 'Delay') color = '#f56c6c'
      else if (statusInfo === 'OnTime') color = '#67c23a'
      const styleAttr = `style="font-weight:700;font-size:16px;${color ? `color:${color};` : ''}"`
      const emphasized = `<span ${styleAttr}>${numberOnly}</span>${suffix}`
      // 仅替换第一个数字出现
      return plain.replace(/(\d+)(\s*天)/, emphasized)
    },
    
    // 开始计划
    async handleTaskStart(item) {
      try {
        await this.$confirm('确认开始该计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await updatePlanStatus(item.plan_code, 1)
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.fetchTaskTodoList()
        } else {
          throw new Error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('操作失败:', error)
          this.$message.error(error.message || '操作失败')
        }
      }
    },
    
    // 暂停计划
    async handleTaskPause(item) {
      try {
        await this.$confirm('确认暂停该计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await updatePlanStatus(item.plan_code, 3)
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.fetchTaskTodoList()
        } else {
          throw new Error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('操作失败:', error)
          this.$message.error(error.message || '操作失败')
        }
      }
    },
    
    // 完成计划
    async handleTaskComplete(item) {
      try {
        await this.$confirm('确认完成该计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await updatePlanStatus(item.plan_code, 2)
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.fetchTaskTodoList()
        } else {
          throw new Error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('操作失败:', error)
          this.$message.error(error.message || '操作失败')
        }
      }
    },
    
    // 终止计划
    async handleTaskTerminate(item) {
      try {
        await this.$confirm('确认终止该计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await updatePlanStatus(item.plan_code, 4)
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.fetchTaskTodoList()
        } else {
          throw new Error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('操作失败:', error)
          this.$message.error(error.message || '操作失败')
        }
      }
    },
    
    // 编辑计划
    async handleTaskEdit(item) {
      try {
        // 尝试获取完整的计划信息
        const response = await getPlanDetail(item.plan_code)
        if (response.code === 200 && response.data) {
          // 使用API返回的完整数据
          this.currentTaskPlan = {
            plan_code: response.data.plan_code,
            plan_name: response.data.plan_name,
            plan_info: response.data.plan_info,
            scheduled_start_time: response.data.scheduled_start_time || '',
            scheduled_end_time: response.data.scheduled_end_time || ''
          }
        } else {
          // 如果API失败，使用计划待办列表中的数据
          this.currentTaskPlan = {
            plan_code: item.plan_code,
            plan_name: item.plan_name,
            plan_info: item.plan_info,
            scheduled_start_time: item.scheduled_start_time || '',
            scheduled_end_time: item.scheduled_end_time || ''
          }
        }
      } catch (error) {
        // 如果API调用失败，使用计划待办列表中的数据
        console.warn('获取计划详情失败，使用计划待办列表中的数据:', error)
        this.currentTaskPlan = {
          plan_code: item.plan_code,
          plan_name: item.plan_name,
          plan_info: item.plan_info,
          scheduled_start_time: item.scheduled_start_time || '',
          scheduled_end_time: item.scheduled_end_time || ''
        }
      }
      this.taskEditDialogVisible = true
    },
    
    // 计划编辑成功回调
    handleTaskEditSuccess() {
      this.taskEditDialogVisible = false
      this.currentTaskPlan = null
      this.fetchTaskTodoList() // 重新获取计划待办列表
    },
    
    // 跳转到题目URL
    handleGoToQuestionUrl(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    
    // 订正待办项
    async handleFixTodo(item) {
      try {
        await this.$confirm('确认将该题目订正分数改为100分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/game/question/${item.question_code}/fix`,
          method: 'put',
          data: {
            question_score_fix: 100
          }
        })
        
        if (res.code === 200) {
          this.$message.success('订正成功')
          // 重新获取数据
          this.fetchFixTodoList()
        } else {
          throw new Error(res.message || '订正失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('订正失败:', error)
          this.$message.error(error.message || '订正失败')
        }
      }
    },
    
    // 订正待办 - 挂起
    async handleFixPending(item) {
      try {
        // 若题目已AC或已订正则不允许挂起
        if (item.question_score === 100 || item.question_score_fix === 100) {
          this.$message.warning('该题目你已经' + (item.question_score === 100 ? 'AC' : '订正') + '，无法挂起。')
          return
        }
        
        await this.$confirm(item.is_pending ? '确认取消挂起该题目吗？' : '确认挂起该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/question/${item.question_code}/pending`,
          method: 'put',
          data: {
            is_pending: !item.is_pending
          }
        })
        
        if (res.code === 200) {
          this.$message.success(item.is_pending ? '取消挂起成功' : '挂起成功')
          // 刷新订正待办列表
          this.fetchFixTodoList()
        } else {
          throw new Error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('挂起操作失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    
    getTagColorByName(tagName) {
      // 使用与题目页面相同的颜色生成逻辑
      const colors = [
        '#409EFF',  // Element UI 主蓝色
        '#67C23A',  // Element UI 成功绿色
        '#E6A23C',  // Element UI 警告黄色
        '#F56C6C',  // Element UI 危险红色
        '#8E44AD',  // 深紫色
        '#16A085',  // 深青色
        '#D35400',  // 深橙色
        '#2980B9',  // 深蓝色
        '#27AE60',  // 深绿色
        '#C0392B'   // 深红色
      ]
      
      // 使用字符串的 hashCode 来选择颜色
      const hashCode = tagName.split('').reduce((acc, char) => {
        return ((acc << 5) - acc) + char.charCodeAt(0)
      }, 0)
      
      return colors[Math.abs(hashCode) % colors.length]
    },

    // 订正待办天数字段文案
    getFixDaysText(item) {
      // 正常：距离超时还有 xx 天；超时：已经超时 xx 天
      const delayDays = this.fixTodoConfig?.delayDays || 7
      const daysAgo = Number(item.days_ago || 0)
      if (item.is_dealy === 'Dealy') {
        const overdue = Math.max(0, daysAgo - delayDays)
        return `已经超时 ${overdue} 天`
      } else {
        const remain = Math.max(0, delayDays - daysAgo)
        return `距离超时还有 ${remain} 天`
      }
    },
    
    // 订正待办天数富文本（仅强调数字、加粗+放大、按状态上色）
    getFixDaysRichText(item) {
      const plain = this.getFixDaysText(item)
      if (!plain) return ''
      const match = plain.match(/(\d+)(\s*天)/)
      if (!match) return plain
      const numberOnly = match[1]
      const suffix = match[2] || ''
      let color = ''
      if (item.is_dealy === 'Dealy') color = '#f56c6c' // 红色
      else color = '#67c23a' // 绿色
      const styleAttr = `style="font-weight:700;font-size:16px;color:${color};"`
      const emphasized = `<span ${styleAttr}>${numberOnly}</span>${suffix}`
      return plain.replace(/(\d+)(\s*天)/, emphasized)
    },
    
    // 更新&复盘待办天数字段文案
    getUpdateReviewTodoDaysText(item) {
      // 正常：距离超时还有 xx 天；超时：已经超时 xx 天
      const delayDays = this.updateReviewTodoConfig?.delayDays || 7
      const daysAgo = Number(item.days_ago || 0)
      if (item.is_dealy === 'Dealy') {
        const overdue = Math.max(0, daysAgo - delayDays)
        return `已经超时 ${overdue} 天`
      } else {
        const remain = Math.max(0, delayDays - daysAgo)
        return `距离超时还有 ${remain} 天`
      }
    },
    
    // 更新&复盘待办天数富文本（仅强调数字、加粗+放大、按状态上色）
    getUpdateReviewTodoDaysRichText(item) {
      const plain = this.getUpdateReviewTodoDaysText(item)
      if (!plain) return ''
      const match = plain.match(/(\d+)(\s*天)/)
      if (!match) return plain
      const numberOnly = match[1]
      const suffix = match[2] || ''
      let color = ''
      if (item.is_dealy === 'Dealy') color = '#f56c6c' // 红色
      else color = '#67c23a' // 绿色
      const styleAttr = `style="font-weight:700;font-size:16px;color:${color};"`
      const emphasized = `<span ${styleAttr}>${numberOnly}</span>${suffix}`
      return plain.replace(/(\d+)(\s*天)/, emphasized)
    },

    normalizeErrors(errors) {
      if (!errors) return []
      if (Array.isArray(errors)) return errors
      try {
        const arr = JSON.parse(errors)
        return Array.isArray(arr) ? arr : []
      } catch (e) { return [] }
    },

    // 获取用户信息
    async fetchUserInfo() {
      try {
        const { data } = await request.get('/api/user/info')
        if (data) {
          this.username = data.name || data.username  // 优先显示真实姓名，其次是用户名
          this.checkInDays = data.clock_in || 0
          
          // 用户信息获取成功后启动头部滚动
          this.$nextTick(() => {
            this.startHeaderScroll();
          });
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 即使获取失败，也启动滚动，此时可能显示空用户名
        this.$nextTick(() => {
          this.startHeaderScroll();
        });
      }
    },

    // 检查今日打卡状态
    async checkTodayStatus() {
      try {
        const { data } = await request.get('/api/user/check-in/status')
        console.log('获取到的打卡状态:', data)  // 添加日志
        this.todayCheckedIn = data.checked_in
        if (this.todayCheckedIn && data.fortune) {
          console.log('今日运势数据:', data.fortune)  // 添加日志
          this.todayFortune = data.fortune
        }
      } catch (error) {
        console.error('检查打卡状态失败:', error)
      }
    },

    // 生成骚话
    generateComment(activity) {
      if (!activity) return ''
      // 如果是特殊文本，不生成骚话
      if (activity === '百无禁忌' || activity === '诸事不宜') return ''
      
      // 判断是宜还是忌的骚话
      const type = activity === this.todayFortune?.bad ? 'bad' : 'good'
      const comments = COMMENTS[type]
      return comments[Math.floor(Math.random() * comments.length)]
    },

    // 生成今日运势
    generateFortune() {
      const random = Math.random()
      let sum = 0
      let selectedLevel = FORTUNE_LEVELS[FORTUNE_LEVELS.length - 1]

      for (const fortune of FORTUNE_LEVELS) {
        sum += fortune.probability
        if (random <= sum) {
          selectedLevel = fortune
          break
        }
      }

      // 随机选择宜忌
      const activities = [...ACTIVITIES]
      const shuffled = activities.sort(() => Math.random() - 0.5)
      let good = shuffled[0]
      let bad = shuffled[1]

      // 特殊处理大吉和大凶
      if (selectedLevel.level === '大吉') {
        bad = '百无禁忌'
      } else if (selectedLevel.level === '大凶') {
        good = '诸事不宜'
      }

      // 生成骚话
      const goodComment = selectedLevel.level === '大凶' ? '' : COMMENTS.good[Math.floor(Math.random() * COMMENTS.good.length)]
      const badComment = selectedLevel.level === '大吉' ? '' : COMMENTS.bad[Math.floor(Math.random() * COMMENTS.bad.length)]

      const fortune = {
        level: selectedLevel.level,
        good,
        bad,
        goodComment,
        badComment
      }

      // 设置为当前运势，以便 generateComment 方法使用
      this.todayFortune = fortune
      return fortune
    },

    // 处理打卡
    async handleCheckIn() {
      if (this.checkingIn) return
      this.checkingIn = true

      try {
        const fortune = this.generateFortune()
        console.log('生成的运势数据:', fortune)  // 添加日志
        const response = await request({
          url: '/api/user/check-in',
          method: 'post',
          data: { fortune }
        })

        console.log('打卡响应:', response)  // 添加日志
        if (response.code === 200) {
          this.todayCheckedIn = true
          this.todayFortune = fortune
          this.checkInDays += 1
          this.$message.success('打卡成功')
        } else {
          throw new Error(response.message || '打卡失败')
        }
      } catch (error) {
        console.error('打卡失败:', error)
        this.$message.error(error.message || '打卡失败，请重试')
      } finally {
        this.checkingIn = false
      }
    },

    // 获取大事记数据
    async fetchGreatEvents() {
      this.eventsLoading = true;
      try {
        const response = await getVisibleGreatEvents(100) // 获取前100条记录
        if (Array.isArray(response)) {
          this.greatEvents = response;
        } else if (response && Array.isArray(response.data)) {
          this.greatEvents = response.data;
        } else {
          this.greatEvents = [];
          console.warn('未获取到有效的大事记数据:', response);
        }
        
        // 获取数据后同步高度并初始化滚动
        this.$nextTick(() => {
          this.syncGreatEventsHeight();
          this.initializeScroll();
        });
      } catch (error) {
        console.error('获取大事记失败:', error);
        this.greatEvents = [];
      } finally {
        this.eventsLoading = false;
      }
    },
    
    // 初始化滚动
    initializeScroll() {
      // 检查是否有足够内容需要滚动
      const container = this.$el.querySelector('.events-container');
      const contentList = this.$el.querySelector('.events-list');
      
      if (container && contentList) {
        // 检查内容高度是否超过容器高度
        const contentHeight = contentList.scrollHeight;
        const containerHeight = container.clientHeight;
        
        // 当内容高度大于容器高度时才启用自动滚动
        if (contentHeight > containerHeight) {
          // 实现无缝滚动：复制内容
          this.cloneEventsForInfiniteScroll();
          
          // 根据内容长度调整滚动速度
          this.adjustScrollSpeed(contentHeight, containerHeight);
          this.startAutoScroll();
        } else if (this.greatEvents.length > 1) {
          // 内容不够长但有多条记录时，复制更多次以填满滚动区域
          this.cloneEventsMultipleTimes(containerHeight, contentHeight);
          this.adjustScrollSpeed(containerHeight * 1.5, containerHeight);
          this.startAutoScroll();
        }
      }
    },
    
    // 根据需要多次复制内容以填满滚动区域
    cloneEventsMultipleTimes(containerHeight, contentHeight) {
      const contentList = this.$el.querySelector('.events-list');
      if (!contentList || this.greatEvents.length === 0) return;
      
      // 计算需要复制的次数，至少复制3次以确保循环流畅
      const requiredHeight = containerHeight * 2; // 至少是容器高度的2倍
      let cloneCount = Math.max(3, Math.ceil(requiredHeight / contentHeight));
      
      // 获取所有事件项
      const eventItems = contentList.querySelectorAll('.event-item');
      if (!eventItems.length) return;
      
      // 复制多次
      for (let j = 0; j < cloneCount; j++) {
        for (let i = 0; i < eventItems.length; i++) {
          const clone = eventItems[i].cloneNode(true);
          clone.setAttribute('data-clone', 'true');
          clone.setAttribute('data-clone-group', j.toString());
          contentList.appendChild(clone);
        }
      }
    },
    
    // 复制事件内容用于无缝滚动
    cloneEventsForInfiniteScroll() {
      const contentList = this.$el.querySelector('.events-list');
      if (!contentList || this.greatEvents.length === 0) return;
      
      // 获取所有原始事件项（非克隆）
      const originalEventItems = contentList.querySelectorAll('.event-item:not([data-clone="true"])');
      if (!originalEventItems.length) return;
      
      // 复制所有事件项并添加到列表末尾，实现无缝循环效果
      for (let i = 0; i < originalEventItems.length; i++) {
        const clone = originalEventItems[i].cloneNode(true);
        clone.setAttribute('data-clone', 'true'); // 标记为克隆项
        contentList.appendChild(clone);
      }
    },
    
    // 根据内容长度调整滚动速度
    adjustScrollSpeed(contentHeight, containerHeight) {
      // 计算滚动内容与容器的比例
      const ratio = contentHeight / containerHeight;
      
      // 根据比例调整滚动速度，速度略微降低确保阅读体验
      if (ratio > 3) {
        // 内容很长，适中速度
        this.scrollSpeed = 0.7;
      } else if (ratio > 2) {
        // 内容较长，较慢速度
        this.scrollSpeed = 0.5;
      } else {
        // 内容适中，慢速
        this.scrollSpeed = 0.3;
      }
    },
    
    // 启动自动滚动
    startAutoScroll() {
      // 清除已有定时器
      this.stopAutoScroll();
      
      const container = this.$el.querySelector('.events-container');
      const contentList = this.$el.querySelector('.events-list');
      
      if (!container || !contentList) return;
      
      // 确保从头开始滚动
      this.currentScrollPosition = 0;
      container.scrollTop = 0;
      
      // 创建新定时器
      this.autoScrollInterval = setInterval(() => {
        // 暂停时不滚动
        if (this.pauseScroll) return;
        
        // 获取原始内容高度（未克隆的第一组内容）
        const originalItems = contentList.querySelectorAll('.event-item:not([data-clone="true"])');
        if (originalItems.length === 0) return;
        
        let originalContentHeight = 0;
        const lastOriginalItem = originalItems[originalItems.length - 1];
        originalContentHeight = lastOriginalItem.offsetTop + lastOriginalItem.offsetHeight;
        
        // 如果原始内容高度为0，则停止滚动
        if (originalContentHeight <= 0) return;
        
        // 增加滚动位置
        this.currentScrollPosition += this.scrollSpeed;
        
        // 当滚动到原始内容的末尾时，立即回到顶部继续滚动
        if (this.currentScrollPosition >= originalContentHeight) {
          // 回到顶部，但保持一点偏移，使过渡更自然
          this.currentScrollPosition = 0;
        }
        
        // 应用滚动位置
        container.scrollTop = this.currentScrollPosition;
      }, 16); // 使用16ms（约60fps）获得更平滑的滚动体验
    },
    
    // 停止自动滚动
    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    },
    
    // 暂停滚动（鼠标悬停时）
    pauseScrolling() {
      this.pauseScroll = true;
    },
    
    // 恢复滚动（鼠标离开时）
    resumeScrolling() {
      this.pauseScroll = false;
    },
    
    // 同步大事记和每日X订高度与友情链接区域
    syncGreatEventsHeight() {
      const eventsSection = this.$el.querySelector('.great-events-section');
      const eventsCard = this.$el.querySelector('.great-events-card-bottom');
      const dailyFixSection = this.$el.querySelector('.daily-fix-section-in-bottom');
      const dailyFixCard = this.$el.querySelector('.daily-fix-card-bottom');
      
      // 移动端：清除inline样式，让CSS接管
      if (this.isMobileDevice) {
        if (eventsSection) eventsSection.style.height = '';
        if (eventsCard) eventsCard.style.height = '';
        if (dailyFixSection) dailyFixSection.style.height = '';
        if (dailyFixCard) dailyFixCard.style.height = '';
        console.log('移动端：清除高度样式');
        return;
      }
      
      // PC端：使用固定高度414px（5行友情链接的高度）
      const fixedHeight = 414; // 固定高度：5 * 70px + 4 * 16px = 414px
      
      // 设置固定高度
      if (eventsSection) {
        eventsSection.style.height = `${fixedHeight}px`;
      }
      if (eventsCard) {
        eventsCard.style.height = `${fixedHeight}px`;
      }
      if (dailyFixSection) {
        dailyFixSection.style.height = `${fixedHeight}px`;
      }
      if (dailyFixCard) {
        dailyFixCard.style.height = `${fixedHeight}px`;
      }
      
      console.log('PC端：已设置固定高度', fixedHeight + 'px');
    },
    
    // 格式化大事记时间
    formatEventTime(timeString) {
      if (!timeString) return ''
      const date = new Date(timeString)
      return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`
    },
    
    // 在新标签页中打开博客链接（保留此方法，因为在欢迎卡片中仍然需要使用）
    openBlogInNewTab() {
      const url = `${window.location.origin}/blog`;
      window.open(url, '_blank');
    },
    getErrorOutlineStyle,
    
    // 获取更新&复盘待办note类型样式
    getUpdateReviewTodoNoteStyle(note) {
      if (!note || !Array.isArray(note) || note.length === 0) return {}
      
      // 优先级：NOREP > NOLEVEL > NOERR > NOTAG
      if (note.includes('NOREP')) {
        return { backgroundColor: '#fef0f0', borderColor: '#f56c6c', color: '#f56c6c' }
      } else if (note.includes('NOLEVEL')) {
        return { backgroundColor: '#fdf6ec', borderColor: '#e6a23c', color: '#e6a23c' }
      } else if (note.includes('NOERR')) {
        return { backgroundColor: '#f0f9ff', borderColor: '#409eff', color: '#409eff' }
      } else if (note.includes('NOTAG')) {
        return { backgroundColor: '#f4f4f5', borderColor: '#909399', color: '#909399' }
      }
      return {}
    },
    
    // 获取更新&复盘待办note类型文本
    getUpdateReviewTodoNoteText(note) {
      if (!note || !Array.isArray(note) || note.length === 0) return '未知'
      
      const textMap = {
        'NOREP': '未复盘',
        'NOLEVEL': '无题目难度',
        'NOERR': '无错误类型',
        'NOTAG': '无标签'
      }
      
      // 返回第一个匹配的文本，如果有多个则用逗号分隔
      return note.map(n => textMap[n] || n).join('、')
    },
    
    // 单个note标签文本
    getUpdateReviewTodoSingleNoteText(n) {
      const textMap = {
        'NOREP': '未复盘',
        'NOLEVEL': '无题目难度',
        'NOERR': '无错误类型',
        'NOTAG': '无标签'
      }
      return textMap[n] || n
    },
    
    // 获取更新&复盘待办tooltip内容
    getUpdateReviewTodoTooltipHtml(item) {
      const parts = []
      const isGame = item.type === 'game'
      
      // 数据类型（移动到第一行）
      if (item.type) {
        const typeText = isGame ? '赛事' : '题目'
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">数据类型：</span>
            <span class="tooltip-value">${typeText}</span>
          </div>
        `)
      }

      // 待办事宜（第二行显示，带样式标签）
      if (item.note && Array.isArray(item.note) && item.note.length > 0) {
        const noteHtml = item.note.map(n => {
          const style = this.getUpdateReviewTodoNoteStyle([n]) || {}
          const bg = style.backgroundColor || '#f4f4f5'
          const border = style.borderColor || '#909399'
          const color = style.color || '#909399'
          const text = this.getUpdateReviewTodoSingleNoteText(n)
          return `<span style="display:inline-block;margin:0 6px 4px 0;padding:2px 6px;border-radius:4px;font-size:11px;background-color:${bg};border:1px solid ${border};color:${color};">${text}</span>`
        }).join('')
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">待办事宜：</span>
            <span class="tooltip-value">${noteHtml}</span>
          </div>
        `)
      }

      // 名称（根据类型显示不同的标签）— 移到第三行
      if (item.name) {
        const nameLabel = isGame ? '赛事名称' : '题目名称'
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">${nameLabel}：</span>
            <span class="tooltip-value">${item.name}</span>
          </div>
        `)
      }
      
      // 题目数据：在题目名称下方显示赛事名称
      if (!isGame && item.game_name) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">赛事名称：</span>
            <span class="tooltip-value">${item.game_name}</span>
          </div>
        `)
      }
      
      // 难度/级别（根据类型显示不同的标签）
      if (item.level) {
        const levelLabel = isGame ? '赛事级别' : '题目难度'
        const levelColor = this.getDifficultyColor(item.level)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">${levelLabel}：</span>
            <span class="tooltip-difficulty-tag" style="background-color: ${levelColor}; color: white; padding: 2px 6px; border-radius: 4px; font-size: 12px; display: inline-block;">
              ${item.level}
            </span>
          </div>
        `)
      }
      
      // 分数（根据类型使用不同的颜色计算方式）
      if (isGame) {
        // 赛事数据：使用questionNum计算百分比
        // 如果question_num不存在或为0，尝试从score估算（假设每100分为1题），或者使用默认值1
        let questionNum = item.question_num
        if (!questionNum || questionNum === 0) {
          // 如果question_num不存在，尝试从score估算题目数量（向上取整）
          const estimatedFromScore = Math.max(1, Math.ceil((item.score || 0) / 100))
          const estimatedFromScoreFix = Math.max(1, Math.ceil((item.score_fix || 0) / 100))
          questionNum = Math.max(estimatedFromScore, estimatedFromScoreFix, 1) // 至少1题
        }
        const scoreColor = this.getGameScoreColor(item.score || 0, questionNum)
        const scoreFixColor = this.getGameScoreColor(item.score_fix || 0, questionNum)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">分数：</span>
            <span class="tooltip-value">
              <span style="color: ${scoreColor}; font-weight: bold;">${item.score || 0}</span>
              <span>/</span>
              <span style="color: ${scoreFixColor}; font-weight: bold;">${item.score_fix || 0}</span>
            </span>
          </div>
        `)
      } else {
        // 题目数据：保持原有逻辑
      parts.push(`
        <div class="tooltip-row">
          <span class="tooltip-label">分数：</span>
          <span class="tooltip-value">
            <span style="color: ${this.getScoreColor(item.score)}; font-weight: bold;">${item.score}</span>
            <span>/</span>
            <span style="color: ${this.getScoreColor(item.score_fix)}; font-weight: bold;">${item.score_fix}</span>
          </span>
        </div>
      `)
      }
      
      // 天数
      if (item.days_ago !== undefined && item.days_ago !== null) {
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">天数：</span>
            <span class="tooltip-value">${item.days_ago}天</span>
          </div>
        `)
      }
      
      // 状态
      if (item.is_dealy) {
        const statusText = item.is_dealy === 'Dealy' ? '超时' : '正常'
        const statusColor = item.is_dealy === 'Dealy' ? '#f56c6c' : '#67c23a'
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">状态：</span>
            <span style="color: ${statusColor}; font-weight: bold;">${statusText}</span>
          </div>
        `)
      }
      
      // 时间
      if (item.time) {
        const formattedTime = this.formatTooltipTime(item.time)
        parts.push(`
          <div class="tooltip-row">
            <span class="tooltip-label">时间：</span>
            <span class="tooltip-value">${formattedTime}</span>
          </div>
        `)
      }

      // 题目数据：在最后增加 标签 与 错误类型（兼容多种字段）
      if (!isGame) {
        // 标签：优先使用数组字段 item.tags；其次使用逗号分隔字符串 item.tag_name
        let tagList = []
        if (Array.isArray(item.tags)) {
          tagList = item.tags
        } else if (typeof item.tag_name === 'string' && item.tag_name.trim()) {
          tagList = this.getTagList(item.tag_name)
        }
        if (tagList.length) {
          const tagHtml = tagList.map(tag => {
            const tagColor = this.getTagColorByName(tag)
            return `<span class="tooltip-tag" style="background-color: ${tagColor}; color: white; padding: 2px 6px; border-radius: 4px; font-size: 11px; display: inline-block; margin-right: 4px; margin-bottom: 4px;">${tag}</span>`
          }).join('')
          parts.push(`
            <div class="tooltip-row">
              <span class="tooltip-label">标签：</span>
              <div style="display: inline-block; line-height: 1.8;">${tagHtml}</div>
            </div>
          `)
        }
        // 错误类型：优先数组 item.errors；其次 JSON 字符串；再次逗号分隔名称 item.error_name
        let errorNames = []
        if (Array.isArray(item.errors)) {
          errorNames = item.errors.map(e => e.error_name || e).filter(Boolean)
        } else if (typeof item.errors === 'string') {
          const parsed = this.normalizeErrors(item.errors)
          errorNames = parsed.map(e => e.error_name || e).filter(Boolean)
        } else if (typeof item.error_name === 'string' && item.error_name.trim()) {
          errorNames = this.getErrorList(item.error_name)
        }
        if (errorNames.length) {
          const errorHtml = errorNames.map(errorName => {
            const style = getErrorOutlineStyle(errorName)
            return `<span class="tooltip-error" style="background-color: ${style.backgroundColor}; border: 1px solid ${style.borderColor}; color: ${style.color}; padding: 2px 6px; border-radius: 4px; font-size: 11px; display: inline-block; margin-right: 4px; margin-bottom: 4px;">
              <i class="el-icon-warning" style="margin-right: 4px;"></i>${errorName}
            </span>`
          }).join('')
          parts.push(`
            <div class="tooltip-row">
              <span class="tooltip-label">错误类型：</span>
              <div style="display: inline-block; line-height: 1.8;">${errorHtml}</div>
            </div>
          `)
        }
      }
      
      // URL
      // 不显示链接地址
      
      return parts.length > 0 ? parts.join('') : '<div class="tooltip-row">暂无详细信息</div>'
    },
    
    // 跳转到 URL
    handleGoToUrl(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    
    // 处理复盘按钮（跳转到game页面）
    handleReview(item) {
      if (item.code) {
        // 跳转到game页面，可以通过game_code查询到对应的赛事
        this.$router.push({
          path: '/game',
          query: { game_code: item.code }
        })
      }
    },
    
    // 处理编辑按钮（跳转到题目页面）
    handleUpdateReviewEdit(item) {
      if (item.code) {
        // 跳转到题目页面，可以通过question_code查询到对应的题目
        this.$router.push({
          path: '/question',
          query: { question_code: item.code }
        })
      }
    },
    
    // 打开复盘弹窗
    async openReplayDialog(item) {
      try {
        console.log('打开复盘弹窗，item:', item)
        if (!item || item.type !== 'game' || !item.code) {
          this.$message.warning('无效的赛事数据')
          return
        }
        
        // 1. 获取题目列表（这是必需的）
        console.log('开始获取题目列表，game_code:', item.code)
        const questionsRes = await getQuestions(item.code)
        console.log('获取题目列表响应:', questionsRes)
        
        if (questionsRes.code !== 200) {
          this.$message.error(questionsRes.message || '获取题目列表失败')
          return
        }
        
        const questions = questionsRes.data || []
        console.log('题目列表:', questions)
        
        if (questions.length === 0) {
          this.$message.warning('未找到题目信息')
          return
        }
        
        // 2. 尝试获取完整的游戏信息（用于获取 game_type, rank, parameter_number 等字段）
        let fullGameInfo = null
        try {
          console.log('开始获取完整游戏信息')
          const gameListRes = await getGameList({
            pageNum: 1,
            pageSize: 100, // 获取更多数据以便查找
            sort_prop: 'game_time',
            sort_order: 'descending'
          })
          console.log('获取游戏列表响应:', gameListRes)
          
          if (gameListRes.code === 200 && gameListRes.data && gameListRes.data.items) {
            fullGameInfo = gameListRes.data.items.find(g => g.game_code === item.code)
            console.log('找到完整游戏信息:', fullGameInfo)
          }
        } catch (error) {
          console.warn('获取完整游戏信息失败，使用基本信息:', error)
        }
        
        // 3. 计算总分
        const totalScore = questions.reduce((sum, q) => sum + (parseInt(q.question_score) || 0), 0)
        console.log('计算总分:', totalScore)
        
        // 4. 构建完整的 gameInfo 对象
        const gameInfo = {
          game_code: item.code,
          game_name: item.name || fullGameInfo?.game_name || '',
          game_level: item.level || fullGameInfo?.game_level || '',
          game_type: fullGameInfo?.game_type || '',
          game_time: item.time || fullGameInfo?.game_time || '',
          total_score: totalScore,
          rank: fullGameInfo?.rank || 0,
          parameter_number: fullGameInfo?.parameter_number || 0,
          questions: questions.map(q => ({
            question_code: q.question_code,
            question_seq: q.question_seq,
            question_name: q.question_name,
            question_score: q.question_score,
            question_score_fix: q.question_score_fix,
            tags: q.tags || [],
            error_codes: q.error_codes || []
          }))
        }
        
        console.log('构建的 gameInfo:', gameInfo)
        
        // 5. 先设置 gameInfo，确保组件能被创建
        // 注意：此时 updateReviewReplayVisible 应该是 false（初始值），这样组件创建时 visible prop 是 false
        this.updateReviewCurrentGame = gameInfo
        
        // 6. 使用 $nextTick 确保组件已经创建并完成初始化
        await this.$nextTick()
        
        // 7. 现在设置 visible 为 true，触发 watch，对话框会显示
        console.log('设置 updateReviewReplayVisible = true')
        this.updateReviewReplayVisible = true
        
        // 8. 再次使用 $nextTick 确保对话框已经完全显示
        await this.$nextTick()
        console.log('当前状态 - updateReviewReplayVisible:', this.updateReviewReplayVisible)
        console.log('当前状态 - updateReviewCurrentGame:', this.updateReviewCurrentGame)
      } catch (error) {
        console.error('打开复盘弹窗失败:', error)
        this.$message.error('打开复盘弹窗失败: ' + (error.message || '未知错误'))
      }
    },
    
    // 打开编辑弹窗
    async openEditDialog(item) {
      try {
        if (!item || item.type !== 'question' || !item.code) return
        
        // 使用后端返回的数据构建完整的question对象
        this.updateReviewCurrentQuestion = {
          question_code: item.code,
          question_name: item.name || '',
          question_level: item.level || '',
          question_score: item.score || 0,
          question_score_fix: item.score_fix || 0,
          question_seq: item.question_seq || '',
          question_url: item.url || '',
          note: item.question_note || '',
          game_code: item.game_code || ''
        }
        
        // 如果缺少game_code，需要通过API获取题目的完整信息
        if (!this.updateReviewCurrentQuestion.game_code) {
          try {
            // 通过game/questions API获取题目详情（需要知道game_code）
            // 如果后端没有返回game_code，这里需要通过其他方式获取
            // 暂时先使用已有的数据，如果QuestionDialog内部需要，会通过question_code查询
            console.warn('缺少game_code，可能无法正常编辑题目')
          } catch (error) {
            console.error('获取题目信息失败:', error)
          }
        }
        
        this.updateReviewEditVisible = true
      } catch (e) {
        console.error('打开编辑弹窗失败:', e)
        this.$message.error('打开编辑弹窗失败')
      }
    },
    
    // 启动头部标题滚动
    startHeaderScroll() {
      if (this.headerScrollInterval) {
        clearInterval(this.headerScrollInterval);
      }
      
      const scrollElement = this.$refs.scrollText;
      if (!scrollElement) return;
      
      // 获取容器宽度
      const containerWidth = scrollElement.parentNode.offsetWidth;
      
      // 先清空内容，然后重新设置，确保用户名是最新的
      const originalContent = `欢迎尊贵的 <span class="crown-text"><span class="crown-emoji">👑</span>${this.username}</span> 来到 OIer 之路`;
      scrollElement.innerHTML = originalContent;
      
      // 等待DOM更新后再复制内容
      this.$nextTick(() => {
        // 获取原始内容的实际宽度
        const originalWidth = scrollElement.offsetWidth;
        
        // 计算需要的空白数量，确保第一段完全离开视野
        const spaceNeeded = Math.max(containerWidth, originalWidth);
        const spacesCount = Math.ceil(spaceNeeded / 8); // 一个&nbsp;大约8px宽
        
        // 添加足够的空白，然后是第二份内容
        scrollElement.innerHTML = originalContent + '&nbsp;'.repeat(spacesCount) + originalContent;
        
        // 设置初始位置
        let scrollPosition = 0;
        const scrollSpeed = 0.8; // 滚动速度
        
        this.headerScrollInterval = setInterval(() => {
          if (!scrollElement) return;
          
          // 获取第一段内容的宽度（包括空白）
          const firstSegmentWidth = originalWidth + (spacesCount * 8);
          
          // 增加滚动位置
          scrollPosition += scrollSpeed;
          
          // 当第一段文字完全滚动出视野后，重置位置
          if (scrollPosition >= firstSegmentWidth) {
            // 立即重置到开始位置
            scrollPosition = 0;
          }
          
          // 应用滚动位置
          scrollElement.style.transform = `translateX(-${scrollPosition}px)`;
        }, 30); // 每30ms滚动一次，使滚动更平滑
      });
    },
    
    // 停止头部标题滚动
    stopHeaderScroll() {
      if (this.headerScrollInterval) {
        clearInterval(this.headerScrollInterval);
        this.headerScrollInterval = null;
      }
    },
    
    // ========== Skip功能相关方法 ==========
    
    // 处理info icon点击（连续5次触发skip按钮）
    handleInfoIconClick(item, index, type) {
      const key = `${type}-${index}`
      const now = Date.now()
      
      // 获取或初始化点击记录
      if (!this.infoClickCounts[key]) {
        this.infoClickCounts[key] = { count: 0, lastTime: 0 }
      }
      
      const record = this.infoClickCounts[key]
      
      // 如果距离上次点击超过3秒，重置计数
      if (now - record.lastTime > 3000) {
        record.count = 0
      }
      
      // 增加点击次数
      record.count++
      record.lastTime = now
      
      // 如果达到5次，显示skip按钮
      if (record.count >= 5) {
        this.$set(this.showSkipButtons, key, true)
        // 重置计数
        record.count = 0
      }
    },
    
    // 打开skip确认对话框
    openSkipDialog(item, index, type) {
      this.skipDialogItem = { ...item, _index: index, _type: type }
      this.skipDialogType = type
      this.skipReason = ''
      this.skipCustomReason = ''
      this.showSkipDialog = true
    },
    
    // 选择预设原因
    selectPresetReason(reason) {
      this.skipReason = reason
      this.skipCustomReason = ''
    },
    
    // 确认skip
    async confirmSkip() {
      // 验证原因
      if (!this.skipReason && !this.skipCustomReason) {
        this.$message.warning('请选择或输入跳过原因')
        return
      }
      
      const reason = this.skipCustomReason || this.skipReason
      if (reason.length > 50) {
        this.$message.warning('跳过原因不能超过50字符')
        return
      }
      
      try {
        // 确定todo_type和skip_code
        let todoType = 0
        let skipCode = ''
        let skipInfo = ''
        
        if (this.skipDialogType === 'update-review') {
          todoType = 1
          skipCode = this.skipDialogItem.code || ''
          // 更新&复盘：在skip_info中包含类型信息（G/P）和标签信息
          const typeBadge = this.skipDialogItem.type === 'game' ? 'G' : 'P'
          const name = this.skipDialogItem.name || ''
          // 获取标签信息
          const notes = this.skipDialogItem.note || []
          // 格式：G 名称 |NOREP,NOTAG| 或 P 名称 |NOTAG,NOLEVEL|
          if (notes.length > 0) {
            skipInfo = `${typeBadge} ${name} |${notes.join(',')}|`
          } else {
            skipInfo = `${typeBadge} ${name}`
          }
        } else if (this.skipDialogType === 'fix') {
          todoType = 2
          skipCode = this.skipDialogItem.question_code || ''
          // 订正：在skip_info中包含题目难度、赛事名称和分数信息
          const questionLevel = this.skipDialogItem.question_level || '未定义'
          const gameName = this.skipDialogItem.game_name || ''
          const questionName = this.skipDialogItem.question_name || ''
          const questionScore = this.skipDialogItem.question_score || 0
          const questionScoreFix = this.skipDialogItem.question_score_fix || 0
          
          // 格式：[难度] 名称 |分数/订正分数|
          const namePart = gameName ? `${gameName} - ${questionName}` : questionName
          skipInfo = `[${questionLevel}] ${namePart} |${questionScore}/${questionScoreFix}|`
        } else if (this.skipDialogType === 'task') {
          todoType = 3
          skipCode = this.skipDialogItem.plan_code || ''
          // 计划待办：在skip_info中包含计划名称和任务状态
          const planName = this.skipDialogItem.plan_name || ''
          const planStatus = this.skipDialogItem.plan_status || ''
          const planStatusValue = this.skipDialogItem.plan_status_value !== undefined ? this.skipDialogItem.plan_status_value : null
          
          // 格式：计划名称 |状态,状态值|
          if (planStatus && planStatusValue !== null) {
            skipInfo = `${planName} |${planStatus},${planStatusValue}|`
          } else {
            skipInfo = planName
          }
        }
        
        if (!skipCode) {
          this.$message.error('无法获取待办编号')
          return
        }
        
        // 调用API添加skip记录
        const response = await addTodoSkip({
          todo_type: todoType,
          skip_code: skipCode,
          skip_info: skipInfo,
          skip_reason: reason
        })
        
        if (response.code === 200) {
          this.$message.success('跳过成功')
          this.showSkipDialog = false
          
          // 隐藏skip按钮（使用保存的索引）
          if (this.skipDialogItem._index !== undefined) {
            const key = `${this.skipDialogType}-${this.skipDialogItem._index}`
            this.$set(this.showSkipButtons, key, false)
          }
          
          // 重新获取待办列表
          if (this.skipDialogType === 'update-review') {
            this.fetchUpdateReviewTodoList()
          } else if (this.skipDialogType === 'fix') {
            this.fetchFixTodoList()
          } else if (this.skipDialogType === 'task') {
            this.fetchTaskTodoList()
          }
        } else {
          throw new Error(response.message || '跳过失败')
        }
      } catch (error) {
        console.error('跳过失败:', error)
        this.$message.error(error.message || '跳过失败')
      }
    },
    
    // 打开View Skip对话框
    async openViewSkipDialog(todoType) {
      this.viewSkipType = todoType
      this.showViewSkipDialog = true
      this.skipList = [] // 先清空列表
      this.skipListLoading = true // 开始加载
      
      try {
        const response = await getTodoSkipList(todoType)
        if (response.code === 200) {
          this.skipList = response.data || []
        } else {
          this.$message.error(response.message || '获取跳过列表失败')
          this.skipList = []
        }
      } catch (error) {
        console.error('获取跳过列表失败:', error)
        this.$message.error('获取跳过列表失败')
        this.skipList = []
      } finally {
        this.skipListLoading = false // 加载完成
      }
    },
    
    // 打开放大查看对话框
    openExpandDialog(todoType) {
      this.expandDialogType = todoType
      this.expandDialogVisible = true
      // 重置溢出状态
      this.expandDialogContentOverflow = false
    },
    
    // 处理放大对话框打开后的事件
    handleExpandDialogOpened() {
      this.$nextTick(() => {
        // 检测内容是否超过最大高度
        const contentEl = this.$refs.expandTodoContent
        if (contentEl) {
          const maxHeight = window.innerHeight * 0.75 - 120 // 75vh - 120px (上10%，下20%，标题和padding)
          const actualHeight = contentEl.scrollHeight
          this.expandDialogContentOverflow = actualHeight > maxHeight
        }
      })
    },
    
    // 获取放大对话框标题
    getExpandDialogTitle(todoType) {
      const typeMap = {
        1: '更新&复盘待办',
        2: '订正待办',
        3: '计划待办'
      }
      return typeMap[todoType] || '待办'
    },
    
    // 获取放大对话框内容区域的类名
    getExpandContentClass(todoType) {
      const classMap = {
        1: 'expand-update-review-content',
        2: 'expand-fix-content',
        3: 'expand-task-content'
      }
      return classMap[todoType] || ''
    },
    
    // 获取待办类型文本
    getTodoTypeText(todoType) {
      const typeMap = {
        1: '更新&复盘',
        2: '订正',
        3: '计划'
      }
      return typeMap[todoType] || '未知'
    },
    
    // 获取skip列表项的名称（去除标签部分）
    getSkipItemName(item) {
      if (!item.skip_info) return ''
      
      // 格式：G 名称 |NOREP,NOTAG| 或 P 名称 |NOTAG,NOLEVEL| 或 [难度] 名称 |分数/订正分数| 或 计划名称 |状态,状态值|
      // 先去除标签部分（|...|）
      let name = item.skip_info.replace(/\|[^|]+\|/g, '').trim()
      
      // 如果是更新&复盘待办（G或P开头）
      if (name.startsWith('G ') || name.startsWith('P ')) {
        return name.substring(2).trim()
      }
      
      // 如果包含[标签]格式，提取标签后的内容（订正待办）
      const match = name.match(/\[([^\]]+)\]\s*(.+)/)
      if (match) {
        return match[2] || name
      }
      
      // 计划待办直接返回（已经去除了状态信息）
      return name
    },
    
    // 获取skip列表项的待办标签（更新&复盘待办）
    getSkipItemTodoTags(item) {
      if (!item.skip_info) return []
      
      // 从skip_info中解析标签信息
      // 格式：[复盘] 名称 |NOREP,NOTAG| 或 [更新] 名称 |NOTAG,NOLEVEL|
      const match = item.skip_info.match(/\|([^|]+)\|/)
      if (match && match[1]) {
        // 解析标签字符串，例如 "NOREP,NOTAG" -> ['NOREP', 'NOTAG']
        const tags = match[1].split(',').map(tag => tag.trim()).filter(tag => tag)
        return tags
      }
      
      return []
    },
    
    // 获取skip列表项的分数信息（订正待办）
    getSkipItemScores(item) {
      if (!item.skip_info) return null
      
      // 从skip_info中解析分数信息
      // 格式：[难度] 名称 |分数/订正分数|
      const match = item.skip_info.match(/\|([^|]+)\|/)
      if (match && match[1]) {
        const scoreStr = match[1]
        // 解析分数字符串，例如 "80/100" -> { score: 80, scoreFix: 100 }
        const scoreMatch = scoreStr.match(/(\d+)\/(\d+)/)
        if (scoreMatch) {
          return {
            score: parseInt(scoreMatch[1], 10),
            scoreFix: parseInt(scoreMatch[2], 10)
          }
        }
      }
      
      return null
    },
    
    // 获取skip列表项的题目名称（订正待办）
    getSkipItemQuestionName(item) {
      if (!item.skip_info) return ''
      
      // 格式：[难度] 赛事名称 - 题目名称 |分数/订正分数|
      // 先去除分数部分（|...|）
      let name = item.skip_info.replace(/\|[^|]+\|/g, '').trim()
      
      // 提取[难度]后的内容
      const match = name.match(/\[([^\]]+)\]\s*(.+)/)
      if (match && match[2]) {
        const namePart = match[2]
        // 如果有 " - " 分隔符，取后面的题目名称
        if (namePart.includes(' - ')) {
          return namePart.split(' - ')[1] || namePart
        }
        // 如果没有分隔符，说明只有题目名称
        return namePart
      }
      
      return ''
    },
    
    // 获取skip列表项的赛事名称（订正待办）
    getSkipItemGameName(item) {
      if (!item.skip_info) return ''
      
      // 格式：[难度] 赛事名称 - 题目名称 |分数/订正分数|
      // 先去除分数部分（|...|）
      let name = item.skip_info.replace(/\|[^|]+\|/g, '').trim()
      
      // 提取[难度]后的内容
      const match = name.match(/\[([^\]]+)\]\s*(.+)/)
      if (match && match[2]) {
        const namePart = match[2]
        // 如果有 " - " 分隔符，取前面的赛事名称
        if (namePart.includes(' - ')) {
          return namePart.split(' - ')[0] || ''
        }
        // 如果没有分隔符，说明没有赛事名称
        return ''
      }
      
      return ''
    },
    
    // 获取skip列表项的任务状态（计划待办）
    getSkipItemTaskStatus(item) {
      if (!item.skip_info) return null
      
      // 从skip_info中解析任务状态信息
      // 格式：计划名称 |状态,状态值|
      const match = item.skip_info.match(/\|([^|]+)\|/)
      if (match && match[1]) {
        const statusStr = match[1]
        // 解析状态字符串，例如 "未开始,0" -> { status: "未开始", statusValue: 0 }
        const statusMatch = statusStr.match(/^(.+),(\d+)$/)
        if (statusMatch) {
          return {
            status: statusMatch[1],
            statusValue: parseInt(statusMatch[2], 10)
          }
        }
      }
      
      return null
    },
    
    // 取消skip
    async handleRemoveSkip(skipItem) {
      try {
        await this.$confirm('确认取消跳过该待办吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await removeTodoSkip({
          id: skipItem.id
        })
        
        if (response.code === 200) {
          this.$message.success('取消跳过成功')
          
          // 重新获取skip列表
          this.skipListLoading = true
          try {
            const response2 = await getTodoSkipList(this.viewSkipType)
            if (response2.code === 200) {
              this.skipList = response2.data || []
            }
          } finally {
            this.skipListLoading = false
          }
          
          // 重新获取待办列表
          if (this.viewSkipType === 1) {
            this.fetchUpdateReviewTodoList()
          } else if (this.viewSkipType === 2) {
            this.fetchFixTodoList()
          } else if (this.viewSkipType === 3) {
            this.fetchTaskTodoList()
          }
        } else {
          throw new Error(response.message || '取消跳过失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消跳过失败:', error)
          this.$message.error(error.message || '取消跳过失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 0;
  
  /* 移动端固定顶部欢迎标题栏 */
  .mobile-welcome-header {
    display: none; /* 默认隐藏，仅在移动端显示 */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: #304156; /* 与App.vue中的.mobile-drawer背景色保持一致 */
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), transparent); /* 添加与抽屉菜单相同的渐变效果 */
    color: white;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 调整阴影与GameMobile.vue一致 */
    overflow: hidden;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08); /* 添加与抽屉菜单相同的底部边框 */
    
    .mobile-welcome-scroll-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0 10px;
      
      .mobile-welcome-scroll-content {
        white-space: nowrap;
        font-size: 18px;
        font-weight: 600; /* 添加与GameMobile.vue一致的字体粗细 */
        display: inline-block;
        will-change: transform;
        
        .crown-text {
          color: #f5a623;
          font-weight: bold;
          
          .crown-emoji {
            margin-right: 4px;
          }
        }
      }
    }
  }
  
  /* PC/移动端显示控制（统一使用 device.js 判断） */
  &.device-pc .pc-only { display: block; }
  &.device-pc .mobile-only { display: none; }
  &.device-mobile .pc-only { display: none; }
  &.device-mobile .mobile-only { display: block; }
  
  .welcome-card {
    margin-top: 8px;
    margin-bottom: 16px;
    border: none;
    background: linear-gradient(135deg, #fdfbff 0%, #f2f7ff 45%, #fef9f2 100%);
    box-shadow: 0 18px 45px rgba(51, 83, 145, 0.12);

    ::v-deep .el-card__body {
      padding: 18px;
    }
    
      .welcome-content {
        display: flex;
        align-items: stretch;
      min-height: 170px;
      background: rgba(255, 255, 255, 0.92);
      border-radius: 24px;
      padding: 20px 28px;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);

      .welcome-message {
        flex: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 24px;
        
        h2 {
          margin: 0;
          font-size: 36px;
          color: #303133;
          display: flex;
          align-items: center;
          gap: 8px;
          line-height: 1.3;

          .crown-username {
            display: inline-flex;
            align-items: center;
            color: #f5a623;
            animation: glow 2s ease-in-out infinite;
            line-height: 1;
            position: relative;

            .crown-emoji {
              margin-right: 8px;
              font-size: 36px;
              line-height: 1;
              position: relative;
              z-index: 1;
            }
          }

          span {
            display: inline-flex;
            align-items: center;
            line-height: 1;
          }
        }
      }

      .fortune-section {
        flex: 1;
        text-align: center;
        min-height: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 16px;

        .fortune-content {
          width: 100%;
          padding: 20px 18px 16px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 150px;
          border-radius: 18px;
          background: #f7f9ff;
          border: 1px solid #e3e9ff;
          box-shadow: 0 10px 20px rgba(95, 115, 180, 0.1);

          .fortune-level {
            font-size: 36px;
            font-weight: bold;
            margin-bottom: 0;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
            
            &.great { color: #f56c6c; }
            &.good { color: #e6a23c; }
              &.small-good { 
                color: #f7ba2a;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            &.normal { color: #909399; }
            &.small-bad { color: #67c23a; }
            &.bad { color: #409eff; }
            &.worse { color: #8e44ad; }
          }

          .fortune-details {
            margin: 12px 0;

            .fortune-row {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              background: #f8f9fb;
              padding: 10px;
              border-radius: 6px;
              min-height: 50px;
            }

            .fortune-item {
              display: flex;
              align-items: center;
              gap: 8px;
              width: 45%;
              min-width: 120px;

              &:first-child {
                .fortune-text {
                  align-items: flex-start;
                  .fortune-value {
                    text-align: left;
                  }
                  .fortune-comment {
                    text-align: left;
                  }
                }
              }

              &:last-child {
                .fortune-text {
                  align-items: flex-end;
                  .fortune-value {
                    text-align: right;
                  }
                  .fortune-comment {
                    text-align: right;
                  }
                }
              }

              .fortune-text {
                display: flex;
                flex-direction: column;
                gap: 6px;
                width: calc(100% - 40px);

                .fortune-value {
                  color: #303133;
                  font-weight: 500;
                  width: 100%;
                  line-height: 1.4;
                }

                .fortune-comment {
                  color: #909399;
                  font-size: 12px;
                  line-height: 1.4;
                  width: 100%;
                }
              }

              .fortune-label {
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                color: white;
                font-weight: bold;
                flex-shrink: 0;

                &.good {
                  background-color: #67c23a;
                }

                &.bad {
                  background-color: #f56c6c;
                }
              }
            }
          }

          .check-in-days {
          margin-top: auto;
              padding-top: 0;
            font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 4px;

            .text {
              color: #606266;
            }

            .number {
              color: #303133;
              font-weight: bold;
              margin: 0 4px;
            }
          }
        }
      }
    }
  }

  // 统一卡片基础样式
  .base-card {
    transition: all 0.3s;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    &:hover {
      transform: translateY(-5px);
    }
  }

  // 标题栏容器
  .section-headers {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-top: 48px;
    margin-bottom: 16px;
  }

  // 标题栏样式
  .section-header {
    &.links-header {
      grid-column: span 3;
    }
    
    &.daily-header {
      grid-column: span 1;
    }
    
    .section-title {
      font-size: 16px;
      color: #303133;
      margin: 0;
      padding: 6px 12px;
      border-left: 4px solid #2E365A;
      background-color: #f5f7fa;
      border-radius: 0 4px 4px 0;
      line-height: 1.3;
      display: inline-block;
    }
  }

  .nav-section {
    display: grid;
    grid-template-columns: repeat(3, 1fr); // 更新&复盘待办、订正待办、计划待办各占1/3宽度
    grid-template-rows: repeat(3, 120px); // 明确指定3行，每行120px
    gap: 16px;
    margin-bottom: 20px;
    padding: 18px 18px 8px 18px; // 底部padding调整为2px，因为gap已经包含了10px的间距，所以底部只需要8px即可达到18px的视觉效果
    border-radius: 28px;
    background: linear-gradient(135deg, #fdfbff 0%, #f2f7ff 45%, #fef9f2 100%);
    border: 1px solid rgba(226, 232, 255, 0.8);
    box-shadow: 0 18px 40px rgba(63, 89, 130, 0.08);
    
    // 不再使用grid-template-areas和grid-row-span
    // 而是使用更直接的布局
    
    align-items: start; // 确保所有卡片从顶部开始对齐
    justify-items: stretch; // 确保水平拉伸以填充网格
    overflow: visible; // 确保卡片的hover效果不会被裁剪

    // 为所有卡片设置相同的边框和阴影
    :deep(.el-card) {
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
      border: none !important;
    }
    
    // 为所有卡片内容区域设置相同的内边距
    :deep(.el-card__body) {
      padding: 12px !important;
      height: 100%;
      box-sizing: border-box;
    }
  
    // 所有卡片通用样式
    .nav-card, .great-events-card {
      @extend .base-card;
      box-sizing: border-box;
      padding: 12px;
      cursor: pointer;
      margin: 0;
    }

    // 所有卡片的统一header样式
    .nav-card .header-row, .great-events-card .header-row {
      display: flex;
      align-items: center;
      margin-bottom: 4px; // 减小间距
      height: 22px;
      
      .nav-icon {
        font-size: 18px;
        color: #2E365A;
        display: flex;
        align-items: center;
        margin-right: 8px;
        margin-bottom: 0;
        height: 18px;
        
        i {
          transition: all 0.3s;
        }
      }
      
      h3 {
        margin: 0;
        color: #303133;
        font-size: 16px;
        line-height: 18px;
        display: inline-block;
      }
    }
    
    // 标准导航卡片
    .nav-card {
      display: flex;
      flex-direction: column;
      height: 120px !important; // 固定单行卡片高度
      justify-content: space-between;
      
      &.data {
        grid-column: 1;
        grid-row: 1;
      }
      
      &.game {
        grid-column: 2;
        grid-row: 1;
      }
      
      &.question {
        grid-column: 3;
        grid-row: 1;
      }
      
      &.tag {
        grid-column: 1;
        grid-row: 2;
      }
      
      &.outline {
        grid-column: 2;
        grid-row: 2;
      }
      
      &.plan {
        grid-column: 1;
        grid-row: 3;
      }
      
      &.article {
        grid-column: 2;
        grid-row: 3;
      }
      
      &.manage {
        grid-column: 3;
        grid-row: 2 / span 2; // 跨两行
        height: 256px !important; // 两行高度
      }
      
      .nav-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center; // 内容垂直居中

        p {
          margin: 4px 0 0 0; // 减小间距
          color: #606266;
          font-size: 13px;
          line-height: 1.2;
        }
      }

      .nav-button {
        margin-top: 4px; // 减小间距
        color: #2E365A;
        font-size: 13px;
        padding: 4px 8px;
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        display: flex;
        align-items: center;

        i.el-icon-arrow-right {
          margin-left: 4px;
          font-size: 12px;
        }

        &:hover {
          color: #BD6C73;
          background-color: #f5f7fa;
          border-radius: 3px;
        }
      }
      
      .multi-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 8px;
        
        .nav-button {
          flex: 0 0 45%;
          color: #2E365A;
          font-size: 13px;
          padding: 6px 0;
          margin: 4px;
          justify-content: flex-start !important;
          text-align: left !important;
          display: flex;
          align-items: center;
          
          i {
            margin-right: 4px;
            font-size: 14px;
          }

          &:hover {
            color: #BD6C73;
            background-color: #f5f7fa;
            border-radius: 3px;
          }
        }
      }
    }
    
    // 更新&复盘待办在导航区域的样式
    .update-review-todo-in-nav {
      grid-column: 1; // 占用第一列
      grid-row: 1 / span 3; // 从第一行开始跨三行
      display: flex;
      flex-direction: column;
      height: 400px;
      min-width: 0; // 允许 Grid 项目自适应缩小，防止内容撑开
      
      .section-header.update-review-todo-title-in-nav {
        margin-bottom: 8px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .section-title {
          font-size: 16px;
          color: #303133;
          margin: 0;
          padding: 6px 12px;
          border-left: 4px solid #2E365A;
          background-color: #f5f7fa;
          border-radius: 0 4px 4px 0;
          line-height: 1.3;
          display: inline-block;
        }
        
        .update-review-todo-header-right {
          display: flex;
          align-items: center;
          gap: 2px;
        }
        
        .update-review-todo-count {
          font-size: 13px;
          color: #606266;
          font-weight: 500;
          margin-right: 0;
        }
        
        .todo-count-tag {
          width: 18px;
          height: 18px;
          padding: 0;
          border-radius: 4px;
          font-size: 11px;
          font-weight: bold;
          margin-left: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          
          &.status-ontime {
            background-color: #67c23a;
            color: #fff;
            border: 1px solid #67c23a;
          }
          
          &.status-delay {
            background-color: #f56c6c;
            color: #fff;
            border: 1px solid #f56c6c;
          }
        }
        
        .header-separator {
          font-size: 13px;
          color: #DCDFE6;
          margin: 0;
          line-height: 1;
        }
        
        .expand-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
        
        .view-skip-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
        
        .config-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
      }
      
      .update-review-todo-section-in-nav {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0; // 允许flex子元素缩小
        overflow: hidden; // 防止内容溢出
        
        .update-review-todo-card {
          @extend .base-card;
          height: 100%; // 填满剩余空间
          position: relative;
          display: flex;
          flex-direction: column;
          min-height: 0; // 允许flex子元素缩小
          border-radius: 22px;
          border: 1px solid #eef1f7;
          box-shadow: 0 12px 32px rgba(44, 62, 80, 0.12);
          
          ::v-deep .el-card__body {
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 12px;
            overflow: hidden; // 确保内容不会溢出
            min-height: 0; // 允许flex子元素缩小
          }
          
          // 空状态样式（与订正待办一致）
          .empty-state-celebration {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px 52px 20px;
            margin: 0;
            background: linear-gradient(135deg, #f0f9f0 0%, #e8f5e8 50%, #f0f9f0 100%);
            border-radius: 8px;
            min-height: 300px;
            box-sizing: border-box;
            
            .celebration-icon {
              font-size: 64px;
              margin-bottom: 16px;
              animation: bounce 2s ease-in-out infinite;
            }
            
            .celebration-title {
              font-size: 24px;
              font-weight: bold;
              color: #67c23a;
              margin-bottom: 8px;
            }
            
            .celebration-message {
              font-size: 16px;
              color: #606266;
              margin-bottom: 8px;
            }
            
            .celebration-subtitle {
              font-size: 14px;
              color: #909399;
            }
          }
          
      .update-review-todo-content {
            flex: 1;
            min-height: 0;
            overflow-y: auto;
            padding: 0;
            
            .update-review-todo-item {
                padding: 12px 14px;
                border-bottom: none;
                border-left: 4px solid transparent;
                transition: all 0.2s;
                background: rgba(244, 247, 255, 0.9);
                border-radius: 14px;
                border: 1px solid #e6ebff;
                box-shadow: 0 8px 18px rgba(92, 117, 179, 0.08);
                margin-bottom: 8px;
                
                // 正常状态样式
                &:not(.delay-item) {
                  border-left-color: #67c23a;
                }
                
                // 超时状态样式
                &.delay-item {
                  background-color: #fff4f4;
                  border-color: #ffe1e1;
                  border-left-color: #f56c6c;
                }
              
              .todo-item-content {
                display: flex;
                flex-direction: column;
                gap: 4px;
                
                // 第一行：标志(G/P) + 名称 + note标签（靠右）
                .todo-row-first {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  flex-wrap: nowrap;
                  height: 24px;
                  
                  .todo-type-badge {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 20px;
                    height: 20px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    color: #fff;
                    flex-shrink: 0;
                    
                    &.badge-game {
                      background-color: #2E365A;
                    }
                    &.badge-question {
                      background-color: #409EFF;
                    }
                  }
                  
                  .todo-name-with-icon {
                    display: flex;
                    align-items: center;
                    flex: 1;
                    min-width: 0;
                  }
                  
                  .todo-name {
                    font-size: 13px;
                    font-weight: bold;
                    color: #303133;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  
                  .todo-info-icon {
                    font-size: 14px;
                    color: #909399;
                    cursor: pointer;
                    flex-shrink: 0;
                    margin-left: 1px;
                    transition: color 0.3s;
                    
                    &:hover {
                      color: #409EFF;
                    }
                  }
                  
                  .todo-note-tags {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 6px;
                    margin-left: auto;
                    flex-shrink: 0;
                    
                    .note-tag {
                      border: 1px solid #dcdfe6;
                      background-color: #fff;
                    }
                    // 根据类型增强边框与背景
                    .el-tag--danger.note-tag {
                      border-color: #f56c6c;
                      background-color: #fef0f0;
                      color: #f56c6c;
                    }
                    .el-tag--warning.note-tag {
                      border-color: #e6a23c;
                      background-color: #fdf6ec;
                      color: #e6a23c;
                    }
                    .el-tag--info.note-tag {
                      border-color: #409eff;
                      background-color: #f0f9ff;
                      color: #409eff;
                    }
                    // 默认样式
                    .note-tag:not(.el-tag--danger):not(.el-tag--warning):not(.el-tag--info) {
                      border-color: #909399;
                      background-color: #f4f4f5;
                      color: #909399;
                    }
                  }
                }
                
                // 第二行：状态 + days_ago + 按钮（靠右）
                .todo-row-second {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  flex-wrap: nowrap;
                  height: 24px;
                  
                  .todo-status-tag {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    white-space: nowrap;
                    flex-shrink: 0;
                    height: 20px;
                    line-height: 18px;
                    box-sizing: border-box;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    
                    &.status-delay {
                      background-color: #f56c6c;
                      color: #fff;
                      border: 1px solid #f56c6c;
                    }
                    
                    &.status-ontime {
                      background-color: #67c23a;
                      color: #fff;
                      border: 1px solid #67c23a;
                    }
                  }
                  
                  .todo-days {
                    font-size: 12px;
                    color: #606266;
                    flex-shrink: 0;
                    white-space: nowrap;
                  }
                  
                  .todo-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-shrink: 0;
                    margin-left: auto;
                    
                    .action-btn {
                      padding: 0;
                      width: 24px;
                      height: 24px;
                      min-width: 24px;
                      line-height: 24px;
                      border-radius: 4px;
                      font-size: 12px;
                      margin: 0; // 避免额外外边距影响间距
                      
                      &:hover {
                        opacity: 0.8;
                      }
                      
                      // 复盘按钮：紫色样式
                      &.replay-btn {
                        background-color: #6f42c1;
                        border-color: #6f42c1;
                        color: #fff;
                        
                        &:hover {
                          background-color: #5a32a3;
                          border-color: #5a32a3;
                        }
                        
                        &:active {
                          background-color: #4c2889;
                          border-color: #4c2889;
                        }
                      }
                        
                        // 编辑按钮：深蓝色样式
                        &.edit-btn {
                          background-color: #0056b3;
                          border-color: #0056b3;
                          color: #fff;
                          
                          &:hover {
                            background-color: #004494;
                            border-color: #004494;
                          }
                          
                          &:active {
                            background-color: #003d82;
                            border-color: #003d82;
                          }
                        }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    
    // 订正待办在导航区域的样式
    .fix-todo-in-nav {
      grid-column: 2; // 占用第二列
      grid-row: 1 / span 3; // 从第一行开始跨三行
      display: flex;
      flex-direction: column;
      height: 400px;
      min-width: 0; // 允许 Grid 项目自适应缩小，防止内容撑开
      
      .section-header.fix-todo-title-in-nav {
        margin-bottom: 8px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .section-title {
          font-size: 16px;
          color: #303133;
          margin: 0;
          padding: 6px 12px;
          border-left: 4px solid #2E365A;
          background-color: #f5f7fa;
          border-radius: 0 4px 4px 0;
          line-height: 1.3;
          display: inline-block;
        }
        
        .fix-todo-header-right {
          display: flex;
          align-items: center;
          gap: 2px;
        }
        
        .fix-todo-count {
          font-size: 13px;
          color: #606266;
          font-weight: 500;
          margin-right: 0;
        }
        
        .todo-count-tag {
          width: 18px;
          height: 18px;
          padding: 0;
          border-radius: 4px;
          font-size: 11px;
          font-weight: bold;
          margin-left: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          
          &.status-ontime {
            background-color: #67c23a;
            color: #fff;
            border: 1px solid #67c23a;
          }
          
          &.status-delay {
            background-color: #f56c6c;
            color: #fff;
            border: 1px solid #f56c6c;
          }
        }
        
        .header-separator {
          font-size: 13px;
          color: #DCDFE6;
          margin: 0;
          line-height: 1;
        }
        
        .expand-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
        
        .view-skip-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
        
        .config-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
      }
      
      .fix-todo-section-in-nav {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0; // 允许flex子元素缩小
        overflow: hidden; // 防止内容溢出
        
        .fix-todo-card {
          @extend .base-card;
          height: 100%; // 填满剩余空间
          position: relative;
          display: flex;
          flex-direction: column;
          min-height: 0; // 允许flex子元素缩小
          border-radius: 22px;
          border: 1px solid #eef1f7;
          box-shadow: 0 12px 32px rgba(44, 62, 80, 0.12);
          
          ::v-deep .el-card__body {
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 12px;
            overflow: hidden; // 确保内容不会溢出
            min-height: 0; // 允许flex子元素缩小
          }
          
          // 喜庆的空状态样式（在fix-todo-card下）
          .empty-state-celebration {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px 52px 20px; // 底部padding增加，确保与卡片padding合计的底部间距一致
            margin: 0;
            background: linear-gradient(135deg, #f0f9f0 0%, #e8f5e8 50%, #f0f9f0 100%);
            border-radius: 8px;
            min-height: 300px;
            box-sizing: border-box;
            
            .celebration-icon {
              font-size: 64px;
              margin-bottom: 16px;
              animation: bounce 2s ease-in-out infinite;
            }
            
            .celebration-title {
              font-size: 24px;
              font-weight: bold;
              color: #67c23a;
              margin-bottom: 8px;
            }
            
            .celebration-message {
              font-size: 16px;
              color: #606266;
              margin-bottom: 8px;
            }
            
            .celebration-subtitle {
              font-size: 14px;
              color: #909399;
            }
          }
          
      .fix-todo-content {
            flex: 1;
            min-height: 0;
            overflow-y: auto;
            padding: 0;
            
            .fix-todo-item {
                padding: 12px 14px;
                border-bottom: none;
                border-left: 4px solid transparent;
                transition: all 0.2s;
                background: rgba(244, 247, 255, 0.9);
                border-radius: 14px;
                border: 1px solid #e6ebff;
                box-shadow: 0 8px 18px rgba(92, 117, 179, 0.08);
                margin-bottom: 8px;
                
                // 正常状态样式
                &:not(.delay-item) {
                  border-left-color: #67c23a; // 绿色表示正常
                }
                
                // 超时状态样式
                &.delay-item {
                  background-color: #fff4f4;
                  border-color: #ffe1e1;
                  border-left-color: #f56c6c; // 红色表示超时
                }
              
              .todo-item-content {
                display: flex;
                  flex-direction: column; // 两行
                  gap: 4px; // 行间距
                
                // 第一行：难度标签 + 题目名称 + 分数 + 天数 + 状态标签 + 操作按钮
                .todo-row-first {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  flex-wrap: nowrap;
                  height: 24px;
                  
                  .todo-level-tag {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1px 8px;
                    border-radius: 4px;
                    border: 1px solid;
                    font-size: 12px;
                    color: white;
                    font-weight: bold;
                    white-space: nowrap;
                    flex-shrink: 0;
                    height: 20px;
                    line-height: 18px;
                    box-sizing: border-box;
                  }
                  
                  .todo-question-name-with-icon {
                    display: flex;
                    align-items: center;
                    flex: 1 1 auto;
                    min-width: 0;
                  }
                  
                  .todo-question-name {
                    /* 动态长度：尽可能占用剩余空间，空间不足时省略号 */
                    min-width: 0;   /* 允许根据剩余空间收缩，避免过早截断 */
                    max-width: 100%;
                    font-size: 13px;
                    font-weight: bold;
                    color: #303133;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  
                  .todo-info-icon {
                    font-size: 14px;
                    color: #909399;
                    cursor: pointer;
                    flex-shrink: 0;
                    margin-left: 1px;
                    transition: color 0.3s;
                    
                    &:hover {
                      color: #409EFF;
                    }
                  }
                  
                  /* 第一行追加：错误类型 + 标签（紧凑同行显示） */
                  .todo-first-row-extras {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    /* 靠右显示，宽度根据内容自适应，尽量不挤压题目名称 */
                    flex: 0 0 auto;
                    min-width: 0;
                    overflow: visible; // 不截断
                    flex-wrap: wrap;   // 允许换行，完整显示
                    margin-left: auto; // 靠右
                    justify-content: flex-end; // 内容向右对齐
                    text-align: right;
                    
                    .todo-error-types,
                    .todo-tags {
                      display: flex;
                      align-items: center;
                      gap: 4px;
                      flex-wrap: wrap;   // 换行显示全部
                      min-width: 0;
                      overflow: visible;
                      justify-content: flex-end; // 内部也靠右排
                    }
                    
                    .todo-error-tag {
                      white-space: nowrap;
                      padding: 0 6px;
                      height: 20px;
                      line-height: 20px;
                      font-size: 11px;
                      flex-shrink: 0;
                      background-color: transparent;
                    }
                    
                    .todo-tag-item {
                      white-space: nowrap;
                      padding: 0 6px;
                      height: 20px;
                      line-height: 20px;
                      font-size: 11px;
                      border: none;
                      flex-shrink: 0;
                      color: #fff;
                    }
                  }
                  
                  .todo-score {
                    display: flex;
                    align-items: center;
                    gap: 2px;
                    font-size: 13px;
                    font-weight: 500;
                    flex-shrink: 0;
                    
                    .score-original,
                    .score-fix {
                      font-weight: bold;
                    }
                    
                    .score-separator {
                      color: #909399;
                      margin: 0 0px;
                    }
                  }
                  
                  .todo-days {
                    font-size: 12px;
                    color: #606266;
                    flex-shrink: 0;
                  }
                  
                  .todo-status-tag {
                    padding: 1px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    flex-shrink: 0;
                    height: 20px;
                    line-height: 18px;
                    box-sizing: border-box;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    
                    &.status-delay {
                      background-color: #f56c6c;
                      color: #fff;
                      border: 1px solid #f56c6c;
                    }
                    
                    &.status-ontime {
                      background-color: #67c23a;
                      color: #fff;
                      border: 1px solid #67c23a;
                    }
                  }
                  
                  .todo-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-shrink: 0;
                    
                    .action-btn {
                      padding: 0;
                      width: 24px;
                      height: 24px;
                      min-width: 24px;
                      line-height: 24px;
                      border-radius: 4px;
                      font-size: 12px;
                      margin: 0; // 避免额外外边距影响间距
                      
                      &[disabled] {
                        opacity: 0.5;
                        cursor: not-allowed;
                      }
                      
                      &:not([disabled]):hover {
                        opacity: 0.8;
                      }
                    }
                  }
                }
                
                // 第二行：错误类型 + 标签
                .todo-row-middle {
                    display: flex;
                    align-items: center;
                  gap: 8px;
                  flex-wrap: wrap; // 允许换行完整显示
                    
                    .todo-error-types {
                      display: flex;
                      align-items: center;
                      gap: 4px;
                      flex-wrap: wrap;
                      
                      .todo-error-tag {
                        white-space: nowrap;
                        padding: 0 6px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 11px;
                        flex-shrink: 0;
                        background-color: transparent;
                      }
                    }
                    
                    .todo-tags {
                      display: flex;
                      align-items: center;
                      gap: 4px;
                      flex-wrap: wrap;
                      
                      .todo-tag-item {
                        white-space: nowrap;
                        padding: 0 6px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 11px;
                        border: none;
                        flex-shrink: 0;
                      }
                    }
                  }
                
                // 第三行：状态 + 天数 + 操作按钮（靠右）
                .todo-row-second {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  height: 24px;
                  
                  .todo-status-tag {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    white-space: nowrap;
                    flex-shrink: 0;
                    height: 20px;
                    line-height: 18px;
                    box-sizing: border-box;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    
                    &.status-delay {
                      background-color: #f56c6c;
                      color: #fff;
                      border: 1px solid #f56c6c;
                    }
                    
                    &.status-ontime {
                      background-color: #67c23a;
                      color: #fff;
                      border: 1px solid #67c23a;
                    }
                  }
                  
                  .todo-days {
                    font-size: 12px;
                    color: #606266;
                  }
                  
                  .todo-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-left: auto;
                    
                    .action-btn {
                      padding: 0;
                      width: 24px;
                      height: 24px;
                      min-width: 24px;
                      line-height: 24px;
                      border-radius: 4px;
                      font-size: 12px;
                      margin: 0;
                      
                      &[disabled] {
                        opacity: 0.5;
                        cursor: not-allowed;
                      }
                      
                      &:not([disabled]):hover {
                        opacity: 0.8;
                      }
                    }
                  }
                }
              }
            }
          }
          
          .todo-content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            
            p {
              color: #909399;
              font-size: 14px;
              margin: 0;
            }
          }
        }
      }
    }
    
    // 计划待办在导航区域的样式
    .task-todo-in-nav {
      grid-column: 3; // 占用第三列
      grid-row: 1 / span 3; // 从第一行开始跨三行
      display: flex;
      flex-direction: column;
      height: 400px;
      min-width: 0; // 允许 Grid 项目自适应缩小，防止内容撑开
      
      .section-header.task-todo-title-in-nav {
        margin-bottom: 8px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .section-title {
          font-size: 16px;
          color: #303133;
          margin: 0;
          padding: 6px 12px;
          border-left: 4px solid #2E365A;
          background-color: #f5f7fa;
          border-radius: 0 4px 4px 0;
          line-height: 1.3;
          display: inline-block;
        }
        
        .task-todo-header-right {
          display: flex;
          align-items: center;
          gap: 2px;
        }
        
        .task-todo-count {
          font-size: 13px;
          color: #606266;
          font-weight: 500;
          margin-right: 0;
        }
        
        .todo-count-tag {
          width: 18px;
          height: 18px;
          padding: 0;
          border-radius: 4px;
          font-size: 11px;
          font-weight: bold;
          margin-left: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          
          &.status-ontime {
            background-color: #67c23a;
            color: #fff;
            border: 1px solid #67c23a;
          }
          
          &.status-delay {
            background-color: #f56c6c;
            color: #fff;
            border: 1px solid #f56c6c;
          }
        }
        
        .header-separator {
          font-size: 13px;
          color: #DCDFE6;
          margin: 0;
          line-height: 1;
        }
        
        .expand-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
        
        .view-skip-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
        
        .config-btn {
          padding: 4px;
          font-size: 14px;
          color: #909399;
          margin: 0;
          
          &:hover {
            color: #409EFF;
          }
        }
      }
      
      .task-todo-section-in-nav {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        
        .task-todo-card {
          @extend .base-card;
          height: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          min-height: 0;
          border-radius: 22px;
          border: 1px solid #eef1f7;
          box-shadow: 0 12px 32px rgba(44, 62, 80, 0.12);
          
          ::v-deep .el-card__body {
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 12px;
            overflow: hidden;
            min-height: 0;
          }
          
          // 喜庆的空状态样式（在task-todo-card下）
          .empty-state-celebration {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px 52px 20px; // 底部padding增加，确保与卡片padding合计的底部间距一致
            margin: 0;
            background: linear-gradient(135deg, #f0f9f0 0%, #e8f5e8 50%, #f0f9f0 100%);
            border-radius: 8px;
            min-height: 300px;
            box-sizing: border-box;
            
            .celebration-icon {
              font-size: 64px;
              margin-bottom: 16px;
              animation: bounce 2s ease-in-out infinite;
            }
            
            .celebration-title {
              font-size: 24px;
              font-weight: bold;
              color: #67c23a;
              margin-bottom: 8px;
            }
            
            .celebration-message {
              font-size: 16px;
              color: #606266;
              margin-bottom: 8px;
            }
            
            .celebration-subtitle {
              font-size: 14px;
              color: #909399;
            }
          }
          
      .task-todo-content {
            flex: 1;
            min-height: 0;
            overflow-y: auto;
            padding: 0;
            
            .task-todo-item {
                padding: 12px 14px;
                border-bottom: none;
                border-left: 4px solid transparent;
                transition: all 0.2s;
                background: rgba(244, 247, 255, 0.9);
                border-radius: 14px;
                border: 1px solid #e6ebff;
                box-shadow: 0 8px 18px rgba(92, 117, 179, 0.08);
                margin-bottom: 8px;
                
                // 未开始状态样式
                &.status-not-started-item {
                  border-left-color: #909399;
                }
                
                // 进行中状态样式
                &.status-in-progress-item {
                  border-left-color: #409EFF;
                }
                
                // 超时项额外样式
                &.delay-item {
                  background-color: #fff4f4;
                  border-color: #ffe1e1;
                  border-left-color: #f56c6c;
                }
              
              .task-item-content {
                display: flex;
                flex-direction: column;
                gap: 4px;
                
                // 第一行：状态标签 + 计划名称
                .task-row-first {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  flex-wrap: nowrap;
                  height: 24px;
                  
                  .task-status-tag {
                    padding: 1px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    flex-shrink: 0;
                    white-space: nowrap;
                    height: 20px;
                    line-height: 18px;
                    box-sizing: border-box;
                    
                    &.status-not-started {
                      background-color: #e1e3e5;
                      color: #606266;
                    }
                    
                    &.status-in-progress {
                      background-color: #409EFF;
                      color: #ffffff;
                    }
                  }
                  
                  .task-plan-name-with-icon {
                    display: flex;
                    align-items: center;
                    flex: 1;
                    min-width: 0;
                  }
                  
                  .task-plan-name {
                    font-size: 13px;
                    font-weight: bold;
                    color: #303133;
                    cursor: pointer;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    min-width: 0;
                    
                    &:hover {
                      color: #409EFF;
                      text-decoration: underline;
                    }
                  }
                  
                  .todo-info-icon {
                    font-size: 14px;
                    color: #909399;
                    cursor: pointer;
                    flex-shrink: 0;
                    margin-left: 1px;
                    transition: color 0.3s;
                    
                    &:hover {
                      color: #409EFF;
                    }
                  }
                }
                
                // 第二行：天数 + 时间状态 + 操作按钮
                .task-row-second {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  flex-wrap: nowrap;
                  height: 24px;
                  
                  .task-days {
                    font-size: 12px;
                    color: #606266;
                    flex-shrink: 0;
                    white-space: nowrap;
                    
                    .days-emphasis {
                      font-weight: 700;
                      font-size: 16px; // 提升两个字号，效果更明显
                    }
                    .days-emphasis.delay {
                      color: #f56c6c;
                    }
                    .days-emphasis.ontime {
                      color: #67c23a;
                    }
                  }
                  
                  .task-time-status {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    white-space: nowrap;
                    flex-shrink: 0;
                    height: 20px;
                    line-height: 18px;
                    box-sizing: border-box;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    
                    &.time-delay {
                      background-color: #f56c6c;
                      color: #fff;
                      border: 1px solid #f56c6c;
                    }
                    
                    &.time-ontime {
                      background-color: #67c23a;
                      color: #fff;
                      border: 1px solid #67c23a;
                    }
                    
                    &.time-unconfigured {
                      background-color: #f5f7fa;
                      color: #909399;
                      border: 1px solid #909399;
                    }
                  }
                  
                  .task-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-left: auto;
                    flex-shrink: 0;
                    
                    .task-action-btn {
                      padding: 0;
                      width: 24px;
                      height: 24px;
                      min-width: 24px;
                      border-radius: 4px;
                      font-size: 12px;
                      line-height: 24px;
                      margin: 0;
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      
                      &:hover {
                        opacity: 0.8;
                      }
                    }
                    
                    /* 参考 Plan.vue 色系 */
                    .task-edit-btn {
                      background-color: #0056b3; /* 深蓝 */
                      color: #fff;
                    }
                    .task-start-btn {
                      background-color: #20c997; /* 青绿 */
                      color: #fff;
                    }
                    .task-pause-btn {
                      background-color: #E6A23C; /* 橙色 */
                      color: #fff;
                    }
                    .task-complete-btn {
                      background-color: #67C23A; /* 绿色 */
                      color: #fff;
                    }
                    .task-terminate-btn {
                      background-color: #F56C6C; /* 红色 */
                      color: #fff;
                    }
                  }
                  
                  // 移动端“...”折叠
                  .task-actions-mobile {
                    margin-left: auto;
                    position: relative;
                    display: flex;
                    align-items: center;
                    
                    .task-action-btn {
                      padding: 0;
                      width: 24px;
                      height: 24px;
                      min-width: 24px;
                      border-radius: 4px;
                      font-size: 12px;
                      line-height: 24px;
                      margin: 0;
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                    }
                    
                    .task-actions-panel {
                      position: absolute;
                      /* 将面板显示在“...”按钮左侧，垂直居中 */
                      right: 30px;
                      top: 50%;
                      transform: translateY(-50%);
                      background: #fff;
                      border: 1px solid #ebeef5;
                      border-radius: 4px;
                      box-shadow: 0 2px 12px rgba(0,0,0,0.12);
                      padding: 6px 8px;
                      display: flex;
                      gap: 6px;
                      white-space: nowrap; /* 横向一排显示 */
                      z-index: 20;
                      
                      .task-edit-btn    { background-color: #0056b3; color:#fff; }
                      .task-start-btn   { background-color: #20c997; color:#fff; }
                      .task-pause-btn   { background-color: #E6A23C; color:#fff; }
                      .task-complete-btn{ background-color: #67C23A; color:#fff; }
                      .task-terminate-btn{ background-color: #F56C6C; color:#fff; }
                    }
                  }
                }
              }
            }
          }
          
          .todo-content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            
            p {
              color: #909399;
              font-size: 14px;
              margin: 0;
            }
          }
          
          // 喜庆的空状态样式
          .empty-state-celebration {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px;
            background: linear-gradient(135deg, #f0f9f0 0%, #e8f5e8 50%, #f0f9f0 100%);
            border-radius: 8px;
            min-height: 300px;
            
            .celebration-icon {
              font-size: 64px;
              margin-bottom: 16px;
              animation: bounce 2s ease-in-out infinite;
            }
            
            .celebration-title {
              font-size: 24px;
              font-weight: bold;
              color: #67c23a;
              margin-bottom: 8px;
            }
            
            .celebration-message {
              font-size: 16px;
              color: #606266;
              margin-bottom: 8px;
            }
            
            .celebration-subtitle {
              font-size: 14px;
              color: #909399;
            }
            }
          }
        }
      }
    }
    
  // 配置对话框样式（已移至全局样式）

  // 底部区域容器
  .bottom-container {
    margin-top: 12px;
        margin-bottom: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    grid-template-areas: 
      "links-title links-title daily-title events-title"
      "links-content links-content daily-content events-content";
    grid-template-rows: auto 414px !important; // 第一行自动高度（标题），第二行固定414px（内容区域）
    align-items: start; // 内容从顶部对齐
    padding: 18px;
    border-radius: 28px;
    background: linear-gradient(135deg, #fdfbff 0%, #f2f7ff 45%, #fef9f2 100%);
    border: 1px solid rgba(226, 232, 255, 0.8);
    box-shadow: 0 18px 40px rgba(63, 89, 130, 0.08);
    
    // 标题栏样式
    .section-header {
        .section-title {
          font-size: 16px;
          color: #303133;
          margin: 0;
          padding: 6px 12px;
          border-left: 4px solid #2E365A;
          background-color: #f5f7fa;
          border-radius: 0 4px 4px 0;
          line-height: 1.3;
          display: inline-block;
        }

      &.links-title {
        grid-area: links-title;
      }

      &.daily-title-in-bottom {
        grid-area: daily-title;
      }

      &.great-events-title {
        grid-area: events-title;
      }
    }

    // 友情链接区域
      .links-section {
        grid-area: links-content;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-auto-rows: 70px; // 固定每行高度为70px
        gap: 16px; // 固定间距
        align-content: start; // 内容靠上对齐
        height: 414px !important; // 固定高度：5行高度：5 * 70px + 4 * 16px = 350 + 64 = 414px
        min-height: 414px !important; // 确保最小高度
        max-height: 414px !important; // 确保最大高度
        overflow-y: auto; // 超过5行时支持滚动
        overflow-x: hidden; // 隐藏横向滚动条
        
        // 隐藏滚动条但保持滚动功能
        scrollbar-width: none; // Firefox
        -ms-overflow-style: none; // IE 和 Edge
        
        &::-webkit-scrollbar {
          display: none; // Chrome, Safari, Opera
        }
      
      // 移除el-card的默认边框
      :deep(.el-card) {
        border: none !important;
      }

      .link-card {
        @extend .base-card;
        height: 70px !important; // 固定高度
        min-height: 70px !important; // 确保最小高度
        max-height: 70px !important; // 确保最大高度
        border: 1px solid #eef1f7;
        border-radius: 16px;
        box-shadow: 0 10px 24px rgba(50, 65, 87, 0.08);
        margin: 0;
        align-self: start; // 卡片靠上对齐
        
        // 确保 el-card__body 高度也是 60px
        ::v-deep .el-card__body {
          height: 70px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
        }
        
        .link-content {
          height: 100%;
          width: 100%;
          text-decoration: none;
          color: inherit;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 12px;
          box-sizing: border-box;

          .link-name {
            font-size: 13px;
            font-weight: bold;
            margin: 0;
            color: #303133;
            overflow: hidden;
            white-space: pre-line;
            width: 100%;
            text-align: center;
            word-wrap: break-word;
            word-break: break-all;
            
            // 增加两行之间的间距 4px
            ::v-deep br {
              display: block;
              margin: 4px 0;
              content: "";
            }
            
            // 第一行是 icon/emoji 时的放大样式
            ::v-deep .link-name-icon {
              display: inline-block;
              font-size: 2.25em; // 字体大小放大 2.25 倍
              line-height: 1.25em;
              vertical-align: middle;
            }
          }
        }
      }
    }
    
    // 每日X订在底部区域的样式
    .daily-fix-section-in-bottom {
      grid-area: daily-content;
      display: flex;
      height: 414px !important; // 固定高度：与友情链接5行高度一致
      min-height: 414px !important; // 确保最小高度
      max-height: 414px !important; // 确保最大高度
      
      // 移除el-card的默认边框
      :deep(.el-card) {
        border: none !important;
      }
      
      .daily-fix-card-bottom {
          @extend .base-card;
        flex: 1; // 填满父容器
          display: flex;
          flex-direction: column;
        height: 100%; // 填满父容器高度
        overflow: hidden; // 防止内容撑大卡片
        border-radius: 20px;
        border: 1px solid #eef1f7;
        box-shadow: 0 10px 24px rgba(50, 65, 87, 0.08);
          
          ::v-deep .el-card__body {
            height: 100%;
          padding: 12px;
            display: flex;
            flex-direction: column;
          min-height: 0; // 允许缩小
          overflow: hidden; // 防止内容撑大
          }
          
          .question-info {
            flex: 1;
            overflow-y: auto;
            padding: 0 0 16px 0;
            
            .question-header {
              display: flex;
              align-items: center;
              height: 40px;
              margin-bottom: 0;
              background-color: #f8f9fb;
              padding: 0;
              
              .question-name {
                margin: 0;
                font-size: 15px;
                font-weight: bold;
                color: #303133;
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: 0 4px;
              }

              .score-tag {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 36px;
                height: 36px;
                border-radius: 50%;
                font-weight: bold;
                color: white;
                margin: 0 4px;
                font-size: 14px;
              }

              .difficulty-tag {
                padding: 4px 8px;
                border-radius: 4px;
                font-size: 12px;
                color: white;
                margin: 0 4px;
              }
            }
            
            .game-name {
              color: #606266;
              font-size: 13px;
              height: 36px;
              margin-bottom: 0;
              display: flex;
              align-items: center;
              border-bottom: 1px dashed #dcdfe6;

              i {
                margin-right: 8px;
                font-size: 16px;
                color: #E6A23C;
              }
              
              .game-name-link {
                color: #606266;
                text-decoration: none;
                
                &:hover {
                  color: #409EFF;
                  text-decoration: underline;
                }
              }
            }
            
            .game-time {
              color: #606266;
              font-size: 13px;
              height: 36px;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              border-bottom: 1px dashed #dcdfe6;

              i {
                margin-right: 8px;
                font-size: 16px;
                color: #409EFF;
              }
            }
            
            .error-types {
              color: #606266;
              font-size: 13px;
              min-height: 24px;
              margin: 6px 0 6px 0;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
            
            .question-tags {
              min-height: 50px;
              flex: 1;
              margin-bottom: 10px;
              overflow-y: auto;

              .el-tag {
                margin: 4px 8px 4px 0;
              }
            }
          }
          
          .question-actions {
            flex-shrink: 0;
            padding: 12px 0 0 0;
            display: flex;
            gap: 10px;
            justify-content: center;
            border-top: 1px solid #ebeef5;
            
            .el-button {
            flex: 1;
            min-width: 50px;
            max-width: 80px;
              display: flex;
              align-items: center;
            padding: 6px 8px;
            justify-content: center;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

              [class^="el-icon-"] {
              margin-right: 2px;
              font-size: 12px;
              }
            }
          }
        }

        .el-empty {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
      }
    }
    
    // 大事记区域
    .great-events-section {
      grid-area: events-content;
      display: flex;
      height: 414px !important; // 固定高度：与友情链接5行高度一致
      min-height: 414px !important; // 确保最小高度
      max-height: 414px !important; // 确保最大高度
      
      // 移除el-card的默认边框
      :deep(.el-card) {
        border: none !important;
      }
      
      .great-events-card-bottom {
        @extend .base-card;
        flex: 1; // 填满父容器
        display: flex;
        flex-direction: column;
        height: 100%; // 填满父容器高度
        overflow: hidden; // 防止内容撑大卡片
        border-radius: 20px;
        border: 1px solid #eef1f7;
        box-shadow: 0 10px 24px rgba(50, 65, 87, 0.08);
        
        ::v-deep .el-card__body {
          height: 100%;
          padding: 12px;
          display: flex;
          flex-direction: column;
          min-height: 0; // 允许缩小
          overflow: hidden; // 防止内容撑大
        }
        
        .events-container {
          flex: 1;
          overflow: hidden; // 严格隐藏超出部分，由JS控制滚动
          margin: 0;
          padding: 0;
          position: relative;
          min-height: 0; // 允许缩小
          
          .events-list {
            padding: 0;
            margin: 0;
            position: relative;
            
            .event-item {
              padding: 8px 0;
              display: flex;
              flex-direction: column;
              border-bottom: 1px dashed #ebeef5;
              
              &:first-child {
                padding-top: 0;
              }
              
              &:last-child {
                padding-bottom: 0;
              }
              
              // 克隆的元素不需要底部边框，以避免重复
              &[data-clone="true"] {
                border-bottom: 1px dashed #ebeef5;
                
                &:last-child {
                  border-bottom: none;
                }
              }
              
              .event-time {
                font-size: 12px;
                color: #909399;
                margin-bottom: 4px;
              }
              
              .event-content {
                display: flex;
                flex-direction: column;
                
                .event-person {
                  font-weight: bold;
                  color: #409EFF;
                  margin-bottom: 2px;
                  font-size: 13px;
                }
                
                .event-text {
                  font-size: 13px;
                  color: #606266;
                  line-height: 1.4;
                  word-break: break-all;
                }
              }
            }
          }
          
          .el-empty {
            margin-top: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }

  .copyright-text {
    text-align: center;
    color: #909399;
    font-size: 13px;
    margin: 16px 0 24px;
    line-height: 1.6;
  }
}

@keyframes glow {
  0% {
    text-shadow: 0 0 5px rgba(245, 166, 35, 0.5);
  }
  50% {
    text-shadow: 0 0 20px rgba(245, 166, 35, 0.8);
  }
  100% {
    text-shadow: 0 0 5px rgba(245, 166, 35, 0.5);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 使用 device.js 控制移动端样式，保留断点作为降级兜底 */
@media (max-width: 768px) {
  /* 显示移动端顶部欢迎标题栏 */
  .mobile-welcome-header {
    display: block !important;
  }
  
  /* 为固定顶部栏添加内容区域的上边距 */
  .dashboard-container {
    padding-top: 50px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  
  /* 在移动端调整欢迎卡片而不是完全隐藏 */
  .welcome-card {
    margin-top: 10px !important;
    
    .welcome-content {
      flex-direction: column !important;
      min-height: auto !important;
      padding: 10px 0 !important;
      
      .welcome-message {
        display: none !important; /* 隐藏欢迎文字，因为已经在顶部显示 */
      }
      
      .fortune-section {
        flex: none !important;
        width: 100% !important;
        min-height: auto !important;
        
        .fortune-content {
          min-height: auto !important;
          padding: 8px !important;
          
          .fortune-level {
            font-size: 24px !important;
            margin-bottom: 0 !important;
          }
          
          .fortune-details {
            margin: 8px 0 !important;
            
            .fortune-row {
              min-height: 40px !important;
              padding: 8px !important;
            }
            
            .fortune-item .fortune-text .fortune-comment {
              font-size: 11px !important;
            }
          }
          
          .check-in-days {
            padding-top: 8px !important;
            font-size: 12px !important;
          }
        }
        
        .check-in-btn {
          padding: 8px 16px !important;
          font-size: 14px !important;
        }
      }
    }
  }

  /* 隐藏PC导航卡片 */
  .nav-section {
    display: block !important;
    grid-template-columns: none !important;
    grid-auto-rows: auto !important;
    gap: 16px !important;
  }

  .nav-section .nav-card {
    display: none !important;
  }

  .nav-section .daily-fix-in-nav {
    display: none !important;
  }
  
  .nav-section .update-review-todo-in-nav,
  .nav-section .fix-todo-in-nav,
  .nav-section .task-todo-in-nav {
    display: block !important;
    height: auto !important;
  }

  /* 调整底部容器为单列，移动端显示每日X订和大事记 */
  .bottom-container {
    grid-template-columns: 1fr !important;
    grid-template-rows: auto !important; /* 覆盖PC端的固定行高，让每行根据内容自适应 */
    grid-template-areas:
      "events-title"
      "events-content"
      "daily-title"
      "daily-content"
      "links-title"
      "links-content" !important;
    gap: 16px !important;
  }

  .links-section {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 16px !important;
  }

  .links-section .link-card {
    max-height: none !important;
    height: auto !important;
  }

  /* 移动端：三个待办的空状态卡片更紧凑，图标与标题同一行 */
  .update-review-todo-in-nav .empty-state-celebration,
  .fix-todo-in-nav .empty-state-celebration,
  .task-todo-in-nav .empty-state-celebration {
    padding: 16px 12px !important;
    min-height: 120px !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-icon,
  .fix-todo-in-nav .empty-state-celebration .celebration-icon,
  .task-todo-in-nav .empty-state-celebration .celebration-icon {
    font-size: 32px !important;
    margin: 0 8px 0 0 !important;
    animation: none !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-title,
  .fix-todo-in-nav .empty-state-celebration .celebration-title,
  .task-todo-in-nav .empty-state-celebration .celebration-title {
    display: inline-block !important;
    font-size: 18px !important;
    margin: 0 0 0 0 !important;
    vertical-align: middle !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-message,
  .fix-todo-in-nav .empty-state-celebration .celebration-message,
  .task-todo-in-nav .empty-state-celebration .celebration-message {
    font-size: 13px !important;
    margin: 6px 0 2px 0 !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-subtitle,
  .fix-todo-in-nav .empty-state-celebration .celebration-subtitle,
  .task-todo-in-nav .empty-state-celebration .celebration-subtitle {
    font-size: 12px !important;
  }
  /* 第一行并排：图标 + 标题 */
  .update-review-todo-in-nav .empty-state-celebration,
  .fix-todo-in-nav .empty-state-celebration,
  .task-todo-in-nav .empty-state-celebration {
    flex-direction: column !important;
  }
  /* 将图标与标题置于同一行并居中对齐 */
  .update-review-todo-in-nav .empty-state-celebration,
  .fix-todo-in-nav .empty-state-celebration,
  .task-todo-in-nav .empty-state-celebration {
    text-align: center !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-icon,
  .fix-todo-in-nav .empty-state-celebration .celebration-icon,
  .task-todo-in-nav .empty-state-celebration .celebration-icon,
  .update-review-todo-in-nav .empty-state-celebration .celebration-title,
  .fix-todo-in-nav .empty-state-celebration .celebration-title,
  .task-todo-in-nav .empty-state-celebration .celebration-title {
    display: inline-flex !important;
    vertical-align: middle !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-icon { margin-right: 8px !important; }
  .update-review-todo-in-nav .empty-state-celebration .celebration-title::before,
  .fix-todo-in-nav .empty-state-celebration .celebration-title::before,
  .task-todo-in-nav .empty-state-celebration .celebration-title::before {
    content: '' !important;
  }
  /* 用一行容器包住图标与标题（通过 inline 布局实现） */
  .update-review-todo-in-nav .empty-state-celebration .celebration-title,
  .fix-todo-in-nav .empty-state-celebration .celebration-title,
  .task-todo-in-nav .empty-state-celebration .celebration-title {
    display: inline-flex !important;
    align-items: center !important;
  }
  .update-review-todo-in-nav .empty-state-celebration .celebration-title::before,
  .fix-todo-in-nav .empty-state-celebration .celebration-title::before,
  .task-todo-in-nav .empty-state-celebration .celebration-title::before {
    /* 在标题前挪动图标的空间（已将图标本身缩小并靠左） */
    display: none !important;
  }

  /* 每日X订调整 */
  .daily-fix-section-in-bottom {
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
    display: block !important;
    align-self: auto !important;
  }
  
  .daily-fix-section-in-bottom .daily-fix-card-bottom {
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
    flex: none !important;
  }

  /* 大事记调整 */
  .great-events-section {
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
    display: block !important;
    align-self: auto !important;
  }
  
  .great-events-section .great-events-card-bottom {
    height: 250px !important;
    max-height: 250px !important;
    min-height: 250px !important;
    flex: none !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    box-sizing: border-box !important;
    
    .el-card__body {
      height: 100% !important;
      max-height: 100% !important;
      padding: 12px !important;
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
      min-height: 0 !important;
      box-sizing: border-box !important;
    }
  }

  .great-events-section .events-container {
    flex: 1 1 0% !important; /* 使用flex填充剩余空间 */
    min-height: 0 !important; /* 允许flex缩小 */
    max-height: 100% !important; /* 确保不超过父容器 */
    overflow-y: auto !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }
  
  /* 版权卡片调整 */
  .copyright-card {
    display: none !important; /* 移动端隐藏版权卡片 */
  }

  .copyright-text {
    display: block !important; /* 移动端显示版权文本 */
  }
}

/* 基于 device.js 的移动端样式覆盖（优先生效）*/
.dashboard-container.device-mobile {
  /* 为固定顶部栏预留空间（横/竖屏一致） */
  padding-top: 50px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;

.mobile-welcome-header { display: block !important; }
.welcome-card { margin-top: 10px !important; }
.welcome-card ::v-deep .el-card__body { padding: 0 !important; }
.welcome-card .welcome-content {
  flex-direction: column !important;
  min-height: auto !important;
  padding: 12px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.welcome-card .welcome-content .welcome-message { display: none !important; }
.welcome-card .welcome-content .fortune-section {
  width: 100% !important;
  flex: none !important;
  padding-left: 0 !important;
  justify-content: center !important;
}
.welcome-card .welcome-content .fortune-section .fortune-content {
  width: 100% !important;
  max-width: 360px !important;
  margin: 0 auto !important;
  border: none !important;
  box-shadow: 0 8px 20px rgba(100, 115, 140, 0.12) !important;
  background: #fff !important;
}
.welcome-card .welcome-content .welcome-divider { display: none !important; }
  .nav-section { 
    display: block !important; 
    grid-template-columns: none !important; 
    grid-auto-rows: auto !important; 
    gap: 16px !important; 
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .nav-section .nav-card { display: none !important; }
  .nav-section .update-review-todo-in-nav,
  .nav-section .fix-todo-in-nav,
  .nav-section .task-todo-in-nav { display: block !important; height: auto !important; }
  .fix-todo-title-in-nav,
  .task-todo-title-in-nav { margin-top: 16px !important; }
  .nav-section .update-review-todo-card ::v-deep .el-card__body,
  .nav-section .fix-todo-card ::v-deep .el-card__body,
  .nav-section .task-todo-card ::v-deep .el-card__body { height: auto !important; }
  .nav-section .update-review-todo-content,
  .nav-section .fix-todo-content,
  .nav-section .task-todo-content { 
    height: auto !important; 
    max-height: 422px !important; /* 限制最大高度为5行数据 */
    overflow-y: auto !important; /* 超出后可以滚动 */
    overflow-x: hidden !important;
  }
  .bottom-container { 
    grid-template-columns: 1fr !important; 
    grid-template-rows: auto !important; /* 覆盖PC端的固定行高，让每行根据内容自适应 */
    grid-template-areas: 'events-title' 'events-content' 'daily-title' 'daily-content' 'links-title' 'links-content' !important; 
    gap: 16px !important; 
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .links-section { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 16px !important; }
  .links-section .link-card { max-height: none !important; height: auto !important; }
  .daily-fix-section-in-bottom { height: auto !important; max-height: none !important; min-height: auto !important; display: block !important; align-self: auto !important; }
  .daily-fix-section-in-bottom .daily-fix-card-bottom { height: auto !important; max-height: none !important; min-height: auto !important; flex: none !important; }
  .great-events-section { 
    height: auto !important; 
    max-height: none !important;
    min-height: auto !important; 
    display: block !important; 
    align-self: auto !important; 
  }
  .great-events-section .great-events-card-bottom { 
    height: 250px !important; 
    max-height: 250px !important; 
    min-height: 250px !important; 
    flex: none !important; 
    overflow: hidden !important; 
    display: flex !important; 
    flex-direction: column !important;
    box-sizing: border-box !important;
  }
  .great-events-section .great-events-card-bottom ::v-deep .el-card__body {
    height: 100% !important;
    max-height: 100% !important;
    padding: 12px !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    min-height: 0 !important;
    box-sizing: border-box !important;
  }
  .great-events-section .events-container { 
    flex: 1 1 0% !important; /* 使用flex填充剩余空间 */
    min-height: 0 !important; /* 允许flex缩小 */
    max-height: 100% !important; /* 确保不超过父容器 */
    overflow-y: auto !important; 
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }
  .copyright-card { display: none !important; }
  .copyright-text.pc-only { display: none !important; }
  .copyright-text.mobile-only { display: block !important; }
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* 兼容Firefox */
* {
  scrollbar-width: none !important;
}

/* 兼容IE/Edge */
* {
  -ms-overflow-style: none !important;
}

/* 隐藏滚动条 */
html, body {
  overflow: -moz-scrollbars-none !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  overflow-x: hidden !important;
}

html::-webkit-scrollbar, 
body::-webkit-scrollbar,
div::-webkit-scrollbar,
*::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
  display: none !important;
}

/* 确保内容区域也不显示滚动条 */
.dashboard-container {
  overflow-x: hidden !important;
}

/* 确保所有可能出现滚动条的元素都隐藏滚动条 */
.el-main,
.el-container,
.el-scrollbar,
.el-scrollbar__wrap,
.el-scrollbar__view,
.el-table__body-wrapper,
.el-drawer__body,
.el-dialog__body {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.el-main::-webkit-scrollbar,
.el-container::-webkit-scrollbar,
.el-scrollbar::-webkit-scrollbar,
.el-scrollbar__wrap::-webkit-scrollbar,
.el-scrollbar__view::-webkit-scrollbar,
.el-table__body-wrapper::-webkit-scrollbar,
.el-drawer__body::-webkit-scrollbar,
.el-dialog__body::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}
</style>

<!-- 全局样式：修复订正待办配置对话框层级问题 -->
<style>
/* 
  层级结构：
  - 页面内容: z-index: 1-999
  - 遮罩层: z-index: 3000
  - 配置对话框: z-index: 3001
*/

/* 确保订正待办配置对话框在遮罩层上方 - 使用多种选择器提高优先级 */
.el-dialog__wrapper .el-dialog.fix-todo-config-dialog,
body > .el-dialog__wrapper .el-dialog.fix-todo-config-dialog,
html body .el-dialog__wrapper .el-dialog.fix-todo-config-dialog,
.dashboard-container + .el-dialog__wrapper .el-dialog.fix-todo-config-dialog {
  z-index: 3001 !important;
  position: relative !important;
}

/* 确保对话框的 wrapper 在遮罩层上方 */
body > .el-dialog__wrapper:has(.fix-todo-config-dialog),
html body > .el-dialog__wrapper:has(.fix-todo-config-dialog),
.el-dialog__wrapper:has(.fix-todo-config-dialog) {
  z-index: 3001 !important;
}

/* Element UI 对话框默认动画和层级 */
.el-dialog.fix-todo-config-dialog {
  z-index: 3001 !important;
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
  border-radius: 22px !important;
}

.el-dialog.fix-todo-config-dialog .el-dialog__body {
  flex: 1 !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: calc(80vh - 120px) !important;
}

/* 全局遮罩层设置 - 由 JavaScript 动态控制，不在此处强制设置 */
/* 已移除 .v-modal 的强制 z-index 设置，避免与 watch 中的动态设置冲突 */

/* 配置对话框提示文本样式 */
.fix-todo-config-dialog .config-tip {
  font-size: 11px !important;
  color: #c0c4cc !important;
  margin-top: 4px !important;
  line-height: 1.5 !important;
}

/* 订正待办 tooltip 样式 */
.el-tooltip__popper.fix-todo-tooltip {
  max-width: 350px !important;
  padding: 12px !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
}

.fix-todo-tooltip .tooltip-row {
  margin-bottom: 8px;
  line-height: 1.6;
  word-wrap: break-word;
}

.fix-todo-tooltip .tooltip-row:last-child {
  margin-bottom: 0;
}

.fix-todo-tooltip .tooltip-label {
  color: #909399;
  font-weight: 500;
  margin-right: 6px;
  display: inline-block;
  min-width: 70px;
}

.fix-todo-tooltip .tooltip-value {
  color: #ffffff;
}

.fix-todo-tooltip .tooltip-difficulty-tag {
  font-weight: bold;
}

.fix-todo-tooltip .tooltip-tag {
  font-weight: 500;
}

.fix-todo-tooltip .tooltip-error {
  font-weight: 500;
}

/* 更新&复盘待办配置对话框样式 */
.el-dialog__wrapper .el-dialog.update-review-todo-config-dialog,
body > .el-dialog__wrapper .el-dialog.update-review-todo-config-dialog,
html body .el-dialog__wrapper .el-dialog.update-review-todo-config-dialog,
.dashboard-container + .el-dialog__wrapper .el-dialog.update-review-todo-config-dialog {
  z-index: 3001 !important;
  position: relative !important;
}

/* 确保对话框的 wrapper 在遮罩层上方 */
body > .el-dialog__wrapper:has(.update-review-todo-config-dialog),
html body > .el-dialog__wrapper:has(.update-review-todo-config-dialog),
.el-dialog__wrapper:has(.update-review-todo-config-dialog) {
  z-index: 3001 !important;
}

/* Element UI 对话框默认动画和层级 */
.el-dialog.update-review-todo-config-dialog {
  z-index: 3001 !important;
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
  border-radius: 22px !important;
}

.el-dialog.update-review-todo-config-dialog .el-dialog__body {
  flex: 1 !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: calc(80vh - 120px) !important;
}

/* 得分率阈值输入框文本居中 */
.update-review-todo-config-dialog .score-rate-threshold-input .el-input__inner {
  text-align: center !important;
}

/* 配置对话框提示文本样式 */
.update-review-todo-config-dialog .config-tip {
  font-size: 11px !important;
  color: #c0c4cc !important;
  margin-top: 4px !important;
  line-height: 1.5 !important;
}

/* 提升更新&复盘配置对话框中日期面板的层级，避免被对话框遮挡 */
.el-picker-panel.update-review-datepicker,
body > .el-picker-panel,
html body > .el-picker-panel {
  z-index: 3002 !important;
}

/* 计划待办配置对话框样式（与其他配置框一致） */
.el-dialog__wrapper .el-dialog.task-todo-config-dialog,
body > .el-dialog__wrapper .el-dialog.task-todo-config-dialog,
html body .el-dialog__wrapper .el-dialog.task-todo-config-dialog,
.dashboard-container + .el-dialog__wrapper .el-dialog.task-todo-config-dialog {
  z-index: 3001 !important;
  position: relative !important;
}

/* 确保对话框的 wrapper 在遮罩层上方 */
body > .el-dialog__wrapper:has(.task-todo-config-dialog),
html body > .el-dialog__wrapper:has(.task-todo-config-dialog),
.el-dialog__wrapper:has(.task-todo-config-dialog) {
  z-index: 3001 !important;
}

/* Element UI 对话框默认动画和层级（计划待办） */
.el-dialog.task-todo-config-dialog {
  z-index: 3001 !important;
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
  border-radius: 22px !important;
}

.el-dialog.task-todo-config-dialog .el-dialog__body {
  flex: 1 !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: calc(80vh - 120px) !important;
}

/* 配置对话框提示文本样式（计划待办） */
.task-todo-config-dialog .config-tip {
  font-size: 11px !important;
  color: #c0c4cc !important;
  margin-top: 4px !important;
  line-height: 1.5 !important;
}

/* Skip按钮样式（警告色，与其他操作按钮尺寸一致，文字居中） */
.skip-btn {
  padding: 0 !important;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  line-height: 24px !important;
  font-size: 11px !important;
  border: 1px solid #E6A23C !important;
  background-color: #FDF6EC !important;
  color: #E6A23C !important;
  font-weight: 500 !important;
  border-radius: 4px !important;
  text-align: center !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.skip-btn:hover {
  background-color: #E6A23C !important;
  color: #fff !important;
  border-color: #E6A23C !important;
}


/* Skip对话框样式 */
.skip-dialog {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  border-radius: 22px !important;
}

.skip-dialog-content {
  padding: 10px 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-item-info {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-item-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-item-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-reason-section {
  margin-top: 15px;
}

.skip-reason-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 12px;
  font-weight: 500;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-preset-reasons {
  margin-bottom: 15px;
}

.skip-preset-reasons .el-button,
.skip-preset-reasons .el-button:first-child,
.skip-preset-reasons .el-button:last-child,
.skip-preset-reasons .el-button:not(:first-child),
.skip-preset-reasons .el-button:not(:last-child) {
  margin-right: 16px !important;
  margin-bottom: 8px !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
}

.skip-custom-reason {
  margin-top: 10px;
}

/* View Skip对话框样式 - 统一最大高度和滚动 */
.el-dialog__wrapper .el-dialog.view-skip-dialog,
body > .el-dialog__wrapper .el-dialog.view-skip-dialog,
html body .el-dialog__wrapper .el-dialog.view-skip-dialog {
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
}

.view-skip-dialog {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  border-radius: 22px !important;
}

.view-skip-dialog .el-dialog__body {
  flex: 1 !important;
  min-height: 0 !important;
  overflow: hidden !important;
  padding: 20px !important;
}

.view-skip-content {
  max-height: calc(80vh - 120px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list {
  padding: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 12px;
  border-bottom: 1px solid #EBEEF5;
  transition: background-color 0.2s;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item:hover {
  background-color: #F5F7FA;
}

.skip-list-item:last-child {
  border-bottom: none;
}

.skip-list-item-header-row {
  width: 100%;
  margin-bottom: 6px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.skip-list-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
}

.skip-type-tag {
  flex-shrink: 0;
}

/* 更新&复盘待办的G/P标签样式（在skip列表中） */
.skip-list-item .todo-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  flex-shrink: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item .todo-type-badge.badge-game {
  background-color: #2E365A;
}

.skip-list-item .todo-type-badge.badge-question {
  background-color: #409EFF;
}

.skip-level-tag {
  flex-shrink: 0;
}

.skip-list-item-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  word-break: break-all;
  flex: 1;
  min-width: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item-todo-tags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex-shrink: 0;
  justify-content: flex-end;
}

.skip-todo-tag {
  margin: 0;
}

.skip-list-item-score {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 500;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item-score .score-original {
  font-weight: 500;
}

.skip-list-item-score .score-separator {
  margin: 0 2px;
  color: #909399;
}

.skip-list-item-score .score-fix {
  font-weight: 500;
}

.skip-list-item-game-name-row {
  width: 100%;
  margin-bottom: 6px;
}

.skip-list-item-game-name {
  font-size: 13px;
  color: #909399;
  padding-left: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item-game-name .game-icon {
  font-size: 14px;
  line-height: 1;
}

/* 计划待办状态标签样式（在skip列表中） */
.skip-list-item .task-status-tag {
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
  white-space: nowrap;
  height: 20px;
  line-height: 18px;
  box-sizing: border-box;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item .task-status-tag.status-not-started {
  background-color: #e1e3e5;
  color: #606266;
}

.skip-list-item .task-status-tag.status-in-progress {
  background-color: #409EFF;
  color: #ffffff;
}

.skip-list-item-bottom-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.skip-list-item-bottom-left {
  flex: 1;
  min-width: 0;
}

.skip-list-item-reason {
  font-size: 13px;
  color: #606266;
  margin-bottom: 4px;
  word-break: break-all;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item-time {
  font-size: 12px;
  color: #909399;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.skip-list-item-actions {
  flex-shrink: 0;
  margin-left: 12px;
  align-self: flex-end;
}

/* 放大查看对话框样式 - 根据内容高度动态调整位置 */
.el-dialog__wrapper .el-dialog.expand-todo-dialog,
body > .el-dialog__wrapper .el-dialog.expand-todo-dialog,
html body .el-dialog__wrapper .el-dialog.expand-todo-dialog {
  max-height: 75vh !important; /* 上10%，下15% */
  display: flex !important;
  flex-direction: column !important;
  /* 默认：内容少时，在上方显示，水平居中 */
  margin: 10vh auto auto auto !important;
  position: relative !important;
}

/* 内容超过最大高度时：居中显示 */
.el-dialog__wrapper .el-dialog.expand-todo-dialog.expand-dialog-overflow,
body > .el-dialog__wrapper .el-dialog.expand-todo-dialog.expand-dialog-overflow,
html body .el-dialog__wrapper .el-dialog.expand-todo-dialog.expand-dialog-overflow {
  margin: auto !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.el-dialog.expand-todo-dialog {
  max-height: 75vh !important; /* 上10%，下15% */
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  margin: 0 !important;
  position: relative !important;
  border-radius: 22px !important;
}

.el-dialog.expand-todo-dialog .el-dialog__body {
  flex: 1 !important;
  min-height: 0 !important;
  overflow: hidden !important;
  padding: 12px !important;
}

.expand-todo-content {
  height: 100% !important;
  max-height: calc(75vh - 120px) !important; /* 上10%，下15% */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 0 !important;
}

/* 放大对话框中的待办项样式 - 与页面保持一致 */
.expand-todo-content .update-review-todo-item,
.expand-todo-content .fix-todo-item,
.expand-todo-content .task-todo-item {
  padding: 12px 14px;
  border-bottom: none;
  border-left: 4px solid transparent;
  transition: all 0.2s;
  background: rgba(244, 247, 255, 0.9);
  border-radius: 14px;
  border: 1px solid #e6ebff;
  box-shadow: 0 8px 18px rgba(92, 117, 179, 0.08);
  margin-bottom: 8px;
}

.expand-todo-content .update-review-todo-item:not(.delay-item),
.expand-todo-content .fix-todo-item:not(.delay-item) {
  border-left-color: #67c23a;
}

.expand-todo-content .update-review-todo-item.delay-item,
.expand-todo-content .fix-todo-item.delay-item {
  background-color: #fff4f4;
  border-color: #ffe1e1;
  border-left-color: #f56c6c;
}

.expand-todo-content .task-todo-item.status-not-started-item {
  border-left-color: #909399;
}

.expand-todo-content .task-todo-item.status-in-progress-item {
  border-left-color: #409EFF;
}

.expand-todo-content .task-todo-item.delay-item {
  background-color: #fff4f4;
  border-color: #ffe1e1;
  border-left-color: #f56c6c;
}

/* 待办项内容容器 */
.expand-todo-content .todo-item-content,
.expand-todo-content .task-item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 第一行样式 */
.expand-todo-content .todo-row-first,
.expand-todo-content .task-row-first {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  height: 24px;
}

/* 类型标志（G/P） */
.expand-todo-content .todo-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  flex-shrink: 0;
}

.expand-todo-content .todo-type-badge.badge-game {
  background-color: #2E365A;
}

.expand-todo-content .todo-type-badge.badge-question {
  background-color: #409EFF;
}

/* 名称和图标容器 */
.expand-todo-content .todo-name-with-icon,
.expand-todo-content .todo-question-name-with-icon,
.expand-todo-content .task-plan-name-with-icon {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

/* 名称文本 */
.expand-todo-content .todo-name,
.expand-todo-content .todo-question-name,
.expand-todo-content .task-plan-name {
  font-size: 13px;
  font-weight: bold;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.expand-todo-content .task-plan-name {
  cursor: pointer;
}

.expand-todo-content .task-plan-name:hover {
  color: #409EFF;
  text-decoration: underline;
}

/* 信息图标 */
.expand-todo-content .todo-info-icon {
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 1px;
  transition: color 0.3s;
}

.expand-todo-content .todo-info-icon:hover {
  color: #409EFF;
}

/* Note标签容器 */
.expand-todo-content .todo-note-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
}

.expand-todo-content .todo-note-tags .note-tag {
  border: 1px solid #dcdfe6;
  background-color: #fff;
}

.expand-todo-content .todo-note-tags .el-tag--danger.note-tag {
  border-color: #f56c6c;
  background-color: #fef0f0;
  color: #f56c6c;
}

.expand-todo-content .todo-note-tags .el-tag--warning.note-tag {
  border-color: #e6a23c;
  background-color: #fdf6ec;
  color: #e6a23c;
}

.expand-todo-content .todo-note-tags .el-tag--info.note-tag {
  border-color: #409eff;
  background-color: #f0f9ff;
  color: #409eff;
}

.expand-todo-content .todo-note-tags .note-tag:not(.el-tag--danger):not(.el-tag--warning):not(.el-tag--info) {
  border-color: #909399;
  background-color: #f4f4f5;
  color: #909399;
}

/* 难度标签（订正待办） */
.expand-todo-content .todo-level-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 8px;
  border-radius: 4px;
  border: 1px solid;
  font-size: 12px;
  color: white;
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;
  height: 20px;
  line-height: 18px;
  box-sizing: border-box;
}

/* 分数显示（订正待办） */
.expand-todo-content .todo-score {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  font-weight: 500;
  flex-shrink: 0;
}

.expand-todo-content .todo-score .score-original,
.expand-todo-content .todo-score .score-fix {
  font-weight: bold;
}

.expand-todo-content .todo-score .score-separator {
  color: #909399;
  margin: 0 0px;
}

/* 第二行样式 */
.expand-todo-content .todo-row-second,
.expand-todo-content .task-row-second {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  height: 24px;
}

/* 状态标签 */
.expand-todo-content .todo-status-tag,
.expand-todo-content .task-status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;
  height: 20px;
  line-height: 18px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.expand-todo-content .todo-status-tag.status-delay,
.expand-todo-content .task-status-tag.status-delay {
  background-color: #f56c6c;
  color: #fff;
  border: 1px solid #f56c6c;
}

.expand-todo-content .todo-status-tag.status-ontime,
.expand-todo-content .task-status-tag.status-ontime {
  background-color: #67c23a;
  color: #fff;
  border: 1px solid #67c23a;
}

.expand-todo-content .task-status-tag.status-not-started {
  background-color: #e1e3e5;
  color: #606266;
}

.expand-todo-content .task-status-tag.status-in-progress {
  background-color: #409EFF;
  color: #ffffff;
}

/* 天数显示 */
.expand-todo-content .todo-days,
.expand-todo-content .task-days {
  font-size: 12px;
  color: #606266;
  flex-shrink: 0;
  white-space: nowrap;
}

.expand-todo-content .task-days .days-emphasis {
  font-weight: 700;
  font-size: 16px;
}

.expand-todo-content .task-days .days-emphasis.delay {
  color: #f56c6c;
}

.expand-todo-content .task-days .days-emphasis.ontime {
  color: #67c23a;
}

/* 时间状态（计划待办） */
.expand-todo-content .task-time-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;
  height: 20px;
  line-height: 18px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.expand-todo-content .task-time-status.time-delay {
  background-color: #f56c6c;
  color: #fff;
  border: 1px solid #f56c6c;
}

.expand-todo-content .task-time-status.time-ontime {
  background-color: #67c23a;
  color: #fff;
  border: 1px solid #67c23a;
}

.expand-todo-content .task-time-status.time-unconfigured {
  background-color: #f5f7fa;
  color: #909399;
  border: 1px solid #909399;
}

/* 操作按钮容器 */
.expand-todo-content .todo-actions,
.expand-todo-content .task-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

/* 操作按钮 */
.expand-todo-content .action-btn,
.expand-todo-content .task-action-btn {
  padding: 0;
  width: 24px;
  height: 24px;
  min-width: 24px;
  line-height: 24px;
  border-radius: 4px;
  font-size: 12px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.expand-todo-content .action-btn:hover,
.expand-todo-content .task-action-btn:hover {
  opacity: 0.8;
}

.expand-todo-content .action-btn[disabled],
.expand-todo-content .task-action-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 复盘按钮 */
.expand-todo-content .action-btn.replay-btn {
  background-color: #6f42c1;
  border-color: #6f42c1;
  color: #fff;
}

.expand-todo-content .action-btn.replay-btn:hover {
  background-color: #5a32a3;
  border-color: #5a32a3;
}

/* 编辑按钮 */
.expand-todo-content .action-btn.edit-btn,
.expand-todo-content .task-action-btn.task-edit-btn {
  background-color: #0056b3;
  border-color: #0056b3;
  color: #fff;
}

.expand-todo-content .action-btn.edit-btn:hover,
.expand-todo-content .task-action-btn.task-edit-btn:hover {
  background-color: #004494;
  border-color: #004494;
}

/* Skip按钮 */
.expand-todo-content .action-btn.skip-btn,
.expand-todo-content .task-action-btn.skip-btn {
  background-color: #E6A23C;
  border-color: #E6A23C;
  color: #fff;
}

/* 计划待办按钮样式 */
.expand-todo-content .task-action-btn.task-start-btn {
  background-color: #20c997;
  color: #fff;
}

.expand-todo-content .task-action-btn.task-pause-btn {
  background-color: #E6A23C;
  color: #fff;
}

.expand-todo-content .task-action-btn.task-complete-btn {
  background-color: #67C23A;
  color: #fff;
}

.expand-todo-content .task-action-btn.task-terminate-btn {
  background-color: #F56C6C;
  color: #fff;
}

/* 移动端操作面板 */
.expand-todo-content .task-actions-mobile {
  margin-left: auto;
  position: relative;
  display: flex;
  align-items: center;
}

.expand-todo-content .task-actions-panel {
  position: absolute;
  right: 0;
  top: 28px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 4px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 放大对话框中的空状态样式 */
.expand-todo-content .empty-state-celebration {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  margin: 0;
  background: linear-gradient(135deg, #f0f9f0 0%, #e8f5e8 50%, #f0f9f0 100%);
  border-radius: 8px;
  min-height: 200px;
  box-sizing: border-box;
}

.expand-todo-content .empty-state-celebration .celebration-icon {
  font-size: 64px;
  margin-bottom: 16px;
  animation: bounce 2s ease-in-out infinite;
}

.expand-todo-content .empty-state-celebration .celebration-title {
  font-size: 24px;
  font-weight: bold;
  color: #67c23a;
  margin-bottom: 8px;
}

.expand-todo-content .empty-state-celebration .celebration-message {
  font-size: 16px;
  color: #606266;
  margin-bottom: 8px;
}

.expand-todo-content .empty-state-celebration .celebration-subtitle {
  font-size: 14px;
  color: #909399;
}
</style> 